
export const en = {
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.patients': 'Patients',
  'nav.records': 'Medical Records',
  'nav.schedule': 'Schedule',
  'nav.scheduling': 'Scheduling',
  'nav.providerAvailability': 'Provider Availability',
  'nav.resourceScheduling': 'Resource Scheduling',
  'nav.waitlistManagement': 'Waitlist Management',
  'nav.clinical': 'Clinical',
  'nav.drugs': 'Drug Database',
  'nav.billing': 'Billing',
  'nav.featureToggles': 'Feature Toggles',
  'nav.subscription': 'Subscription',
  'nav.adt': 'ADT',
  'nav.labOrders': 'Lab Orders',
  'nav.pharmacy': 'Pharmacy',
  'nav.pharmacyInventory': 'Pharmacy Inventory',
  'nav.bedManagement': 'Bed Management',
  'nav.census': 'Census & Capacity',
  'nav.templates': 'Templates',
  'nav.imagingOrders': 'Imaging Orders',
  'nav.teamMembers': 'Team members',
  'nav.settings': 'Settings',

  // Common
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.create': 'Create',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.add': 'Add',
  'common.new': 'New',
  'common.addNew': 'Add New',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.loading': 'Loading',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.done': 'Done',
  'common.noData': 'No data available',
  'common.viewAll': 'View All',
  'common.viewDetails': 'View Details',
  'common.poweredBy': 'Powered by',
  'common.aiAssistant': 'AI Assistant',
  'common.filteredResults': 'Filtered Results',
  'common.actions': 'Actions',
  'common.update': 'Update',
  'common.minutes': 'minutes',
  'common.hour': 'hour',
  'common.hours': 'hours',
  'common.searchPatients': 'Search patients, records...',
  'common.profile': 'Profile',
  'common.logout': 'Logout',
  'common.menu': 'Menu',
  'common.user': 'User',
  'common.never': 'Never',
  'common.today': 'Today',
  'common.accessDenied': 'Access denied. You do not have permission to view this page.',
  'common.all': 'All',
  'common.view': 'View',
  'common.dismiss': 'Dismiss',
  'common.filters': 'Filters',
  'common.results': 'results',
  'common.noResults': 'No results found',
  'common.searching': 'Searching…',
  'common.refresh': 'Refresh',
  'common.clear': 'Clear',
  'common.export': 'Export',
  'common.recommendation': 'Recommendation',
  'common.source': 'Source',
  'common.references': 'References',
  'common.to': 'To',
  'common.saving': 'Saving',

  // Feature Guard
  'featureGuard.featureDisabled': 'Feature Disabled',
  'featureGuard.moduleDisabled': 'The {{moduleName}} module has been disabled by your administrator.',
  'featureGuard.featureUnavailable': 'This feature is currently unavailable. Please contact your system administrator if you need access to this module.',
  'featureGuard.returnToDashboard': 'Return to Dashboard',
  'featureGuard.accessDenied': 'Access Denied',
  'featureGuard.noPermission': "You don't have permission to access the {{moduleName}} module.",
  'featureGuard.noPermissionMessage': 'Your current role does not have the required permissions to view this page. Please contact your administrator if you believe you should have access.',

  // User Management
  'userManagement.title': 'User Management',
  'userManagement.description': 'Manage users, roles, and permissions',
  'userManagement.addUser': 'Add User',
  'userManagement.editUser': 'Edit User',
  'userManagement.createUser': 'Create User',
  'userManagement.user': 'User',
  'userManagement.firstName': 'First Name',
  'userManagement.lastName': 'Last Name',
  'userManagement.username': 'Username',
  'userManagement.email': 'Email',
  'userManagement.role': 'Role',
  'userManagement.department': 'Department',
  'userManagement.licenseNumber': 'License Number',
  'userManagement.npiNumber': 'NPI Number',
  'userManagement.phoneNumber': 'Phone Number',
  'userManagement.status': 'Status',
  'userManagement.lastLogin': 'Last Login',
  'userManagement.sendWelcomeEmail': 'Send welcome email',
  'userManagement.searchPlaceholder': 'Search users...',
  'userManagement.allRoles': 'All Roles',
  'userManagement.allStatuses': 'All Statuses',
  'userManagement.confirmDelete': 'Are you sure you want to delete this user?',
  'userManagement.suspensionReason': 'Please enter a reason for suspension:',

  'userManagement.roles.SUPER_ADMIN': 'Super Administrator',
  'userManagement.roles.ADMIN': 'Administrator',
  'userManagement.roles.DOCTOR': 'Doctor',
  'userManagement.roles.NURSE': 'Nurse',
  'userManagement.roles.NURSE_MANAGER': 'Nurse Manager',
  'userManagement.roles.PHARMACIST': 'Pharmacist',
  'userManagement.roles.LAB_TECHNICIAN': 'Lab Technician',
  'userManagement.roles.RADIOLOGIST': 'Radiologist',
  'userManagement.roles.THERAPIST': 'Therapist',
  'userManagement.roles.SOCIAL_WORKER': 'Social Worker',
  'userManagement.roles.CASE_MANAGER': 'Case Manager',
  'userManagement.roles.BILLING_SPECIALIST': 'Billing Specialist',
  'userManagement.roles.IT_SUPPORT': 'IT Support',
  'userManagement.roles.RECEPTIONIST': 'Receptionist',

  'userManagement.statuses.active': 'Active',
  'userManagement.statuses.inactive': 'Inactive',
  'userManagement.statuses.suspended': 'Suspended',
  'userManagement.manageSystemUsers': 'Manage system users, roles, and permissions',
  'userManagement.exportCSV': 'Export CSV',
  'userManagement.export': 'Export',
  'userManagement.active': 'Active',
  'userManagement.inactive': 'Inactive',
  'userManagement.suspended': 'Suspended',
  'userManagement.totalUsers': 'Total Users',
  'userManagement.searchAndFilters': 'Search & Filters',
  'userManagement.searchByNameEmailOrUsername': 'Search by name, email, or username...',
  'userManagement.allRolesFilter': 'All Roles',
  'userManagement.allStatusesFilter': 'All Statuses',
  'userManagement.sortByUsername': 'Sort by Username',
  'userManagement.sortByFirstName': 'Sort by First Name',
  'userManagement.sortByLastName': 'Sort by Last Name',
  'userManagement.sortByEmail': 'Sort by Email',
  'userManagement.sortByDateCreated': 'Sort by Date Created',
  'userManagement.sortAscending': 'Sort Ascending',
  'userManagement.sortDescending': 'Sort Descending',
  'userManagement.activate': 'Activate',
  'userManagement.deactivate': 'Deactivate',
  'userManagement.suspend': 'Suspend',
  'userManagement.deleteUser': 'Delete user',
  'userManagement.noRole': 'No role',
  'userManagement.noDepartment': 'No department',
  'userManagement.never': 'Never',
  'userManagement.actions': 'Actions',
  'userManagement.noUsersFound': 'No users found. Try adjusting your search criteria or add a new user.',
  'userManagement.cannotDeleteOwnAccount': 'You cannot delete your own account.',
  'userManagement.cannotChangeOwnStatus': 'You cannot change your own status',
  'userManagement.resetSigningPin': 'Reset signing PIN',
  'userManagement.confirmResetPin': "Reset {{name}}'s signing PIN? They'll be asked to set a new one the next time they sign a record.",
  'userManagement.resetPinSuccess': "{{name}}'s signing PIN was reset. They'll set a new one on their next sign.",
  'userManagement.cannotDeactivateOwnAccount': 'You cannot deactivate or suspend your own account.',
  'userManagement.skippingOwnAccount': 'Skipping your own account. Updating {{count}} other user(s).',
  'userManagement.cannotDeleteOwnAccountBulk': 'You cannot delete your own account. Delete {{count}} other selected user(s)?',
  'userManagement.confirmBulkDelete': 'Delete {{count}} selected users?',

  // Tenant dark-mode palette editor (System Settings → Branding)
  'darkPalette.title': 'Dark mode palette',
  'darkPalette.subtitle':
    "Doctors who pick Dark in their Accessibility settings will see your clinic's dark colours here.",
  'darkPalette.statusCustom': 'Custom',
  'darkPalette.statusDefault': 'Platform default',
  'darkPalette.previewTitle': 'Sample card',
  'darkPalette.previewBody': 'How this looks against your dark background.',
  'darkPalette.previewChip': 'Status chip',
  'darkPalette.save': 'Save dark palette',
  'darkPalette.saving': 'Saving…',
  'darkPalette.saved': 'Saved',
  'darkPalette.resetToDefault': 'Use platform default',
  'darkPalette.saveFailed': 'Could not save dark palette.',

  // Encounter — patient-context sidebar
  'encounter.history.title': 'Medical History',
  'encounter.history.titleMobile': 'Patient Medical History',
  'encounter.history.empty': 'No medical history on file',
  'encounter.history.chronicConditions': 'Chronic Conditions',
  'encounter.history.activeAllergies': 'Active Allergies',
  'encounter.history.recentSurgeries': 'Recent Surgeries',
  'encounter.history.familyHistory': 'Family History',
  'encounter.history.more': '+{{count}} more',

  // AI Assistant Bubble
  'aiAssistant.brandFallback': 'AI Assistant',
  'aiAssistant.continueAnswer': 'Continue the answer',
  'aiAssistant.welcome.greeting': "Hi — I'm MAIE. Type / for commands, or just ask me:",
  'aiAssistant.welcome.bullet.navigate':
    'Run quick clinical analyses (/analyze, /labs, /meds, /risk, /vitals, /summary)',
  'aiAssistant.welcome.bullet.search':
    'Find patients, records, and appointments',
  'aiAssistant.welcome.bullet.create':
    'Schedule visits or draft an encounter from voice',
  'aiAssistant.welcome.bullet.answer':
    'Answer questions about the system or the patient in context',
  'aiAssistant.welcome.examples':
    'Try: "/labs" on a patient · "/risk" for risk assessment · "Find patient John Doe" · "Navigate to schedule"',
  'aiAssistant.thinking': 'AI is thinking',
  'aiAssistant.takingLonger': 'This is taking longer than usual…',
  'aiAssistant.voiceUnavailableAiOff': 'AI voice assistant is turned off. You can still work manually.',
  'aiAssistant.placeholder.recording': '🎤 Recording…',
  'aiAssistant.placeholder.transcribing': '⏳ Transcribing…',
  'aiAssistant.placeholder.idle': 'Ask anything, or type / for commands',
  'aiAssistant.send.sendMessage': 'Send message',
  'aiAssistant.send.completePendingFirst':
    'Please complete the pending selection first',
  'aiAssistant.send.waitForResponse':
    'Wait for the current response to finish',
  'aiAssistant.listening.pushToActivate': 'Listening ({{key}})',
  'aiAssistant.listening.wakeWord': 'Listening for "Hey {{brand}}"',

  // Coming-soon overlay + badges
  'comingSoon.badge': 'Coming soon',
  'comingSoon.defaultTitle': 'Coming soon',
  'comingSoon.defaultDescription':
    "We're putting the final polish on this. It will light up automatically — no action needed.",

  // Subscription page (OWNER) — partial; non-CTA copy still in JSX
  'subscription.plansComingSoon.title': 'Plans & pricing — coming soon',
  'subscription.plansComingSoon.body':
    "You're on the 30-day free trial — the full product, including AI scribe and the assistant. No credit card required. When it ends your clinic stays on the free plan: your manual EMR keeps working and the AI features pause until you subscribe.",

  // Feedback widget
  'feedback.title': 'Report a problem or share feedback',
  'feedback.subtitle':
    "We capture the page you're on and recent in-app logs to help reproduce the issue.",
  'feedback.message.label': "What's wrong, or what would help?",
  'feedback.message.placeholder':
    "Describe the issue, steps to reproduce, or the change you'd like to see…",
  'feedback.email.label': 'Email',
  'feedback.email.optional': '(optional)',
  'feedback.email.placeholder': 'you@clinic.example',
  'feedback.send': 'Send',
  'feedback.errors.send': 'Could not send feedback',
  'feedback.success.title': 'Thanks — we got it.',
  'feedback.success.body':
    "Your report is in our triage queue. If you left an email we'll follow up when we have an update.",
  'feedback.success.done': 'Done',

  // Connected accounts card (Settings → Security)
  'connectedAccounts.eyebrow': 'Account',
  'connectedAccounts.title': 'Connected accounts',
  'connectedAccounts.subtitle':
    'Sign in to your one MAIE account using any provider you connect. Your email is the same across all of them.',
  'connectedAccounts.providers.password': 'Email & password',
  'connectedAccounts.providers.sso': 'Single sign-on',
  'connectedAccounts.password.set':
    'Set — you can sign in with your password.',
  'connectedAccounts.password.unset': 'No password set on this account.',
  'connectedAccounts.status.active': 'Active',
  'connectedAccounts.status.connected': 'Connected',
  'connectedAccounts.connect': 'Connect',
  'connectedAccounts.disconnect': 'Disconnect',
  'connectedAccounts.notConnected': 'Not connected yet.',
  'connectedAccounts.lastUsed': 'last used {{date}}',
  'connectedAccounts.empty':
    'No third-party providers are configured on this deployment yet.',
  'connectedAccounts.disconnectBlockedTooltip':
    'Set a password before disconnecting your only sign-in method',
  'connectedAccounts.toast.connected': '{{provider}} connected.',
  'connectedAccounts.toast.disconnected': 'Disconnected.',
  'connectedAccounts.errors.emailMismatch':
    'The provider account email did not match your MAIE account email. Use the matching account or change your MAIE email first.',
  'connectedAccounts.errors.ownedByOther':
    'That provider account is already linked to a different MAIE user.',
  'connectedAccounts.errors.emailUnverified':
    'Verify your email with the provider before linking.',
  'connectedAccounts.errors.notConfigured':
    'This provider is not configured yet. Try again later.',
  'connectedAccounts.errors.linkFailed':
    'Could not link the account. Try again.',
  'connectedAccounts.errors.lastLoginMethod':
    'This is your only way to sign in. Set a password before unlinking.',
  'connectedAccounts.errors.disconnectFailed': 'Could not disconnect',
  'connectedAccounts.errors.startLinkFailed': 'Could not start linking',

  // Accessibility quick panel (Header trigger → side sheet)
  'accessibilityQuick.title': 'Accessibility & appearance',
  'accessibilityQuick.subtitle':
    'Quick controls — saved to your account and synced across devices.',
  'accessibilityQuick.language': 'Language',
  'accessibilityQuick.openFull': 'Open full accessibility settings',

  // Accessibility Card (per-user a11y prefs — synced across devices)
  'accessibility.eyebrow': 'Accessibility',
  'accessibility.title': 'Accessibility',
  'accessibility.subtitle':
    'Settings sync across every device you sign in on.',
  'accessibility.reset': 'Reset',
  'accessibility.textScale.label': 'Text size',
  'accessibility.colorScheme.label': 'Appearance',
  'accessibility.colorScheme.description':
    'Choose light or dark, or follow your device.',
  'accessibility.colorScheme.system': 'System',
  'accessibility.colorScheme.light': 'Light',
  'accessibility.colorScheme.dark': 'Dark',
  'accessibility.direction.label': 'Layout direction',
  'accessibility.direction.description':
    'Override how the layout flows. Auto follows your selected language.',
  'accessibility.direction.auto': 'Auto',
  'accessibility.direction.autoSub': 'Follow language',
  'accessibility.contrast.label': 'High contrast',
  'accessibility.contrast.description':
    'Sharper text, borders, and chips for clinic glare.',
  'accessibility.reduceMotion.label': 'Reduce motion',
  'accessibility.reduceMotion.description':
    'Trim animations and transitions across the app.',

  // Settings Page
  'settings.title': 'Settings',
  'settings.subtitle': 'Your account, security and how the app looks for you',
  'settings.tabs.profile': 'Profile',
  'settings.tabs.security': 'Security',
  'settings.tabs.accessibility': 'Accessibility',
  'settings.tabs.voice': 'Voice',
  'settings.tabs.privacy': 'Privacy & data',
  'settings.themeAnalysis': 'Theme Analysis',
  'settings.themeCustomization': 'Theme Customization',
  'settings.theme': 'Theme',
  'settings.hospitalBranding': 'Hospital Branding',
  'settings.branding': 'Branding',
  'settings.voiceSettings': 'Voice Settings',
  'settings.voice': 'Voice',
  'settings.themePresets': 'Theme Presets',
  'settings.brandingTabIdentity': 'Identity',
  'settings.brandingTabTheme': 'Theme',
  'settings.brandingTabLogin': 'Login',
  'settings.brandingTabDocuments': 'Documents',
  'settings.lightTheme': 'Light theme',
  'settings.lightThemeHelper':
    'What doctors see when their accessibility colour-scheme resolves to light.',
  'settings.darkTheme': 'Dark theme',
  'settings.darkThemeNoneAvailable':
    'No dark presets shipped yet. The platform default applies until one is added.',
  'settings.customColors': 'Custom Colors',
  'settings.primaryColor': 'Primary Color',
  'settings.secondaryColor': 'Secondary Color',
  'settings.accentColor': 'Accent Color',
  'settings.backgroundColor': 'Background Color',
  'settings.textColor': 'Text Color',
  'settings.buttonTextColor': 'Button Text Color',
  'settings.statusActionColors': 'Status & Action Colors',
  'settings.successColor': 'Success Color',
  'settings.warningColor': 'Warning Color',
  'settings.errorColor': 'Error Color',
  'settings.infoColor': 'Info Color',
  'settings.aiAssistantNote': 'Note: The AI Assistant button uses the Accent Color',
  // Per-field "what does this control" helper copy for the custom palette editors.
  'settings.colorHelp.primary': 'Main buttons, links, and active controls.',
  'settings.colorHelp.secondary': 'Secondary surfaces and muted accents.',
  'settings.colorHelp.accent': 'Highlights and the AI Assistant button.',
  'settings.colorHelp.background': 'The app background behind content.',
  'settings.colorHelp.text': 'Default body text colour.',
  'settings.colorHelp.buttonText': 'Text on primary-coloured buttons.',
  'settings.colorHelp.success': 'Confirmations and success states.',
  'settings.colorHelp.warning': 'Warnings and cautions.',
  'settings.colorHelp.error': 'Errors and destructive actions.',
  'settings.colorHelp.info': 'Informational highlights.',
  'settings.lightCustomColorsHeading': 'Light theme — Custom Colors',
  'settings.hospitalInformation': 'Hospital Information',
  'settings.hospitalName': 'Hospital Name',
  'settings.tagline': 'Tagline',
  'settings.aiProviderName': 'AI Provider Name',
  'settings.logoAndFavicon': 'Logo & Favicon',
  'settings.hospitalLogo': 'Hospital Logo',
  'settings.favicon': 'Favicon',
  'settings.clickToUploadLogo': 'Click to upload logo',
  'settings.logoFormat': 'PNG, JPG or SVG (max. 2MB)',
  'settings.clickToUploadFavicon': 'Click to upload favicon',
  'settings.faviconFormat': 'PNG, ICO or SVG (16x16 or 32x32)',
  'settings.logoNote': 'Logo will appear in the header and favicon in browser tabs',
  'settings.enterHospitalName': 'Enter hospital name',
  'settings.enterTagline': 'Enter tagline',
  'settings.aiProviderPlaceholder': 'AI provider name',
  'settings.poweredBy': 'Powered by',
  'settings.wakeWordDetection': 'Wake Word Detection',
  'settings.active': 'Active',
  'settings.enableWakeWord': 'Enable Wake Word',
  'settings.handsFree': 'Hands-free',
  'settings.wakeWordDescription': 'Activate AI Assistant by saying "Hey {{aiProvider}}"',
  'settings.listeningMode': 'Listening Mode',
  'settings.alwaysListening': 'Always Listening',
  'settings.recommended': 'Recommended',
  'settings.alwaysListeningDescription': 'Always ready - best for hands-free workflow during patient encounters',
  'settings.alwaysListeningWarning': '⚠️ Uses more battery - microphone stays active',
  'settings.pushToActivate': 'Push to Activate',
  'settings.batterySaver': 'Battery Saver',
  'settings.pushToActivateDescription': 'Press {{key}} to listen for 10 seconds - saves battery',
  'settings.voiceTranscription': 'Voice Transcription',
  'settings.localTranscription': 'Local Transcription',
  'settings.fast': 'Fast',
  'settings.localTranscriptionDescription': 'Process voice on your device for instant results (~1 second)',
  'settings.localTranscriptionWarning': '⚠️ Downloads voice recognition files on first use (works offline after)',
  'settings.serverModeNote': 'Audio will be sent to server for higher quality transcription (takes a few seconds)',
  'settings.autoSendMessages': 'Auto-Send Messages',
  'settings.convenience': 'Convenience',
  'settings.autoSendDescription': 'Automatically send messages after voice transcription completes (recommended for wake word)',
  'settings.transcriptionLanguage': 'Transcription Language',
  'settings.transcriptionLanguageDescription': 'Language the scribe transcribes consultations in. English is most accurate; auto-detect can mishear and is less reliable.',
  'settings.langEnglish': 'English',
  'settings.langArabic': 'Arabic',
  'settings.langAuto': 'Auto-detect (less accurate)',
  'settings.textToSpeech': 'Text-to-Speech (TTS)',
  'settings.enabled': 'Enabled',
  'settings.enableTTS': 'Enable TTS',
  'settings.voiceAssistant': 'Voice Assistant',
  'settings.enableTTSDescription': 'Enable AI voice responses from floating button',
  'settings.voiceSelection': 'Voice Selection',
  'settings.femaleVoices': 'Female Voices',
  'settings.maleVoices': 'Male Voices',
  'settings.neutralVoices': 'Neutral Voices',
  'settings.voice_p225': 'Female - Warm & Professional',
  'settings.voice_p228': 'Female - Bright & Clear',
  'settings.voice_p229': 'Female - Calm & Gentle',
  'settings.voice_p230': 'Female - Natural & Confident',
  'settings.voice_p231': 'Female - Soft & Friendly',
  'settings.voice_p232': 'Male - Deep & Authoritative',
  'settings.voice_p237': 'Male - Smooth & Relaxed',
  'settings.voice_p241': 'Male - Energetic & Clear',
  'settings.voice_p243': 'Male - Warm & Steady',
  'settings.voice_p245': 'Male - Professional & Calm',
  'settings.voice_p226': 'Neutral - Balanced & Clear',
  'settings.voice_p227': 'Neutral - Soft & Even',
  'settings.voice_p233': 'Neutral - Bright & Steady',
  'settings.voice_p236': 'Neutral - Warm & Smooth',
  'settings.voice_p240': 'Neutral - Natural & Versatile',
  'settings.voiceSelectionNote': 'Selected voice will be used for AI responses',
  'settings.speechSpeed': 'Speech speed',
  'settings.speechSpeedNote': 'How fast MAIE reads responses aloud',
  'settings.speed_slow': 'Slow',
  'settings.speed_relaxed': 'Relaxed (recommended)',
  'settings.speed_normal': 'Normal',
  'settings.speed_fast': 'Fast',
  'settings.ttsNote': 'TTS is only active when using the floating voice assistant button',
  'settings.howItWorks': 'How it Works',
  'settings.step1AlwaysListening': 'Say "Hey {{aiProvider}}" to activate (you\'ll hear a beep)',
  'settings.step2AlwaysListening': 'Speak your command naturally',
  'settings.step3AlwaysListening': 'Wait 2 seconds after finishing (you\'ll hear another beep)',
  'settings.step4AlwaysListening': 'Your transcript appears in the chat automatically',
  'settings.step1PushToActivate': 'Press {{key}} to start listening (10 seconds)',
  'settings.step2PushToActivate': 'Say "Hey {{aiProvider}}" when you hear the beep',
  'settings.step3PushToActivate': 'Speak your command naturally',
  'settings.step4PushToActivate': 'Wait 2 seconds after finishing - your transcript appears automatically',
  'settings.livePreview': 'Live Preview',
  'settings.buttonStyles': 'Button Styles',
  'settings.primaryButton': 'Primary Button',
  'settings.secondaryButton': 'Secondary Button',
  'settings.accentButton': 'Accent Button',
  'settings.sampleCard': 'Sample Card',
  'settings.success': 'Success',
  'settings.warning': 'Warning',
  'settings.error': 'Error',
  'settings.resetChanges': 'Reset Changes',
  'settings.saveSettings': 'Save Settings',
  'settings.themeSaved': 'Theme settings saved successfully!',
  'settings.themeSaveFailed': 'Failed to save theme settings. Please try again.',
  'settings.serverMode': 'Server Mode:',
  'settings.note': 'Note:',

  // AI Command Palette
  'commandPalette.placeholder': 'Ask AI or search for commands...',
  'commandPalette.recording': '🎤 Recording...',
  'commandPalette.transcribing': '⏳ Transcribing...',
  'commandPalette.aiUnderstood': 'AI UNDERSTOOD',
  'commandPalette.pressEnter': 'Press Enter or click to execute',
  'commandPalette.aiUnderstanding': 'AI is understanding your command...',
  'commandPalette.noResults': 'No results found. Try a different search.',
  'commandPalette.searchResults': 'SEARCH RESULTS',
  'commandPalette.commands': 'COMMANDS',
  'commandPalette.navigate': '↑↓ Navigate',
  'commandPalette.select': 'Enter Select',
  'commandPalette.close': 'Esc Close',
  'commandPalette.openShortcut': 'Ctrl+K to open',
  'commandPalette.voiceTooltipStart': 'Click to start voice input (Whisper AI)',
  'commandPalette.voiceTooltipStop': 'Click to stop recording',
  'commandPalette.voiceTooltipTranscribing': 'Transcribing audio...',
  'commandPalette.micAccessDenied': 'Microphone access denied. Please allow microphone permissions in your browser settings.',
  'commandPalette.micNotFound': 'No microphone found. Please connect a microphone and try again.',
  'commandPalette.voiceServiceNotConnected': 'Voice transcription service not connected. Please try again.',
  'commandPalette.transcriptionError': 'Transcription error: {{error}}',
  'commandPalette.voiceRecordingFailed': 'Failed to start voice recording: {{error}}',
  'commandPalette.analysisComingSoon': 'Analysis feature coming soon! Context: {{context}}, Patient: {{patient}}',

  // AI Command Palette - Commands
  'commandPalette.scheduleAppointmentFor': 'Schedule Appointment for {{patientName}}',
  'commandPalette.bookAppointment': 'Book a new appointment for this patient',
  'commandPalette.orderLabTestsFor': 'Order Lab Tests for {{patientName}}',
  'commandPalette.createLabOrder': 'Create new lab order for this patient',
  'commandPalette.prescribeMedicationFor': 'Prescribe Medication for {{patientName}}',
  'commandPalette.createPrescription': 'Create new prescription',
  'commandPalette.interpretLabResults': 'Interpret These Lab Results',
  'commandPalette.aiAnalysisLabOrder': 'AI analysis of current lab order',
  'commandPalette.analyzeMedicalRecord': 'Analyze This Medical Record',
  'commandPalette.aiClinicalAssessment': 'AI clinical assessment of this visit',
  'commandPalette.summarizePatientHistory': "Summarize {{patientName}}'s History",
  'commandPalette.comprehensivePatientSummary': 'Generate a comprehensive summary of this patient',
  'commandPalette.reviewMedications': "Review {{patientName}}'s Medications",
  'commandPalette.checkInteractions': 'Check for interactions and optimization opportunities',
  'commandPalette.analyzeRiskFactors': "Analyze {{patientName}}'s Risk Factors",
  'commandPalette.riskAssessment': 'AI assessment of clinical risk factors',
  'commandPalette.analyzeRecentLabs': 'Analyze Recent Lab Results',
  'commandPalette.aiLabAnalysis': 'AI analysis of recent laboratory findings',
  'commandPalette.generateClinicalNote': 'Generate Clinical Note',
  'commandPalette.startVisitRecording': 'Start recording a clinical visit',
  'commandPalette.generateDischargeSummary': 'Generate Discharge Summary',
  'commandPalette.createDischargeDoc': 'Create discharge documentation',
  'commandPalette.generateReferralLetter': 'Generate Referral Letter',
  'commandPalette.createReferral': 'Create a referral to another specialist',
  'commandPalette.addNewPatient': 'Add New Patient',
  'commandPalette.registerNewPatient': 'Register a new patient in the system',
  'commandPalette.scheduleAppointment': 'Schedule Appointment',
  'commandPalette.bookNewAppointment': 'Book a new appointment',
  'commandPalette.goToDashboard': 'Go to Dashboard',
  'commandPalette.navigateToDashboard': 'Navigate to main dashboard',

  // Role Management
  'roleManagement.title': 'Role Management',
  'roleManagement.description': 'Manage roles and permissions',
  'roleManagement.addRole': 'Add Role',
  'roleManagement.editRole': 'Edit Role',
  'roleManagement.createRole': 'Create Role',
  'roleManagement.roleName': 'Role Name',
  'roleManagement.displayName': 'Display Name',
  'roleManagement.roleDescription': 'Description',
  'roleManagement.displayNameEn': 'Display Name (English)',
  'roleManagement.displayNameAr': 'Display Name (Arabic)',
  'roleManagement.descriptionEn': 'Description (English)',
  'roleManagement.descriptionAr': 'Description (Arabic)',
  'roleManagement.permissions': 'Permissions',
  'roleManagement.permissionsSelected': 'selected',
  'roleManagement.assignedUsers': 'Assigned Users',
  'roleManagement.system': 'System',
  'roleManagement.systemRole': 'System Role',
  'roleManagement.status': 'Status',
  'roleManagement.confirmDelete': 'Are you sure you want to delete this role?',
  'roleManagement.noRoles': 'No roles found',

  'roleManagement.permissionGroups.user': 'User Management',
  'roleManagement.permissionGroups.patient': 'Patient Management',
  'roleManagement.permissionGroups.record': 'Medical Records',
  'roleManagement.permissionGroups.appointment': 'Appointments',
  'roleManagement.permissionGroups.lab': 'Laboratory',
  'roleManagement.permissionGroups.orders': 'Orders',
  'roleManagement.permissionGroups.adt': 'ADT (Admission, Discharge, Transfer)',
  'roleManagement.permissionGroups.template': 'Templates',
  'roleManagement.permissionGroups.system': 'System Administration',

  'roleManagement.permissions.USER_READ': 'View Users',
  'roleManagement.permissions.USER_WRITE': 'Create/Edit Users',
  'roleManagement.permissions.USER_DELETE': 'Delete Users',
  'roleManagement.permissions.PATIENT_READ': 'View Patients',
  'roleManagement.permissions.PATIENT_WRITE': 'Create/Edit Patients',
  'roleManagement.permissions.PATIENT_DELETE': 'Delete Patients',
  'roleManagement.permissions.RECORD_READ': 'View Medical Records',
  'roleManagement.permissions.RECORD_WRITE': 'Create/Edit Medical Records',
  'roleManagement.permissions.RECORD_DELETE': 'Delete Medical Records',
  'roleManagement.permissions.APPOINTMENT_READ': 'View Appointments',
  'roleManagement.permissions.APPOINTMENT_WRITE': 'Create/Edit Appointments',
  'roleManagement.permissions.APPOINTMENT_DELETE': 'Delete Appointments',
  'roleManagement.permissions.LAB_ORDER_READ': 'View Lab Orders',
  'roleManagement.permissions.LAB_ORDER_WRITE': 'Create/Edit Lab Orders',
  'roleManagement.permissions.LAB_ORDER_DELETE': 'Delete Lab Orders',
  'roleManagement.permissions.LAB_RESULT_READ': 'View Lab Results',
  'roleManagement.permissions.LAB_RESULT_WRITE': 'Create/Edit Lab Results',
  'roleManagement.permissions.ORDER_READ': 'View Orders',
  'roleManagement.permissions.ORDER_WRITE': 'Create/Edit Orders',
  'roleManagement.permissions.ORDER_DELETE': 'Delete Orders',
  'roleManagement.permissions.ORDER_APPROVE': 'Approve Orders',
  'roleManagement.permissions.ADT_READ': 'View ADT',
  'roleManagement.permissions.ADT_WRITE': 'Create/Edit ADT',
  'roleManagement.permissions.ADT_DELETE': 'Delete ADT',
  'roleManagement.permissions.TEMPLATE_READ': 'View Templates',
  'roleManagement.permissions.TEMPLATE_WRITE': 'Create/Edit Templates',
  'roleManagement.permissions.TEMPLATE_DELETE': 'Delete Templates',
  'roleManagement.permissions.SYSTEM_CONFIG': 'System Configuration',
  'roleManagement.permissions.BACKUP_RESTORE': 'Backup & Restore',
  'roleManagement.permissions.AUDIT_LOG_READ': 'View Audit Logs',

  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.administration': 'Administration',

  // Authentication
  'auth.welcomeBack': 'Welcome Back',
  'auth.signIn': 'Sign In',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.usernamePlaceholder': 'Enter your username',
  'auth.passwordPlaceholder': 'Enter your password',
  'auth.rememberMe': 'Remember me',
  'auth.signingIn': 'Signing in...',
  'auth.demoAccounts': 'Demo Accounts',
  'auth.useAnyPassword': 'Use any password',
  'auth.twoFactorCode': 'Security Code',
  'auth.twoFactorPlaceholder': 'Enter 6-digit code',
  'auth.useSecurityCode': 'Use Security Code',
  'auth.hideSecurityCode': 'Hide Security Code',
  'auth.secureLogin': 'Secure Login System',

  // Auth — login page (redesign)
  'auth.login.eyebrow': 'Ambient clinical scribe · Arabic-native',
  'auth.login.signInTo': 'Sign in to your clinic',
  'auth.login.heroSubtitle':
    'MAIE turns every visit into structured clinical notes — in Arabic and English. HIPAA and GDPR compliant.',
  'auth.login.compliant': 'Compliant',
  'auth.login.proof1Title': 'Ambient scribe',
  'auth.login.proof1Body':
    'Your voice becomes the note — no typing during the visit.',
  'auth.login.proof2Title': 'Arabic-first',
  'auth.login.proof2Body': 'Native dialect handling. English on demand.',
  'auth.login.proof3Title': 'Your tenant, your data',
  'auth.login.proof3Body':
    "Patient records stay in your clinic's tenant — never ours.",
  'auth.login.soc2': 'SOC 2 Ready',
  'auth.login.title': 'Sign in to MAIE',
  'auth.login.subtitle': 'Use your organization account or password to continue.',
  'auth.login.formEyebrow': 'Sign in',
  'auth.login.emailLabel': 'Email',
  'auth.login.emailPlaceholder': 'you@example.com',
  'auth.login.passwordLabel': 'Password',
  'auth.login.passwordPlaceholder': 'Your password',
  'auth.login.forgotPassword': 'Forgot password?',
  'auth.login.signInButton': 'Sign in',

  // Password reset (public flow)
  'auth.reset.forgotTitle': 'Reset your password',
  'auth.reset.forgotSubtitle':
    "Enter your email and we'll send you a link to set a new password.",
  'auth.reset.sendLink': 'Send reset link',
  'auth.reset.checkEmailTitle': 'Check your email',
  'auth.reset.checkEmailBody':
    'If an account exists for that email, a password reset link is on its way. The link expires in 1 hour.',
  'auth.reset.backToLogin': 'Back to sign in',
  'auth.reset.genericError': "Something went wrong. Please try again.",
  'auth.reset.invalidTitle': 'Link expired or invalid',
  'auth.reset.invalidBody':
    'This password reset link is no longer valid. Request a new one to continue.',
  'auth.reset.requestNewLink': 'Request a new link',
  'auth.reset.setNewTitle': 'Set a new password',
  'auth.reset.newPasswordLabel': 'New password',
  'auth.reset.newPasswordPlaceholder': 'At least 8 characters',
  'auth.reset.confirmLabel': 'Confirm new password',
  'auth.reset.minLength': 'Password must be at least 8 characters.',
  'auth.reset.noMatch': "Passwords don't match.",
  'auth.reset.setPasswordButton': 'Set password',
  'auth.reset.successToast': 'Password updated — sign in with your new password.',
  'auth.reset.mustChangeTitle': 'Set a new password to continue',
  'auth.reset.mustChangeBody':
    'Your administrator issued a temporary password. Choose a new one to finish signing in.',
  'auth.reset.currentTempLabel': 'Temporary password',
  'auth.reset.currentTempPlaceholder': 'The temporary password you were given',
  'auth.reset.tempWrong': "That temporary password isn't right. Check it and try again.",
  'auth.reset.mustDiffer': 'Your new password must be different from the temporary one.',
  'auth.login.continueWith': 'Continue with {{provider}}',
  'auth.login.orWithPassword': 'or with password',
  'auth.login.newToMaie': 'New to MAIE?',
  'auth.login.createAccount': 'Create your account',
  'auth.login.createAccountHint':
    "Set up your clinic's workspace in a minute — invite colleagues and start charting.",
  'auth.login.needHelp': 'Need help?',
  'auth.login.tfaPrompt': 'Enter the code from your authenticator app',
  'auth.login.tfaVerify': 'Verify',
  'auth.login.back': 'Back',
  'auth.login.pickerPrompt': 'Choose your organization to continue',
  'auth.login.langToggle': 'العربية',
  'auth.login.showPassword': 'Show password',
  'auth.login.hidePassword': 'Hide password',
  'auth.login.closeModal': 'Close',
  'auth.login.ssoNotConfigured':
    '{{provider}} sign-in is coming soon. Use your password for now.',
  'auth.login.ssoNotConfiguredGeneric':
    "Single sign-on isn't configured yet. Use your password for now.",
  'auth.login.ssoStartFailed': 'SSO start failed',
  'auth.login.loginFailed': 'Login failed',
  'auth.login.passwordVerifyFailed': 'Password verification failed',
  'auth.login.tenantPickFailed': 'Tenant pick failed',
  'auth.login.footerTag': 'Patient data never leaves your organization',
  'auth.login.termsLink': 'Terms of Service',
  'auth.login.privacyLink': 'Privacy Policy',
  'auth.login.legalSeparator': '·',

  'auth.register.title': 'Start charting in a minute',
  'auth.register.subtitle':
    'Just an email and password. Solo today, invite your team whenever.',
  'auth.register.eyebrow': 'Get started',
  'auth.register.formEyebrow': 'Sign up',
  'auth.register.emailLabel': 'Email',
  'auth.register.emailPlaceholder': 'you@clinic.example',
  'auth.register.passwordLabel': 'Password',
  'auth.register.passwordPlaceholder': 'Create a strong password',
  'auth.register.confirmPasswordLabel': 'Confirm password',
  'auth.register.confirmPasswordPlaceholder': 'Re-enter your password',
  'auth.register.passwordMismatch': 'Passwords do not match',
  'auth.register.passwordTooShort':
    'Password must be at least 8 characters.',
  'auth.register.passwordHint': 'At least 8 characters.',
  'auth.register.submitButton': 'Create account',
  'auth.register.alreadyHaveAccount': 'Already have an account?',
  'auth.register.signInLink': 'Sign in',
  'auth.register.clinicNameLabel': 'Clinic name',
  'auth.register.clinicNamePlaceholder': 'Cairo Family Clinic',
  'auth.register.slugLabel': 'Your subdomain',
  'auth.register.slugPlaceholder': 'cairo-family-clinic',
  'auth.register.slugHint':
    "This is the URL your team will sign in at. You can change it now — it's stuck after sign-up.",
  'auth.register.slugChecking': 'Checking…',
  'auth.register.slugAvailable': 'Available',
  'auth.register.slugTaken': 'Already taken',
  'auth.register.slugReserved': 'Reserved — pick another',
  'auth.register.slugInvalid': 'Use lowercase letters, digits, and hyphens.',
  'auth.register.clinicAddressPreview': "Your clinic's address: ",
  'auth.register.slugAuto':
    "We'll set up your clinic's web address automatically.",
  'auth.register.customizeSlug': 'Customize clinic address',
  'auth.register.slugUseAutomatic': 'Use automatic',
  'auth.register.joinExisting': 'Joining an existing clinic?',
  'auth.register.joinExistingCta': 'Sign in with your invite',
  'auth.register.termsCheckboxPrefix': 'I agree to the MAIE',
  'auth.register.termsLink': 'Terms of Service',
  'auth.register.termsAnd': 'and',
  'auth.register.privacyLink': 'Privacy Notice',
  'auth.register.signUpFailed': 'Could not create account',
  'auth.register.clinicRequired':
    'Clinic name and subdomain are required.',
  'auth.register.slugMustBeAvailable':
    'Pick an available subdomain to continue.',
  'auth.register.continueWithGoogle': 'Continue with Google',
  'auth.register.orWithEmail': 'or with email',
  'auth.register.heroTitle': 'Stay with your patient.',
  'auth.register.heroTitleAccent': 'MAIE keeps the chart.',
  'auth.register.heroSubtitle':
    'A doctor scribe and an EMR in one. Sign up alone, scale to a clinic when you are ready.',
  'auth.register.proof1Title': 'Live in 60 seconds',
  'auth.register.proof1Body':
    'No setup forms, no salesperson. Email and password and you are in.',
  'auth.register.proof2Title': 'Add your team later',
  'auth.register.proof2Body':
    'When you bring on staff, invite them with a role. Same workspace, same chart.',
  'auth.register.proof3Title': 'Sovereign by default',
  'auth.register.proof3Body':
    'Per-tenant encryption keys. PHI residency pinned to your region.',

  'auth.errors.usernameRequired': 'Username is required',
  'auth.errors.passwordRequired': 'Password is required',
  'auth.errors.twoFactorRequired': 'Security code is required',
  'auth.twoFactorRequired': 'Two-factor authentication required. Please enter your security code.',
  'auth.electronicMedicalRecords': 'Electronic Medical Records',
  'auth.poweredBy': 'Powered by {{provider}}',
  'auth.transformYourHealthcare': 'Transform Your',
  'auth.healthcarePractice': 'Healthcare Practice',
  'auth.nextGenerationDescription': 'Experience the next generation of medical records management with AI-powered insights and seamless workflows.',
  'auth.keyFeatures': 'Key Features',
  'auth.smartDocumentation': 'Smart Documentation',
  'auth.smartDocumentationDesc': 'AI-powered medical records',
  'auth.appointmentManagement': 'Appointment Management',
  'auth.appointmentManagementDesc': 'Seamless scheduling system',
  'auth.patientPortal': 'Patient Portal',
  'auth.patientPortalDesc': 'Enhanced patient engagement',
  'auth.fastEfficient': 'Fast & Efficient',
  'auth.fastEfficientDesc': 'Optimized workflows',
  'auth.signInDescription': 'Sign in to access your medical records dashboard',
  'auth.demoAccount': 'Demo Account',
  'auth.hide': 'Hide',
  'auth.enterUsername': 'Enter your username',
  'auth.enterPassword': 'Enter your password',
  'auth.twoFactorCodePlaceholder': '000000',

  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': 'Welcome back! Here\'s your overview for today',
  'dashboard.welcomeMessage': 'Welcome to your medical practice management system',
  'dashboard.doctorWelcome': 'Welcome back, Dr. {{name}}! Ready to provide excellent patient care.',
  'dashboard.nurseWelcome': 'Welcome back, {{name}}! Your patients are counting on your excellent care.',
  'dashboard.adminWelcome': 'Welcome back, {{name}}! Your system is running smoothly.',
  'dashboard.overview': 'Dashboard Overview',
  'dashboard.todaysAppointments': 'Today\'s Appointments',
  'dashboard.totalPatients': 'Total Patients',
  'dashboard.pendingTasks': 'Pending Tasks',
  'dashboard.criticalAlerts': 'Critical Alerts',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.recentActivity': 'Recent Activity',
  'dashboard.upcomingAppointments': 'Upcoming Appointments',
  'dashboard.performanceMetrics': 'Performance Metrics',
  'dashboard.patientSatisfaction': 'Patient Satisfaction',
  'dashboard.appointmentEfficiency': 'Appointment Efficiency',
  'dashboard.documentationComplete': 'Documentation Complete',
  'dashboard.aiInsights': 'AI Insights',
  'dashboard.onSchedule': 'On Schedule',
  'dashboard.updated': 'Updated',
  'dashboard.medicalRecords': 'Medical Records',
  'dashboard.completionRate': '{{rate}}% Rate',
  'dashboard.completedToday': 'Completed Today',
  'dashboard.newPatient': 'New Patient',
  'dashboard.scheduleAppointment': 'Schedule Appointment',
  'dashboard.createRecord': 'Create Record',
  'dashboard.aiRecommendations': 'AI Recommendations',
  'dashboard.patientFollowUps': 'Patient Follow-ups',
  'dashboard.followUpsDue': '{{count}} patients due for follow-up visits',
  'dashboard.preventiveCare': 'Preventive Care',
  'dashboard.screeningsNeeded': '{{count}} patients need annual screenings',
  'dashboard.documentation': 'Documentation',
  'dashboard.incompleteRecords': '{{count}} incomplete medical records',
  'dashboard.practiceHealth': 'Practice Health',
  'dashboard.welcomeBack': 'Welcome back',
  'dashboard.registeredPatients': 'Registered patients',
  'dashboard.totalScheduled': 'total scheduled',
  'dashboard.clinicalDocumentation': 'Clinical documentation',
  'dashboard.labOrders': 'Lab Orders',
  'dashboard.inProgress': 'in progress',
  'dashboard.invoices': 'Invoices',
  'dashboard.pending': 'pending',
  'dashboard.templates': 'Templates',
  'dashboard.clinicalTemplates': 'Clinical templates',
  'dashboard.systemOverview': 'System Overview',
  'dashboard.activeModules': 'Active Modules',
  'dashboard.totalRecords': 'Total Records',
  'dashboard.todaysActivity': "Today's Activity",
  'dashboard.occupancy': 'Occupancy',
  'dashboard.clinicalOperations': 'Clinical Operations',
  'dashboard.administrative': 'Administrative',
  'dashboard.clinicalInsights': 'Clinical Insights',
  'dashboard.noModulesEnabled': 'No Modules Enabled',
  'dashboard.noModulesEnabledMessage': 'No modules are currently enabled. Please contact your administrator to enable modules.',
  'dashboard.goToFeatureToggles': 'Go to Feature Toggles',
  'dashboard.thisMonth': 'this month',

  // Patients
  'patients.title': 'Patients',
  'patients.subtitle': 'Manage patient records and information',
  'patients.addNew': 'Add Patient',
  'patients.addPatient': 'Add Patient',
  'patients.allData': 'All Patients Data',

  // Patient Photos
  'patients.photo.upload': 'Upload Photo',
  'patients.photo.change': 'Change Photo',
  'patients.photo.uploading': 'Uploading...',
  'patients.photo.dragAndDrop': 'Drag and drop a photo here, or click to select',
  'patients.photo.supportedFormats': 'Supported formats: {{formats}}',
  'patients.photo.maxSize': 'Maximum file size: {{size}}',
  'patients.photo.invalidFileType': 'Invalid file type. Please select a valid image file.',
  'patients.photo.fileTooLarge': 'File is too large. Maximum size is {{max}}MB.',
  'patients.photo.uploadFailed': 'Failed to upload photo. Please try again.',
  'patients.photo.uploadSuccess': 'Photo uploaded successfully.',
  'patients.searchPlaceholder': 'Search patients by name, ID, or phone...',
  'patients.filterAll': 'All Patients',
  'patients.filterActive': 'Active',
  'patients.filterInactive': 'Inactive',
  'patients.totalPatients': 'Total Patients',
  'patients.malePatients': 'Male Patients',
  'patients.femalePatients': 'Female Patients',
  'patients.avgAge': 'Average Age',
  'patients.years': 'years',
  'patients.noResults': 'No patients found',
  'patients.adjustSearch': 'Try adjusting your search or filters',
  'patients.notFound': 'Patient not found',
  'patients.admitted': 'Admitted',
  'patients.outpatient': 'Outpatient',
  'patients.filterAllStatus': 'All Status',
  'patients.filterAdmitted': 'Currently Admitted',
  'patients.filterOutpatient': 'Outpatient',
  'patients.filterNeverAdmitted': 'Never Admitted',
  'patients.analyzeData': 'Analyze Patient Data',
  'patients.allGenders': 'All Genders',
  'patients.sortBy': 'Sort by',
  'patients.newestFirst': 'Newest First',
  'patients.oldestFirst': 'Oldest First',
  'patients.firstNameAZ': 'First Name (A-Z)',
  'patients.firstNameZA': 'First Name (Z-A)',
  'patients.lastNameAZ': 'Last Name (A-Z)',
  'patients.lastNameZA': 'Last Name (Z-A)',
  'patients.statistics': 'Patient Statistics',
  'patients.generateReport': 'Generate Report',
  'patients.activePatients': 'Active Patients',
  'patients.loading': 'Loading patients...',
  'patients.errorLoading': 'Error Loading Patients',
  'patients.errorLoadingMessage': 'Failed to load patients',

  // Patient Form Fields
  'patient.personalInformation': 'Personal Information',
  'patient.firstName': 'First Name',
  'patient.lastName': 'Last Name',
  'patient.contactInformation': 'Contact Information',
  'patient.medicalInformation': 'Medical Information',
  'patient.insuranceProvider': 'Insurance Provider',
  'patient.knownAllergies': 'Known Allergies',
  'patient.currentMedications': 'Current Medications',
  'patient.emergencyContactName': 'Emergency Contact Name',
  'patient.emergencyContactPhone': 'Emergency Contact Phone',
  'patient.medicalHistoryPlaceholder': 'Brief medical history including chronic conditions, previous surgeries, etc.',
  'patient.name': 'Full Name',
  'patient.arabicName': 'Full Name (Arabic)',
  'patient.age': 'Age',
  'patient.gender': 'Gender',
  'patient.male': 'Male',
  'patient.female': 'Female',
  'patient.other': 'Other',
  'patient.email': 'Email',
  'patient.phone': 'Phone Number',
  'patient.dateOfBirth': 'Date of Birth',
  'patient.address': 'Address',
  'patient.arabicAddress': 'Address (Arabic)',
  'patient.bloodType': 'Blood Type',
  'patient.allergies': 'Allergies',
  'patient.arabicAllergies': 'Allergies (Arabic)',
  'patient.medicalHistory': 'Medical History',
  'patient.arabicMedicalHistory': 'Medical History (Arabic)',
  'patient.emergencyContact': 'Emergency Contact',
  'patient.emergencyPhone': 'Emergency Phone',

  // Patient Details Page
  'patient.patientId': 'Patient ID',
  'patient.patient': 'Patient',
  'patient.addToAIContext': 'Add to AI Context',
  'patient.editPatient': 'Edit Patient',
  'patient.basicInformation': 'Basic Information',
  'patient.recentRecords': 'Recent Medical Records',
  'patient.medicationsPrescribed': '{{count}} medications prescribed',
  'patient.noRecords': 'No medical records found',
  'patient.scheduleNew': 'Schedule New',
  'patient.noUpcomingAppointments': 'No upcoming appointments',
  'patient.clinicalNotes': 'Clinical Notes',
  'patient.medicalInfo': 'Medical Information',
  'patient.upcomingAppointments': 'Upcoming Appointments',
  'patient.addPatientToAIContext': 'Add Patient to AI Context',
  'patient.admitPatient': 'Admit Patient',
  'patient.currentAdmission': 'Current Admission',
  'patient.admissionDate': 'Admission Date',
  'patient.ward': 'Ward/Room/Bed',
  'patient.admissionStatus': 'Admission Status',
  'patient.admissionDiagnosis': 'Admission Diagnosis',
  'patient.dischargePatient': 'Discharge Patient',
  'patient.transferPatient': 'Transfer Patient',
  'patient.admissionHistory': 'Admission History',
  'patient.stillAdmitted': 'Still Admitted',
  'patient.location': 'Location',
  'patient.room': 'Room',

  // Patient Details Tabs
  'patientDetails.tabs.overview': 'Overview',
  'patientDetails.tabs.medicalHistory': 'Medical History',
  'patientDetails.tabs.labs': 'Lab Orders',
  'patientDetails.tabs.records': 'Records',
  'patientDetails.tabs.appointments': 'Appointments',
  'patientDetails.tabs.medications': 'Medications',
  'patientDetails.tabs.notes': 'Clinical Notes',

  // Patient Details Sections
  'patientDetails.demographics': 'Demographics',
  'patientDetails.medicalRecords': 'Medical Records',
  'patientDetails.vitals': 'Vital Signs',
  'patientDetails.conditions': 'Medical Conditions',
  'patientDetails.insuranceInfo': 'Insurance Information',
  'patientDetails.emergencyContacts': 'Emergency Contacts',
  'patientDetails.documents': 'Documents',
  'patientDetails.allergiesAndReactions': 'Allergies & Reactions',
  'patientDetails.immunizations': 'Immunizations',
  'patientDetails.familyHistory': 'Family History',
  'patientDetails.socialHistory': 'Social History',

  // Patient Details Labels
  'patientDetails.patientSince': 'Patient Since',
  'patientDetails.lastVisit': 'Last Visit',
  'patientDetails.nextAppointment': 'Next Appointment',
  'patientDetails.totalVisits': 'Total Visits',
  'patientDetails.activeProblems': 'Active Problems',

  // Patient Details Buttons
  'patientDetails.addRecord': 'Add Record',
  'patientDetails.newAppointment': 'New Appointment',
  'patientDetails.orderLab': 'Order Lab',
  'patientDetails.prescribeMedication': 'Prescribe Medication',
  'patientDetails.addNote': 'Add Note',
  'patientDetails.voiceNote': 'Voice Note',
  'patientDetails.noNotesYet': 'No clinical notes yet. Add your first note to get started.',
  'patientDetails.viewAll': 'View All',
  'patientDetails.print': 'Print',
  'patientDetails.export': 'Export',
  'patientDetails.share': 'Share',
  'patientDetails.download': 'Download',

  // Patient Details Form Fields
  'patientDetails.recordType': 'Record Type',
  'patientDetails.recordDate': 'Record Date',
  'patientDetails.provider': 'Provider',
  'patientDetails.diagnosis': 'Diagnosis',
  'patientDetails.treatment': 'Treatment',
  'patientDetails.notes': 'Notes',

  // Patient Details Placeholders
  'patientDetails.searchRecords': 'Search records...',
  'patientDetails.selectProvider': 'Select provider',
  'patientDetails.enterDiagnosis': 'Enter diagnosis',

  // Patient Details Status Messages
  'patientDetails.noRecordsFound': 'No records found',
  'patientDetails.noUpcomingAppointments': 'No upcoming appointments',
  'patientDetails.loading': 'Loading patient details...',

  // Patient Details Warnings
  'patientDetails.criticalAllergy': 'Critical Allergy Alert',
  'patientDetails.drugInteraction': 'Potential Drug Interaction',

  // Patient Timeline
  'patient.timeline': 'Patient Timeline',
  'patient.completeHistory': 'Complete Medical History',
  'patient.medicalTimeline': 'Medical Timeline',
  'patient.allEvents': 'All Events',
  'patient.admissions': 'Admissions',
  'patient.discharges': 'Discharges',
  'patient.allTime': 'All Time',
  'patient.last30Days': 'Last 30 Days',
  'patient.last90Days': 'Last 90 Days',
  'patient.lastYear': 'Last Year',
  'patient.events': 'events',
  'patient.noEventsFound': 'No events found matching your criteria',
  'patient.admitted': 'Admitted',
  'patient.discharged': 'Discharged',
  'patient.routineDischarge': 'Routine Discharge',
  'patient.admissionType': 'Admission Type',

  // Insurance Management
  'patient.insuranceManagement': 'Insurance Management',
  'patient.addInsurance': 'Add Insurance',
  'patient.editInsurance': 'Edit Insurance',
  'patient.primaryInsurance': 'Primary Insurance',
  'patient.secondaryInsurance': 'Secondary Insurance',
  'patient.noInsuranceRecords': 'No Insurance Records',
  'patient.addInsuranceToStart': 'Add insurance information to get started',
  'patient.addFirstInsurance': 'Add Your First Insurance',
  'patient.insuranceName': 'Insurance Company',
  'patient.policyNumber': 'Policy Number',
  'patient.groupNumber': 'Group Number',
  'patient.subscriberId': 'Subscriber ID',
  'patient.subscriberName': 'Subscriber Name',
  'patient.relationship': 'Relationship to Subscriber',
  'patient.relationship.self': 'Self',
  'patient.relationship.spouse': 'Spouse',
  'patient.relationship.child': 'Child',
  'patient.relationship.other': 'Other',
  'patient.effectiveDate': 'Effective Date',
  'patient.expirationDate': 'Expiration Date',
  'patient.copay': 'Copay Amount',
  'patient.deductible': 'Deductible Amount',
  'patient.setPrimaryInsurance': 'Set as Primary Insurance',
  'patient.activeInsurance': 'Active Insurance',
  'patient.saveInsurance': 'Save Insurance',
  'patient.updateInsurance': 'Update Insurance',
  'patient.policy': 'Policy',
  'patient.subscriber': 'Subscriber',
  'patient.insuranceCard.front': 'Front of Card',
  'patient.insuranceCard.back': 'Back of Card',
  'patient.uploadCardImage': 'Upload Card Image',
  'patient.uploading': 'Uploading...',
  'patient.insuranceNamePlaceholder': 'e.g., Blue Cross Blue Shield',
  'patient.policyNumberPlaceholder': 'e.g., ABC123456789',
  'patient.groupNumberPlaceholder': 'e.g., 12345',
  'patient.subscriberIdPlaceholder': 'e.g., 123456789',
  'patient.subscriberNamePlaceholder': 'e.g., John Doe',

  // Resource Scheduling
  'scheduling.resourceScheduling': 'Resource Scheduling',
  'scheduling.manageResourceBookings': 'Manage resource bookings and availability',
  'scheduling.newBooking': 'New Booking',
  'scheduling.searchResources': 'Search resources...',
  'scheduling.allResources': 'All Resources',
  'scheduling.rooms': 'Rooms',
  'scheduling.equipment': 'Equipment',
  'scheduling.facilities': 'Facilities',
  'scheduling.dayView': 'Day',
  'scheduling.weekView': 'Week',
  'scheduling.monthView': 'Month',
  'scheduling.resourceAvailability': 'Resource Availability',
  'scheduling.resources': 'resources',
  'scheduling.resource': 'Resource',
  'scheduling.noResourcesFound': 'No Resources Found',
  'scheduling.adjustFilters': 'Try adjusting your search or filters',
  'scheduling.basicInformation': 'Basic Information',
  'scheduling.type': 'Type',
  'scheduling.room': 'Room',
  'scheduling.facility': 'Facility',
  'scheduling.status': 'Status',
  'scheduling.status.available': 'Available',
  'scheduling.status.occupied': 'Occupied',
  'scheduling.status.maintenance': 'Maintenance',
  'scheduling.status.reserved': 'Reserved',
  'scheduling.capacity': 'Capacity',
  'scheduling.people': 'people',
  'scheduling.features': 'Features',
  'scheduling.maintenance': 'Maintenance',
  'scheduling.frequency': 'Frequency',
  'scheduling.daily': 'Daily',
  'scheduling.weekly': 'Weekly',
  'scheduling.monthly': 'Monthly',
  'scheduling.lastMaintenance': 'Last Maintenance',
  'scheduling.nextMaintenance': 'Next Maintenance',
  'scheduling.todaysBookings': "Today's Bookings",
  'scheduling.noBookingsToday': 'No bookings scheduled for today',
  'scheduling.priority.emergency': 'Emergency',
  'scheduling.priority.high': 'High',
  'scheduling.priority.medium': 'Medium',
  'scheduling.priority.low': 'Low',

  // Provider Availability
  'scheduling.providerAvailability': 'Provider Availability',
  'scheduling.manageProviderSchedules': 'Manage provider schedules and availability',
  'scheduling.templates': 'Templates',
  'scheduling.addAvailability': 'Add Availability',
  'scheduling.searchProviders': 'Search providers...',
  'scheduling.allDepartments': 'All Departments',
  'scheduling.scheduleOverview': 'Schedule Overview',
  'scheduling.providers': 'providers',
  'scheduling.provider': 'Provider',
  'scheduling.noProvidersFound': 'No Providers Found',
  'scheduling.noSchedule': 'No schedule',
  'scheduling.editAvailability': 'Edit Availability',
  'scheduling.selectProvider': 'Select a provider',
  'scheduling.date': 'Date',
  'scheduling.startTime': 'Start Time',
  'scheduling.endTime': 'End Time',
  'scheduling.type.regular': 'Regular Shift',
  'scheduling.type.on-call': 'On-Call',
  'scheduling.type.unavailable': 'Unavailable',
  'scheduling.type.vacation': 'Vacation',
  'scheduling.type.sick': 'Sick Leave',
  'scheduling.type.education': 'Education/Training',
  'scheduling.location': 'Location',
  'scheduling.locationPlaceholder': 'e.g., Main Clinic, OR 1',
  'scheduling.notes': 'Notes',
  'scheduling.notesPlaceholder': 'Additional notes or instructions...',

  // Waitlist Management
  'scheduling.waitlistManagement': 'Waitlist Management',
  'scheduling.managePatientWaitlist': 'Manage patient waitlist and queue',
  'scheduling.autoMatch': 'Auto Match',
  'scheduling.addToWaitlist': 'Add to Waitlist',
  'scheduling.totalWaiting': 'Total Waiting',
  'scheduling.urgentCases': 'Urgent Cases',
  'scheduling.contacted': 'Contacted',
  'scheduling.scheduled': 'Scheduled',
  'scheduling.searchWaitlist': 'Search waitlist...',
  'scheduling.allStatuses': 'All Statuses',
  'scheduling.allUrgencies': 'All Urgencies',
  'scheduling.status.waiting': 'Waiting',
  'scheduling.status.contacted': 'Contacted',
  'scheduling.status.scheduled': 'Scheduled',
  'scheduling.status.cancelled': 'Cancelled',
  'scheduling.urgency.emergency': 'Emergency',
  'scheduling.urgency.urgent': 'Urgent',
  'scheduling.urgency.routine': 'Routine',
  'scheduling.sortBy': 'Sort by',
  'scheduling.position': 'Position',
  'scheduling.urgency': 'Urgency',
  'scheduling.waitTime': 'Wait Time',
  'scheduling.dateAdded': 'Date Added',
  'scheduling.waitlistEntries': 'Waitlist Entries',
  'scheduling.patient': 'Patient',
  'scheduling.appointmentType': 'Appointment Type',
  'scheduling.availableSlots': 'Available Slots',
  'scheduling.since': 'since',
  'scheduling.contactAttempts': 'contact attempts',
  'scheduling.contactPatient': 'Contact Patient',
  'scheduling.scheduleAppointment': 'Schedule Appointment',
  'scheduling.noWaitlistEntries': 'No Waitlist Entries',
  'scheduling.adjustFiltersOrAdd': 'Try adjusting your filters or add a new entry',
  'scheduling.noMatchingSlots': 'No matching slots available',
  'scheduling.schedule': 'Schedule',
  'scheduling.markContacted': 'Mark as Contacted',
  'common.days': 'days',

  // Order Management
  'orders.management.title': 'Order Management',
  'orders.management.subtitle': 'Manage and track all orders across the system',
  'orders.status.pending': 'Pending',
  'orders.status.active': 'Active',
  'orders.status.completed': 'Completed',
  'orders.status.discontinued': 'Discontinued',
  'orders.priority.urgent': 'Urgent',
  'orders.priority.routine': 'Routine',
  'orders.search.placeholder': 'Search by patient, provider, or order ID',
  'orders.filter.status': 'Status',
  'orders.filter.type': 'Type',
  'orders.filter.priority': 'Priority',
  'orders.filter.provider': 'Provider',
  'orders.filter.dateStart': 'Start Date',
  'orders.filter.dateEnd': 'End Date',
  'orders.bulk.selected': 'orders selected',
  'orders.actions.hold': 'Hold',
  'orders.actions.resume': 'Resume',
  'orders.actions.discontinue': 'Discontinue',
  'orders.actions.renew': 'Renew',
  'orders.list.title': 'Orders',
  'orders.list.sortBy': 'Sort by',
  'orders.sort.date': 'Date',
  'orders.sort.patient': 'Patient',
  'orders.sort.provider': 'Provider',
  'orders.sort.status': 'Status',
  'orders.sort.type': 'Type',
  'orders.sort.priority': 'Priority',
  'orders.table.type': 'Type',
  'orders.table.patient': 'Patient',
  'orders.table.details': 'Details',
  'orders.table.status': 'Status',
  'orders.table.priority': 'Priority',
  'orders.table.provider': 'Provider',
  'orders.table.date': 'Date',
  'orders.noOrders': 'No orders found',
  'orders.noOrdersDesc': 'Try adjusting your filters or search criteria',

  // Clinical Decision Support
  'cds.title': 'Clinical Decision Support',
  'cds.loading': 'Analyzing order for safety and effectiveness...',
  'cds.alertsFound': 'alert(s) require attention',
  'cds.noAlerts': 'No safety concerns identified',
  'cds.interactions.title': 'Drug Interactions',
  'cds.interactions.none': 'No drug interactions detected',
  'cds.allergies.title': 'Allergy Alerts',
  'cds.allergies.none': 'No known allergies to this medication',
  'cds.allergies.reaction': 'Previous reaction',
  'cds.allergies.crossSensitivity': 'Cross-sensitivity possible',
  'cds.dosing.title': 'Dosing Recommendations',
  'cds.dosing.appropriate': 'Dosing appears appropriate',
  'cds.dosing.adjustment': 'adjustment',
  'cds.dosing.adjusted': 'Adjusted dose',
  'cds.guidelines.title': 'Clinical Guidelines',
  'cds.guidelines.none': 'No specific guidelines found',
  'cds.calculations.title': 'Dosage Calculations',
  'cds.calculations.none': 'Standard dosing applies',
  'cds.calculations.dosing': 'dosing',
  'cds.calculations.current': 'Current dose',
  'cds.calculations.recommended': 'Recommended dose',
  'cds.cost.title': 'Cost-Effectiveness',
  'cds.cost.optimal': 'Cost-effective option selected',
  'cds.cost.alert': 'alert',
  'cds.cost.alternatives': 'Alternatives',
  'cds.actions.dismiss': 'Dismiss All',
  'cds.actions.acknowledge': 'Acknowledge & Continue',

  // Additional CDS Keys
  'cds.drugInteraction': 'Drug Interaction',
  'cds.allergyAlert': 'Allergy Alert',
  'cds.dosageAlert': 'Dosage Alert',
  'cds.recommendation': 'Recommendation',
  'cds.drugs': 'Drugs',
  'cds.mechanism': 'Mechanism',
  'cds.clinicalEffects': 'Clinical Effects',
  'cds.management': 'Management',
  'cds.adjustmentReason': 'Adjustment Reason',
  'cds.recommendedDose': 'Recommended Dose',
  'cds.references': 'References',
  'cds.overrideReason': 'Override Reason',
  'cds.overrideReasonPlaceholder': 'Enter reason for override...',
  'cds.acknowledge': 'Acknowledge',
  'cds.override': 'Override',
  'cds.additionalAlerts': 'Additional Alerts',
  'cds.checkInteractions': 'Check Interactions',
  'cds.calculateDose': 'Calculate Dose',
  'cds.viewGuidelines': 'View Guidelines',
  'cds.noAlertsFound': 'No alerts found',
  'cds.checking': 'Checking...',

  // CDS Severity Levels
  'cds.severity.critical': 'Critical',
  'cds.severity.high': 'High',
  'cds.severity.medium': 'Medium',
  'cds.severity.low': 'Low',
  'cds.severity.info': 'Info',

  // CDS Alert Types
  'cds.alertType.drugInteraction': 'Drug Interaction',
  'cds.alertType.allergy': 'Allergy',
  'cds.alertType.contraindication': 'Contraindication',
  'cds.alertType.dosage': 'Dosage',
  'cds.alertType.duplicateTherapy': 'Duplicate Therapy',
  'cds.alertType.renalAdjustment': 'Renal Adjustment',
  'cds.alertType.hepaticAdjustment': 'Hepatic Adjustment',
  'cds.alertType.monitoring': 'Monitoring Required',
  'cds.alertType.costAlternative': 'Cost Alternative',
  'cds.alertType.formularyRestriction': 'Formulary Restriction',

  // Administrative Features
  'admin.systemSettings.title': 'System Settings',
  'admin.systemSettings.subtitle': 'Configure your facility, branding, and preferences',
  'admin.systemSettings.unsavedChanges': 'Unsaved changes',
  'admin.systemSettings.lastSaved': 'Last saved',
  'admin.systemSettings.tabs.hospital': 'Facility',
  'admin.systemSettings.tabs.system': 'System',
  'admin.systemSettings.tabs.branding': 'Branding',
  'admin.systemSettings.tabs.backup': 'Backup',
  'admin.systemSettings.tabs.domains': 'Domains',
  'admin.systemSettings.hospital.basicInfo': 'Facility Information',
  'admin.systemSettings.hospital.basicInfoDesc': 'Basic details about your facility — hospital, clinic, or solo practice',
  'admin.systemSettings.hospital.nameEn': 'Facility Name (English)',
  'admin.systemSettings.hospital.nameAr': 'Facility Name (Arabic)',
  'admin.systemSettings.hospital.logo': 'Facility Logo',
  'admin.systemSettings.hospital.uploadLogo': 'Upload Logo',
  'admin.systemSettings.hospital.movedToBranding':
    'Hospital name and logo are managed in the Branding tab so the same value flows to the sidebar, login page, and PDFs.',
  'admin.systemSettings.hospital.contact': 'Contact Information',
  'admin.systemSettings.hospital.contactDesc': 'How patients and partners reach your facility',
  'admin.systemSettings.hospital.phone': 'Phone Number',
  'admin.systemSettings.hospital.email': 'Email Address',
  'admin.systemSettings.hospital.website': 'Website',
  'admin.systemSettings.hospital.location': 'Location & License',
  'admin.systemSettings.hospital.locationDesc': 'Physical address and licensing information',
  'admin.systemSettings.hospital.defaultLocale': 'Default Language',
  'admin.systemSettings.hospital.licenseNumber': 'License Number',
  'admin.systemSettings.hospital.issuedBy': 'Issued By',
  'admin.systemSettings.hospital.validUntil': 'Valid Until',
  'admin.systemSettings.hospital.phoneCountry': 'Phone country',
  'admin.systemSettings.hospital.currencyDisplay': 'Currency display',
  'admin.systemSettings.hospital.currencyDisplayDesc': 'Choose how monetary amounts are shown across billing. Defaults to your country based on browser locale.',
  'admin.systemSettings.hospital.currencyCode': 'Currency',
  'admin.systemSettings.hospital.currencyPreview': 'Preview',
  'admin.systemSettings.system.security': 'Security Settings',
  'admin.systemSettings.system.securityDesc': 'Configure security policies and authentication',
  'admin.systemSettings.system.sessionTimeout': 'Session Timeout (minutes)',
  'admin.systemSettings.system.passwordExpiry': 'Password Expiry (days)',
  'admin.systemSettings.system.loginAttempts': 'Max Login Attempts',
  'admin.systemSettings.system.requireMFA': 'Require Multi-Factor Authentication',
  'admin.systemSettings.system.dataRetention': 'Data Retention',
  'admin.systemSettings.system.dataRetentionDesc': 'Configure how long data is kept in the system',
  'admin.systemSettings.system.patientRecords': 'Patient Records (months)',
  'admin.systemSettings.system.auditLogs': 'Audit Logs (months)',
  'admin.systemSettings.system.backups': 'Backups (months)',
  'admin.systemSettings.branding.title': 'Brand Customization',
  'admin.systemSettings.branding.description': 'Customize the look and feel of your system',
  'admin.systemSettings.branding.primaryColor': 'Primary Color',
  'admin.systemSettings.branding.secondaryColor': 'Secondary Color',
  'admin.systemSettings.branding.accentColor': 'Accent Color',
  'admin.systemSettings.branding.logoPosition': 'Logo Position',
  'admin.systemSettings.branding.headerStyle': 'Header Style',
  'admin.systemSettings.branding.left': 'Left',
  'admin.systemSettings.branding.center': 'Center',
  'admin.systemSettings.branding.right': 'Right',
  'admin.systemSettings.branding.simple': 'Simple',
  'admin.systemSettings.branding.gradient': 'Gradient',
  'admin.systemSettings.branding.image': 'Image Background',
  'admin.systemSettings.branding.preview': 'Color Preview',
  'admin.systemSettings.backup.settings': 'Backup Settings',
  'admin.systemSettings.backup.settingsDesc': 'Configure automatic backup and restore options',
  'admin.systemSettings.backup.autoBackup': 'Enable Automatic Backup',
  'admin.systemSettings.backup.frequency': 'Backup Frequency',
  'admin.systemSettings.backup.retention': 'Retention (days)',
  'admin.systemSettings.backup.location': 'Backup Location',
  'admin.systemSettings.backup.daily': 'Daily',
  'admin.systemSettings.backup.weekly': 'Weekly',
  'admin.systemSettings.backup.monthly': 'Monthly',
  'admin.systemSettings.backup.local': 'Local Storage',
  'admin.systemSettings.backup.cloud': 'Cloud Storage',
  'admin.systemSettings.backup.both': 'Both',
  'admin.systemSettings.backup.manual': 'Manual Backup & Restore',
  'admin.systemSettings.backup.manualDesc': 'Create manual backups or restore from existing backups',
  'admin.systemSettings.backup.creating': 'Creating Backup...',
  'admin.systemSettings.backup.export': 'Export Backup',
  'admin.systemSettings.backup.restore': 'Restore Backup',
  'admin.systemSettings.backup.warning': 'Important Backup Information',
  'admin.systemSettings.backup.warningText1': 'Restoring a backup will overwrite current data',
  'admin.systemSettings.backup.warningText2': 'Always create a backup before restoring',
  'admin.systemSettings.backup.warningText3': 'Backup files contain sensitive data - store securely',

  // System Monitoring
  'admin.monitoring.title': 'System Monitoring',
  'admin.monitoring.subtitle': 'Real-time system performance and health monitoring',
  'admin.monitoring.lastUpdated': 'Last updated',
  'admin.monitoring.autoRefresh': 'Auto refresh',
  'admin.monitoring.cpu.title': 'CPU Usage',
  'admin.monitoring.memory.title': 'Memory Usage',
  'admin.monitoring.disk.title': 'Disk Usage',
  'admin.monitoring.users.title': 'Active Users',
  'admin.monitoring.performance.title': 'Performance Trends',
  'admin.monitoring.timeRange.1h': 'Last Hour',
  'admin.monitoring.timeRange.6h': 'Last 6 Hours',
  'admin.monitoring.timeRange.24h': 'Last 24 Hours',
  'admin.monitoring.timeRange.7d': 'Last 7 Days',
  'admin.monitoring.alerts.title': 'System Alerts',
  'admin.monitoring.alerts.none': 'No active alerts',
  'admin.monitoring.alerts.resolve': 'Resolve',
  'admin.monitoring.network.title': 'Network & Database',
  'admin.monitoring.network.latency': 'Network Latency',
  'admin.monitoring.network.throughput': 'Throughput',
  'admin.monitoring.database.connections': 'DB Connections',
  'admin.monitoring.database.queries': 'Queries/min',
  'admin.monitoring.storage.title': 'Storage Details',
  'admin.monitoring.storage.system': 'System Drive',
  'admin.monitoring.storage.iops': 'IOPS',
  'admin.monitoring.storage.free': 'Free Space',
  'admin.monitoring.storage.database': 'Database Size',
  'admin.monitoring.storage.backups': 'Backup Size',

  // Audit Logs
  'admin.audit.title': 'Audit Logs & Compliance',
  'admin.audit.subtitle': 'Monitor system activity and maintain compliance records',
  'admin.audit.export': 'Export',
  'admin.audit.searchPlaceholder': 'Search logs...',
  'admin.audit.category': 'Category',
  'admin.audit.outcome': 'Outcome',
  'admin.audit.riskLevel': 'Risk Level',
  'admin.audit.dateRange': 'Date Range',
  'admin.audit.success': 'Success',
  'admin.audit.failure': 'Failure',
  'admin.audit.warning': 'Warning',
  'admin.audit.risk.low': 'Low',
  'admin.audit.risk.medium': 'Medium',
  'admin.audit.risk.high': 'High',
  'admin.audit.risk.critical': 'Critical',
  'admin.audit.logs': 'Audit Logs',
  'admin.audit.noLogs': 'No audit logs found',
  'admin.audit.noLogsDesc': 'Try adjusting your filters or date range',
  'admin.audit.complianceReports': 'Compliance Reports',
  'admin.audit.generateHIPAA': 'HIPAA Report',
  'admin.audit.generateCustom': 'Custom Report',
  'admin.audit.quickStats': 'Quick Statistics',
  'admin.audit.totalLogs': 'Total Logs',
  'admin.audit.failedActions': 'Failed Actions',
  'admin.audit.highRiskEvents': 'High Risk Events',
  'admin.audit.uniqueUsers': 'Unique Users',
  'admin.audit.logDetails': 'Audit Log Details',
  'admin.audit.timestamp': 'Timestamp',
  'admin.audit.user': 'User',
  'admin.audit.action': 'Action',
  'admin.audit.resource': 'Resource',
  'admin.audit.ipAddress': 'IP Address',
  'admin.audit.sessionId': 'Session ID',
  'admin.audit.complianceFlags': 'Compliance Flags',
  'admin.audit.details': 'Additional Details',
  'admin.audit.userAgent': 'User Agent',

  // Medical Records
  'records.title': 'Medical Records',
  'records.subtitle': 'View and manage patient medical records',
  'records.addNew': 'Add Record',
  'records.addRecord': 'Add Record',
  'records.editRecord': 'Edit Record',
  'records.saveRecord': 'Save Record',
  'records.overview': 'Medical Records Overview',
  'records.searchPlaceholder': 'Search records...',
  'records.filterAll': 'All Types',
  'records.filterConsultation': 'Consultation',
  'records.filterDiagnosis': 'Diagnosis',
  'records.filterTreatment': 'Treatment',
  'records.filterFollowUp': 'Follow-up',
  'records.type': 'Record Type',
  'records.date': 'Date',
  'records.patient': 'Patient',
  'records.selectPatient': 'Select a patient',
  'records.selectPatientFirst': 'Select a patient first',
  'records.recordType': 'Record Type',
  'records.types.consultation': 'Consultation',
  'records.types.diagnosis': 'Diagnosis',
  'records.types.treatment': 'Treatment',
  'records.types.followUp': 'Follow-up',
  'records.vitalSigns': 'Vital Signs',
  'records.vitals.bloodPressure': 'Blood Pressure',
  'records.vitals.temperature': 'Temperature (°F)',
  'records.vitals.heartRate': 'Heart Rate (bpm)',
  'records.vitals.weight': 'Weight (kg)',
  'records.vitals.height': 'Height (cm)',
  'records.diagnosis': 'Diagnosis',
  'records.diagnosisPlaceholder': 'Enter diagnosis details...',
  'records.arabicDiagnosis': 'Diagnosis (Arabic)',
  'records.treatmentPlan': 'Treatment Plan',
  'records.treatment': 'Treatment Plan',
  'records.treatmentPlaceholder': 'Enter treatment details...',
  'records.arabicTreatment': 'Treatment Plan (Arabic)',
  'records.medications': 'Medications',
  'records.medicationPlaceholder': 'Enter medication name and dosage...',
  'records.arabicMedications': 'Medications (Arabic)',
  'records.notes': 'Additional Notes',
  'records.notesPlaceholder': 'Any additional observations or recommendations...',
  'records.validation.patientRequired': 'Please select a patient',
  'records.validation.subjectiveRequired': 'Subjective is required',
  'records.validation.objectiveRequired': 'Objective is required',
  'records.validation.assessmentRequired': 'Assessment is required',
  'records.validation.planRequired': 'Plan is required',
  'records.validation.diagnosisRequired': 'Assessment is required',
  'records.validation.treatmentRequired': 'Plan is required',
  'records.arabicNotes': 'Additional Notes (Arabic)',
  // 'records.vitalSigns': 'Vital Signs', // DUPLICATE REMOVED
  'records.bloodPressure': 'Blood Pressure',
  'records.temperature': 'Temperature',
  'records.heartRate': 'Heart Rate',
  'records.weight': 'Weight',
  'records.height': 'Height',
  'records.respiratoryRate': 'Respiratory Rate',
  'records.oxygenSaturation': 'O2 Saturation',
  'records.clinicalInformation': 'Clinical Information',
  // 'records.treatmentPlan': 'Treatment Plan', // DUPLICATE REMOVED
  'records.medicationsPrescribed': 'Medications Prescribed',
  'records.followUpInstructions': 'Follow-up Instructions',
  'records.additionalNotes': 'Additional Notes',

  // Record Details Page
  'records.recordDetails': 'Record Details',
  'records.recordId': 'Record ID',
  'records.record': 'Record',
  'records.medicalRecord': 'Medical Record',
  'records.notFound': 'Medical record not found',
  'records.download': 'Download',
  'records.viewPatientProfile': 'View Patient Profile',
  'records.recordInformation': 'Record Information',
  'records.consultation': 'Consultation',
  'records.follow-up': 'Follow-up',
  // 'records.treatmentPlan': 'Treatment Plan', // DUPLICATE REMOVED
  'records.prescribedMedications': 'Prescribed Medications',
  'records.downloadPDF': 'Download PDF',
  'records.printRecord': 'Print Record',
  'records.shareWithPatient': 'Share with Patient',
  'records.deleteConfirmTitle': 'Delete Medical Record?',
  'records.deleteConfirmMessage': 'Are you sure you want to delete this medical record? This action cannot be undone.',
  'records.confirmDelete': 'Delete Medical Record?',
  'records.deleteWarning': 'Are you sure you want to delete this medical record? This action cannot be undone.',
  'records.loading': 'Loading medical record...',
  'records.clinicalAssessment': 'Clinical Assessment',
  'records.viewProfile': 'View Profile',
  'records.clinicalSummary': 'Clinical Summary',
  'records.visitDate': 'Visit Date',
  'records.historyPresentIllness': 'History of Present Illness',
  'records.pastMedicalHistory': 'Past Medical History',
  'records.allergies': 'Allergies',
  'records.familyHistory': 'Family History',
  'records.socialHistory': 'Social History',
  'records.reviewOfSystems': 'Review of Systems',
  'records.physicalExamination': 'Physical Examination',
  'records.subjective': 'Subjective',
  'records.objective': 'Objective',
  'records.assessment': 'Assessment',
  'records.plan': 'Plan',
  'records.diagnoses': 'Diagnoses',
  'records.code': 'Code',
  'records.drugInteractionCheck': 'Drug Interaction Check',
  'records.vitalSignsAnalysis': 'Vital Signs Analysis',
  'records.bmi': 'BMI',
  'records.soapNote': 'SOAP Note',
  'records.additionalHistory': 'Additional History',
  'records.showAdditionalHistory': 'Show Additional History',
  'records.notRecorded': 'Not recorded',
  'records.signRecord': 'Sign Record',
  'records.signing': 'Signing...',
  'records.status.draft': 'Draft',
  'records.status.signed': 'Signed',
  'records.status.final': 'Final',
  'records.provider': 'Provider',
  'records.chiefComplaint': 'Chief Complaint',

  // Schedule
  'schedule.title': 'Schedule',
  'schedule.subtitle': 'Manage appointments and calendar',
  'schedule.newAppointment': 'New Appointment',
  'schedule.addAppointment': 'Add Appointment',
  'schedule.appointmentsTitle': 'Schedule & Appointments',
  'schedule.today': 'Today',
  'schedule.day': 'Day',
  'schedule.week': 'Week',
  'schedule.month': 'Month',
  'schedule.noAppointments': 'No appointments',
  'schedule.more': 'more',
  'schedule.scheduled': 'Scheduled',
  'schedule.completed': 'Completed',
  'schedule.cancelled': 'Cancelled',
  'schedule.todaysAppointments': 'Today\'s Appointments',
  'schedule.new': 'New',
  'schedule.weekOf': 'Week of {{date}}',
  'schedule.selectLimit': 'Select limit',
  'schedule.perDay': '{{count}} per day',
  'schedule.showAll': 'Show all',
  'schedule.moreAppointments': '+{{count}} more appointments',
  'schedule.showLess': 'Show less',
  'schedule.scheduleAnalytics': 'Schedule Analytics',
  'schedule.generateReport': 'Generate Schedule Report',
  'schedule.startClinicalNote': 'Start Clinical Note',
  'schedule.changeStatus': 'Change status',
  'schedule.failedToLoad': 'Failed to load appointments',
  'schedule.unknownPatient': 'Unknown Patient',
  'schedule.eyebrow': 'Calendar',
  'schedule.viewLabel': 'View',
  'schedule.emptyTitle': 'Nothing on the books',
  'schedule.emptyBody': 'No appointments for this day. Tap "New" to schedule a visit.',
  'schedule.emptyMonth': 'No visits this day',
  'schedule.appointmentsCount': '{{count}} appointments',
  'schedule.appointmentSingular': '1 appointment',
  'schedule.appointmentsZero': 'No appointments',

  // Provider Availability
  'availability.title': 'Provider Availability',
  'availability.subtitle': 'Manage provider schedules and working hours across the week',
  'availability.addAvailability': 'Add Availability',
  'availability.editAvailability': 'Edit Availability',
  'availability.updateSchedule': 'Update provider schedule',
  'availability.setWorkingHours': 'Set provider working hours',
  'availability.today': 'Today',
  'availability.showWeek': 'Show Week',
  'availability.show3Days': 'Show 3 Days',
  'availability.searchProviders': 'Search providers...',
  'availability.allDepartments': 'All Departments',
  'availability.provider': 'Provider',
  'availability.addAvailabilitySlot': 'Add availability',
  'availability.oneTime': 'One-time',
  'availability.noProvidersFound': 'No providers found',
  'availability.adjustFilters': 'Try adjusting your search or filters to find providers',
  'availability.selectProvider': 'Select Provider',
  'availability.dayOfWeek': 'Day of Week',
  'availability.startTime': 'Start Time',
  'availability.endTime': 'End Time',
  'availability.recurring': 'Recurring (repeats weekly)',
  'availability.effectiveFrom': 'Effective From',
  'availability.effectiveTo': 'Effective To',
  'availability.oneTimeDate': 'Date',
  'availability.oneTimeDateHint': 'This availability applies only to the selected date.',
  'availability.dateRequired': 'Pick a date for this one-time availability.',
  'availability.notes': 'Notes (Optional)',
  'availability.addNotes': 'Add any notes...',
  'availability.cancel': 'Cancel',
  'availability.create': 'Create',
  'availability.update': 'Update',
  'availability.saving': 'Saving...',
  'availability.deleteTitle': 'Delete Availability',
  'availability.deleteMessage': 'Are you sure you want to delete this availability entry? This action cannot be undone.',
  'availability.delete': 'Delete',
  'availability.failedToLoad': 'Failed to load provider availability',
  'availability.moduleRequired': 'Scheduling module is required for provider availability management.',
  'availability.monday': 'Monday',
  'availability.tuesday': 'Tuesday',
  'availability.wednesday': 'Wednesday',
  'availability.thursday': 'Thursday',
  'availability.friday': 'Friday',
  'availability.saturday': 'Saturday',
  'availability.sunday': 'Sunday',

  // Appointments
  'appointments.title': 'Appointments',
  'appointments.addAppointment': 'Add Appointment',
  'appointments.editAppointment': 'Edit Appointment',
  'appointments.saveAppointment': 'Save Appointment',
  'appointments.selectProvider': 'Select Provider',
  'appointments.patient': 'Patient',
  'appointments.provider': 'Provider',
  'appointments.selectPatient': 'Select a patient',
  'appointments.searchPatient': 'Search by name or phone…',
  'appointments.searchPatientHint': 'Type at least 2 characters to search.',
  'appointments.noPatientMatches': 'No matching patients',
  'appointments.date': 'Date',
  'appointments.time': 'Time',
  'appointments.duration': 'Duration',
  'appointments.reason': 'Reason for Visit',
  'appointments.reasonPlaceholder': 'e.g., Regular checkup, Follow-up consultation...',
  'appointments.notes': 'Additional Notes',
  'appointments.notesPlaceholder': 'Any special instructions or notes...',
  'appointments.confirmationTitle': 'Appointment Confirmation',
  'appointments.confirmationMessage': 'The patient will receive an email confirmation with appointment details.',
  'appointments.availabilityOutsideWindow': 'This time is outside {{provider}}’s availability for this day.',
  'appointments.availabilityNoneForDay': '{{provider}} has no availability set for this day.',
  'appointments.availabilityWithinWindow': 'Within {{provider}}’s availability.',
  'appointments.availabilityWarningHint': 'You can still book — this is only a heads-up.',
  'appointments.validation.requiredFields': 'Please fill in all required fields',
  'appointments.validation.patientRequired': 'Please select a patient',
  'appointments.validation.dateRequired': 'Date is required',
  'appointments.validation.timeRequired': 'Time is required',
  'appointments.validation.reasonRequired': 'Reason for visit is required',

  // Appointment Form (legacy - keeping for compatibility)
  'appointment.patient': 'Patient',
  'appointment.date': 'Date',
  'appointment.time': 'Time',
  'appointment.duration': 'Duration',
  'appointment.reason': 'Reason for Visit',
  'appointment.arabicReason': 'Reason for Visit (Arabic)',
  'appointment.notes': 'Additional Notes',
  'appointment.arabicNotes': 'Additional Notes (Arabic)',
  'appointment.minutes': 'minutes',
  'appointment.hour': 'hour',
  'appointment.hours': 'hours',
  'appointment.appointment': 'Appointment',
  'appointment.appointmentDetails': 'Appointment Details',
  'appointment.appointmentId': 'Appointment ID',
  'appointment.appointmentInformation': 'Appointment Information',
  'appointment.status': 'Status',
  'appointment.contact': 'Contact',
  'appointment.patientInformation': 'Patient Information',
  'appointment.createRecord': 'Create Medical Record',
  'appointment.documentVisit': 'Document this visit',
  'appointment.reschedule': 'Reschedule',
  'appointment.changeDateOrTime': 'Change date or time',
  'appointment.sendReminder': 'Send Reminder',
  'appointment.emailConfirmation': 'Email confirmation',
  'appointment.deleteConfirmTitle': 'Delete Appointment?',
  'appointment.deleteConfirmMessage': 'Are you sure you want to delete this appointment? This action cannot be undone.',
  'appointment.notFound': 'Appointment not found',
  'appointment.provider': 'Provider',
  'appointment.clinicalDocumentation': 'Clinical Documentation',
  'appointment.startVoiceNote': 'Start voice-enabled clinical note taking for this appointment',
  'appointment.startNote': 'Start Note',
  'appointment.addAnotherNote': 'Add Another Note',
  'appointment.linkedRecords': 'Linked Records',
  'appointment.loadingRecords': 'Loading medical records...',
  'appointment.noChiefComplaint': 'No chief complaint',
  'appointment.reminderSent': 'Reminder sent successfully',
  'appointment.reminderFailed': 'Failed to send reminder',
  'appointment.whatsAppReminder': 'WhatsApp Reminder',
  'appointment.sendWhatsAppReminder': 'Send appointment reminder via WhatsApp',
  'appointment.type': 'Type',

  // Settings
  'settings.language': 'Language',
  'settings.hospital': 'Hospital Settings',
  'settings.hospitalTagline': 'Hospital Tagline',
  'settings.aiProvider': 'AI Provider',

  // Hospital & Bed Management
  'hospital.bedManagement.title': 'Bed Management',
  'hospital.bedManagement.subtitle': 'Real-time bed status and capacity management',
  'hospital.bedManagement.totalBeds': 'Total Beds',
  'hospital.bedManagement.availableBeds': 'Available Beds',
  'hospital.bedManagement.occupiedBeds': 'Occupied Beds',
  'hospital.bedManagement.occupancyRate': 'Occupancy Rate',
  'hospital.bedManagement.needsCleaning': 'Needs Cleaning',
  'hospital.bedManagement.blockedBeds': 'Blocked Beds',
  'hospital.bedManagement.isolation': 'Isolation',
  'hospital.bedManagement.realTimeOn': 'Real-time ON',
  'hospital.bedManagement.realTimeOff': 'Real-time OFF',
  'hospital.bedManagement.refresh': 'Refresh',
  'hospital.bedManagement.searchPlaceholder': 'Search beds or units...',
  'hospital.bedManagement.allFloors': 'All Floors',
  'hospital.bedManagement.floor': 'Floor',
  'hospital.bedManagement.availableOnly': 'Available Only',
  'hospital.bedManagement.occupiedOnly': 'Occupied Only',
  'hospital.bedManagement.filters': 'Filters',
  'hospital.bedManagement.clearAll': 'Clear All',
  'hospital.bedManagement.assign': 'Assign',
  'hospital.bedManagement.discharge': 'Discharge',
  'hospital.bedManagement.block': 'Block',
  'hospital.bedManagement.edit': 'Edit',
  'hospital.bedManagement.lastUpdated': 'Last updated',
  'hospital.bedManagement.noBedsFound': 'No beds found',
  'hospital.bedManagement.adjustFilters': 'Try adjusting your filters or search criteria',

  // Bed Status
  'hospital.bedStatus.occupied': 'Occupied',
  'hospital.bedStatus.available': 'Available',
  'hospital.bedStatus.dirty': 'Dirty',
  'hospital.bedStatus.housekeeping': 'Housekeeping',
  'hospital.bedStatus.maintenance': 'Maintenance',
  'hospital.bedStatus.blocked': 'Blocked',
  'hospital.bedStatus.isolation': 'Isolation',

  // Bed Equipment
  'hospital.bedEquipment.oxygen': 'Oxygen',
  'hospital.bedEquipment.monitoring': 'Monitoring',
  'hospital.bedEquipment.ventilator': 'Ventilator',
  'hospital.bedEquipment.telemetry': 'Telemetry',
  'settings.appearance': 'Appearance',
  'settings.darkMode': 'Dark Mode',
  'settings.lightMode': 'Light Mode',
  'settings.systemDefault': 'System Default',
  'settings.colorScheme': 'Color Scheme',
  'settings.preview': 'Preview',
  'settings.resetDefaults': 'Reset to Defaults',

  // Voice
  'voice.startRecording': 'Start Recording',
  'voice.stopRecording': 'Stop Recording',
  'voice.recording': 'Recording',
  'voice.paused': 'Paused',
  'voice.transcribing': 'Transcribing',
  'voice.appointmentRecording': 'Appointment Recording',
  'voice.clinicalNotesRecording': 'Clinical Notes Recording',
  'voice.patientConversation': 'Patient Conversation',
  'voice.generalRecording': 'General Recording',
  'voice.maxDurationWarning': '{{seconds}} seconds remaining',

  // AI Assistant
  'ai.title': 'AI Clinical Assistant',
  'ai.subtitle': 'Powered by {{aiProvider}}',
  'ai.addContext': 'Add full page context',
  'ai.clearContext': 'Clear all',
  'ai.listening': 'Listening...',
  'ai.stopListening': 'Stop Listening',
  'ai.voiceInput': 'Voice Input',
  'ai.placeholder': 'Ask about diagnosis, treatment, or clinical guidelines...',
  'ai.differentialDiagnosis': 'Differential Diagnosis',
  'ai.medicationReview': 'Medication Review',
  'ai.clinicalSummary': 'Clinical Summary',
  'ai.riskAssessment': 'Risk Assessment',
  'ai.followUpPlan': 'Follow-up Plan',
  'ai.treatmentOptions': 'Treatment Options',
  'ai.readyToAssist': 'Ready to Assist',
  'ai.assistDescription': 'I can help with clinical decision support, medical documentation, differential diagnosis, and treatment planning.',
  'ai.quickActions': 'Quick Clinical Actions',
  'ai.chat': 'Chat',
  'ai.visitRecording': 'Visit Recording',

  // Lab Orders
  // 'nav.labOrders': 'Lab Orders', // DUPLICATE REMOVED
  'labOrders.title': 'Lab Orders',
  'labOrders.subtitle': 'Manage laboratory orders and results',
  'labOrders.newOrder': 'New Lab Order',
  'labOrders.newOrderDescription': 'Create a new laboratory order for a patient',
  'labOrders.searchPlaceholder': 'Search lab orders...',
  'labOrders.allStatuses': 'All Statuses',
  'labOrders.allPriorities': 'All Priorities',
  'labOrders.allCategories': 'All Categories',
  'labOrders.draft': 'Draft',
  'labOrders.ordered': 'Ordered',
  'labOrders.specimenCollected': 'Specimen Collected',
  'labOrders.inProgress': 'In Progress',
  'labOrders.resulted': 'Resulted',
  'labOrders.cancelled': 'Cancelled',
  'labOrders.routine': 'Routine',
  'labOrders.urgent': 'Urgent',
  'labOrders.stat': 'STAT',
  'labOrders.totalOrders': 'Total Orders',
  'labOrders.pendingCollection': 'Pending Collection',
  'labOrders.completed': 'Completed',
  'labOrders.noResults': 'No lab orders found',
  'labOrders.adjustSearch': 'Try adjusting your search or filters',
  'labOrders.moreTests': 'more tests',
  'labOrders.orderDetails': 'Lab Order Details',
  'labOrders.orderId': 'Order ID',
  'labOrders.labOrder': 'Lab Order',
  'labOrders.orderInformation': 'Order Information',
  'labOrders.status': 'Status',
  'labOrders.orderDate': 'Order Date',
  'labOrders.priority': 'Priority',
  'labOrders.requiredBy': 'Required By',
  'labOrders.orderedBy': 'Ordered By',
  'labOrders.clinicalInformation': 'Clinical Information',
  'labOrders.clinicalInfo': 'Clinical Info',
  'labOrders.provisionalDiagnosis': 'Provisional Diagnosis',
  'labOrders.orderedTests': 'Ordered Tests',
  'labOrders.category': 'Category',
  'labOrders.specimen': 'Specimen',
  'labOrders.result': 'Result',
  'labOrders.enterResult': 'Enter Result',
  'labOrders.patientInformation': 'Patient Information',
  'labOrders.deleteConfirmTitle': 'Delete Lab Order?',
  'labOrders.deleteConfirmMessage': 'Are you sure you want to delete this lab order? This action cannot be undone.',
  'labOrders.notFound': 'Lab order not found',
  'labOrders.patient': 'Patient',
  'labOrders.selectPatient': 'Select Patient',
  'labOrders.selectTests': 'Select Tests',
  'labOrders.searchTests': 'Search tests...',
  'labOrders.selectedTests': 'Selected Tests',
  'labOrders.common': 'Common',
  'labOrders.turnaround': 'Turnaround',
  'labOrders.clinicalInfoPlaceholder': 'Enter clinical information, symptoms, or relevant medical history',
  'labOrders.diagnosisPlaceholder': 'Enter provisional diagnosis',
  'labOrders.specialInstructions': 'Special Instructions',
  'labOrders.instructionsPlaceholder': 'Enter any special instructions for the lab',
  'labOrders.orderSummary': 'Order Summary',
  'labOrders.totalTests': 'Total Tests',
  'labOrders.testsByCategory': 'Tests by Category',
  'labOrders.orderNote': 'Order will be sent to the laboratory once submitted',
  'labOrders.submitOrder': 'Submit Order',
  'labOrders.errors.selectPatient': 'Please select a patient',
  'labOrders.errors.selectTests': 'Please select at least one test',
  'labOrders.errors.clinicalInfoRequired': 'Clinical information is required',
  'labOrders.hematology': 'Hematology',
  'labOrders.chemistry': 'Chemistry',
  'labOrders.microbiology': 'Microbiology',
  'labOrders.immunology': 'Immunology',
  'labOrders.pathology': 'Pathology',
  'labOrders.radiology': 'Radiology',
  'labOrders.blood': 'Blood',
  'labOrders.urine': 'Urine',
  'labOrders.swab': 'Swab',
  'labOrders.stool': 'Stool',
  'labOrders.sputum': 'Sputum',
  'labOrders.tissue': 'Tissue',
  'labOrders.fluid': 'Fluid',
  'labOrders.normal': 'Normal',
  'labOrders.abnormal-high': 'High',
  'labOrders.abnormal-low': 'Low',
  'labOrders.critical': 'Critical',
  'common.print': 'Print',
  'common.download': 'Download',
  'common.contact': 'Contact',
  'common.by': 'by',
  'common.copy': 'Copy',

  // Lab Order Workflow
  'labOrders.timeline': 'Timeline',
  'labOrders.specimens': 'Specimens',
  'labOrders.specimenTracking': 'Specimen Tracking',
  'labOrders.addSpecimen': 'Add Specimen',
  'labOrders.noSpecimens': 'No specimens collected yet',
  'labOrders.specimenType': 'Type',
  'labOrders.collectedAt': 'Collected',
  'labOrders.collectedBy': 'Collected By',
  'labOrders.notes': 'Notes',
  'labOrders.printLabel': 'Print Label',
  'labOrders.showQR': 'Show QR',
  'labOrders.updateStatus': 'Update Status',
  'labOrders.specimen.collected': 'Collected',
  'labOrders.specimen.in-transit': 'In Transit',
  'labOrders.specimen.received': 'Received',
  'labOrders.specimen.processing': 'Processing',
  'labOrders.specimen.stored': 'Stored',
  'labOrders.specimen.discarded': 'Discarded',
  'labOrders.barcode': 'Barcode',
  'labOrders.barcodePlaceholder': 'Enter specimen barcode',
  'labOrders.selectSpecimenType': 'Select specimen type',
  'labOrders.collectionDateTime': 'Collection Date & Time',
  'labOrders.collectedByPlaceholder': 'Name of person who collected',
  'labOrders.location': 'Storage Location',
  'labOrders.locationPlaceholder': 'e.g., Lab Fridge A-1',
  'labOrders.temperature': 'Storage Temperature',
  'labOrders.temperaturePlaceholder': 'e.g., 4°C or Room Temperature',
  'labOrders.errors.barcodeRequired': 'Barcode is required',
  'labOrders.errors.specimenTypeRequired': 'Specimen type is required',
  'labOrders.errors.collectedByRequired': 'Collector name is required',
  'labOrders.printRequisition': 'Print Requisition',

  // Lab Order Events
  'labOrders.workflow.created': 'Created',
  'labOrders.workflow.ordered': 'Ordered',
  'labOrders.workflow.specimenCollected': 'Specimen Collected',
  'labOrders.workflow.specimenReceived': 'Specimen Received',
  'labOrders.workflow.processingStarted': 'Processing Started',
  'labOrders.workflow.resultEntered': 'Result Entered',
  'labOrders.workflow.resultVerified': 'Result Verified',
  'labOrders.workflow.reviewed': 'Reviewed',
  'labOrders.events.created': 'Order Created',
  'labOrders.events.ordered': 'Order Submitted',
  'labOrders.events.specimenCollected': 'Specimen Collected',
  'labOrders.events.specimenReceived': 'Specimen Received at Lab',
  'labOrders.events.processingStarted': 'Processing Started',
  'labOrders.events.resultEntered': 'Results Entered',
  'labOrders.events.resultVerified': 'Results Verified',
  'labOrders.events.reportGenerated': 'Report Generated',
  'labOrders.events.reviewed': 'Order Reviewed',
  'labOrders.events.amended': 'Order Amended',
  'labOrders.events.cancelled': 'Order Cancelled',

  // Lab Result Entry
  'labOrders.resultValue': 'Result Value',
  'labOrders.enterValue': 'Enter result value',
  'labOrders.referenceRange': 'Reference Range',
  'labOrders.referenceRangePlaceholder': 'e.g., 4.5-11.0',
  'labOrders.criticalValueAlert': 'Critical Value Alert',
  'labOrders.criticalRanges': 'Critical Ranges',
  'labOrders.criticalLow': 'Critical Low',
  'labOrders.criticalHigh': 'Critical High',
  'labOrders.resultNotes': 'Result Notes',
  'labOrders.resultNotesPlaceholder': 'Add any notes about this result...',
  'labOrders.testInformation': 'Test Information',
  'labOrders.specimenNotes': 'Specimen Notes',
  'labOrders.saveResult': 'Save Result',
  'labOrders.errors.resultRequired': 'Result value is required',
  'labOrders.reviewed': 'Reviewed',

  // Medical Record Form
  'records.visitTypes.routineCheckup': 'Routine Check-up',
  'records.visitTypes.followUp': 'Follow-up Visit',
  'records.visitTypes.sickVisit': 'Sick Visit',
  'records.visitTypes.physicalExam': 'Physical Examination',
  'records.visitTypes.consultation': 'Consultation',
  'records.visitTypes.emergency': 'Emergency Visit',
  'records.visitTypes.specialistReferral': 'Specialist Referral',
  'records.visitTypes.labReview': 'Lab Results Review',
  'records.visitTypes.vaccination': 'Vaccination',
  'records.visitTypes.procedure': 'Procedure',
  'records.patientVisitInfo': 'Patient & Visit Information',
  'records.clinicalFindings': 'Clinical Findings',
  // 'records.vitalSigns': 'Vital Signs', // DUPLICATE REMOVED
  'records.assessmentPlan': 'Assessment & Plan',
  // 'records.saveRecord': 'Save Record', // DUPLICATE REMOVED
  'records.updateRecord': 'Update Record',
  // 'records.chiefComplaint' — DUPLICATE REMOVED (defined earlier in this file)
  'records.chiefComplaintPlaceholder': 'Primary reason for the visit...',
  'records.symptoms': 'Symptoms',
  'records.symptomsPlaceholder': 'Detailed symptoms description...',
  // 'records.diagnosisPlaceholder': 'Clinical diagnosis...', // DUPLICATE REMOVED
  // 'records.treatmentPlaceholder': 'Treatment plan and procedures...', // DUPLICATE REMOVED
  'records.medicationsPlaceholder': 'Medications, dosages, and instructions...',
  'records.followUpPlaceholder': 'Follow-up care instructions...',
  // 'records.notesPlaceholder': 'Any additional notes or observations...', // DUPLICATE REMOVED
  'records.visitType': 'Visit Type',
  'records.selectVisitType': 'Select visit type',
  // 'records.patient': 'Patient', // DUPLICATE REMOVED
  // 'records.selectPatient': 'Select patient', // DUPLICATE REMOVED

  // Appointment Form
  'appointment.reasons.generalConsultation': 'General Consultation',
  'appointment.reasons.followUp': 'Follow-up',
  'appointment.reasons.physicalExam': 'Physical Exam',
  'appointment.reasons.vaccination': 'Vaccination',
  'appointment.reasons.labReview': 'Lab Results Review',
  'appointment.reasons.specialistReferral': 'Specialist Referral',
  'appointment.reasons.emergency': 'Emergency',
  'appointment.reasons.telemedicine': 'Telemedicine',
  'appointment.notesPlaceholder': 'Any additional notes or special instructions...',
  'appointment.updateAppointment': 'Update Appointment',
  'appointment.scheduleAppointment': 'Schedule Appointment',
  'appointment.selectPatient': 'Select patient',
  'appointment.selectReason': 'Select reason',

  // Patient Form
  'patient.allergiesPlaceholder': 'List any known allergies (e.g., Penicillin, Shellfish)...',
  'patient.medicationsPlaceholder': 'List current medications with dosages...',
  'patient.emergencyContactPlaceholder': 'Emergency contact name',
  'patient.emergencyPhonePlaceholder': 'Emergency contact phone',
  'patient.savePatient': 'Save Patient',
  'patient.updatePatient': 'Update Patient',
  'patient.selectGender': 'Select gender',
  'patient.selectBloodType': 'Select blood type',
  'patient.namePlaceholder': 'John Doe',
  'patient.emailPlaceholder': 'john.doe@example.com',
  'patient.phonePlaceholder': '+1 (555) 000-0000',
  'patient.addressPlaceholder': '123 Main St, City, State 12345',

  // Patient validation messages
  'patients.validation.nameRequired': 'Name is required',
  'patients.validation.emailRequired': 'Email is required',
  'patients.validation.emailInvalid': 'Invalid email address',
  'patients.validation.phoneRequired': 'Phone number is required',
  'patients.validation.dateOfBirthRequired': 'Date of birth is required',

  // Common placeholders
  'common.currentUser': 'Current User',
  'common.labTech': 'Lab Tech',
  'common.labSystem': 'Lab System',
  'common.patient': 'Patient',
  'common.nurse': 'Nurse',
  'common.doctor': 'Doctor',
  'common.poweredByMAIE': 'Powered by {{aiProvider}}',

  // ADT Module
  'adt.title': 'Admission, Discharge & Transfer',
  'adt.subtitle': 'Manage patient admissions, discharges, and transfers',

  // ADT Tabs
  'adt.tabs.overview': 'Overview',
  'adt.tabs.admissions': 'Admissions',
  'adt.tabs.discharges': 'Discharges',
  'adt.tabs.transfers': 'Transfers',
  'adt.tabs.beds': 'Bed Management',

  // ADT Overview
  'adt.overview.currentOccupancy': 'Current Occupancy',
  'adt.overview.bedUtilization': 'Bed Utilization',
  'adt.overview.todaysAdmissions': "Today's Admissions",
  'adt.overview.avgLengthOfStay': 'Average Length of Stay',
  'adt.overview.days': 'days',
  'adt.overview.wardOccupancy': 'Ward Occupancy',
  'adt.overview.recentAdmissions': 'Recent Admissions',
  'adt.overview.pendingActions': 'Pending Actions',
  'adt.overview.pendingDischarges': '{{count}} patients ready for discharge',
  'adt.overview.scheduledTransfers': '{{count}} transfers scheduled',

  // ADT Filter & Search
  'adt.filter.all': 'All',
  'adt.filter.active': 'Active',
  'adt.filter.pending': 'Pending',
  'adt.admissions.searchPlaceholder': 'Search by patient name or ID...',

  // ADT Status
  'adt.status.pending': 'Pending',
  'adt.status.active': 'Active',
  'adt.status.discharged': 'Discharged',
  'adt.status.transferred': 'Transferred',

  // ADT Actions
  'adt.actions.discharge': 'Discharge',
  'adt.actions.transfer': 'Transfer',

  // Admission
  'adt.admissions.newAdmission': 'New Admission',
  'adt.admissions.patient': 'Patient',
  'adt.admissions.admissionDate': 'Admission Date',
  'adt.admissions.type': 'Type',
  'adt.admissions.location': 'Location',
  'adt.admissions.status': 'Status',
  'adt.admission.patientInformation': 'Patient Information',
  'adt.admission.patient': 'Patient',
  'adt.admission.selectPatient': 'Select patient',
  'adt.admission.date': 'Admission Date',
  'adt.admission.time': 'Admission Time',
  'adt.admission.admittingPhysician': 'Admitting Physician',
  'adt.admission.physicianPlaceholder': 'Enter physician name',
  'adt.admission.admissionType': 'Admission Type',
  'adt.admission.types.emergency': 'Emergency',
  'adt.admission.types.elective': 'Elective',
  'adt.admission.types.transfer': 'Transfer',
  'adt.admission.chiefComplaint': 'Chief Complaint',
  'adt.admission.chiefComplaintPlaceholder': 'Primary reason for admission...',
  'adt.admission.provisionalDiagnosis': 'Provisional Diagnosis',
  'adt.admission.diagnosisPlaceholder': 'Initial diagnosis if available...',
  'adt.admission.bedAssignment': 'Bed Assignment',
  'adt.admission.ward': 'Ward',
  'adt.admission.selectWard': 'Select ward',
  'adt.admission.room': 'Room',
  'adt.admission.selectRoom': 'Select room',
  'adt.admission.bed': 'Bed',
  'adt.admission.bedsAvailable': 'beds available',
  'adt.admission.selectedBed': 'Selected Bed',
  'adt.admission.insuranceVerification': 'Insurance Verification',
  'adt.admission.insuranceProvider': 'Insurance Provider',
  'adt.admission.insuranceProviderPlaceholder': 'Enter insurance provider name',
  'adt.admission.policyNumber': 'Policy Number',
  'adt.admission.policyNumberPlaceholder': 'Enter policy number',
  'adt.admission.verifyInsurance': 'Verify Insurance',
  'adt.admission.verifying': 'Verifying...',
  'adt.admission.verified': 'Verified',
  'adt.admission.insuranceVerifiedMessage': 'Insurance has been verified successfully',
  'adt.admission.admissionOrders': 'Admission Orders',
  'adt.admission.orderPlaceholder': 'Enter admission order...',
  'adt.admission.confirmAndNotify': 'Confirm & Notify',
  'adt.admission.admissionSummary': 'Admission Summary',
  'adt.admission.dateTime': 'Date/Time',
  'adt.admission.assignedBed': 'Assigned Bed',
  'adt.admission.insurance': 'Insurance',
  'adt.admission.notifyDepartments': 'Notify Departments',
  'adt.admission.wristbandReminder': 'Remember to print patient wristband after admission',
  'adt.admission.completeAdmission': 'Complete Admission',

  // Ward Types
  'adt.ward.types.icu': 'ICU',
  'adt.ward.types.general': 'General',
  'adt.ward.types.emergency': 'Emergency',
  'adt.ward.types.pediatric': 'Pediatric',
  'adt.ward.types.maternity': 'Maternity',
  'adt.ward.types.surgical': 'Surgical',

  // Room Types
  'adt.room.types.private': 'Private',
  'adt.room.types.semi_private': 'Semi-Private',
  'adt.room.types.ward': 'Ward',

  // Departments
  'adt.departments.nursing': 'Nursing',
  'adt.departments.dietary': 'Dietary',
  'adt.departments.housekeeping': 'Housekeeping',
  'adt.departments.pharmacy': 'Pharmacy',
  'adt.departments.lab': 'Laboratory',

  // Validation
  'adt.validation.patientRequired': 'Please select a patient',
  'adt.validation.physicianRequired': 'Physician name is required',
  'adt.validation.chiefComplaintRequired': 'Chief complaint is required',
  'adt.validation.wardRequired': 'Please select a ward',
  'adt.validation.roomRequired': 'Please select a room',
  'adt.validation.bedRequired': 'Please select a bed',
  'adt.validation.insuranceNotVerified': 'Insurance must be verified before admission',

  // Discharge
  'adt.discharges.patient': 'Patient',
  'adt.discharges.dischargeDate': 'Discharge Date',
  'adt.discharges.type': 'Type',
  'adt.discharges.status': 'Status',
  'adt.discharge.dischargeSummary': 'Discharge Summary',
  'adt.discharge.admissionDate': 'Admission Date',
  'adt.discharge.date': 'Discharge Date',
  'adt.discharge.time': 'Discharge Time',
  'adt.discharge.dischargingPhysician': 'Discharging Physician',
  'adt.discharge.physicianPlaceholder': 'Enter physician name',
  'adt.discharge.dischargeType': 'Discharge Type',
  'adt.discharge.types.home': 'Home',
  'adt.discharge.types.transfer': 'Transfer',
  'adt.discharge.types.ama': 'AMA (Against Medical Advice)',
  'adt.discharge.types.expired': 'Expired',
  'adt.discharge.types.other': 'Other',
  'adt.discharge.summary': 'Discharge Summary',
  'adt.discharge.summaryPlaceholder': 'Enter discharge summary including diagnosis, treatment provided, and patient condition...',
  'adt.discharge.medicationReconciliation': 'Medication Reconciliation',
  'adt.discharge.homeMedications': 'Home Medications',
  'adt.discharge.medicationName': 'Medication Name',
  'adt.discharge.dosage': 'Dosage',
  'adt.discharge.frequency': 'Frequency',
  'adt.discharge.duration': 'Duration',
  'adt.discharge.specialInstructions': 'Special Instructions',
  'adt.discharge.addMedication': 'Add Medication',
  'adt.discharge.confirmMedicationReconciliation': 'I confirm medication reconciliation has been completed',
  'adt.discharge.followUpAppointments': 'Follow-up Appointments',
  'adt.discharge.specialty': 'Specialty',
  'adt.discharge.physicianName': 'Physician Name',
  'adt.discharge.appointmentNotes': 'Appointment Notes',
  'adt.discharge.addAppointment': 'Add Appointment',
  'adt.discharge.with': 'with',
  'adt.discharge.patientInstructions': 'Patient Instructions',
  'adt.discharge.dischargeInstructions': 'Discharge Instructions',
  'adt.discharge.instructionsPlaceholder': 'Enter detailed discharge instructions for the patient...',
  'adt.discharge.patientEducation': 'Patient Education',
  'adt.discharge.educationTopicPlaceholder': 'Enter education topic',
  'adt.discharge.printInstructions': 'Print Instructions',
  'adt.discharge.downloadPDF': 'Download PDF',
  'adt.discharge.billingAndFinalSteps': 'Billing & Final Steps',
  'adt.discharge.billingSummary': 'Billing Summary',
  'adt.discharge.totalCharges': 'Total Charges',
  'adt.discharge.insuranceCovered': 'Insurance Covered',
  'adt.discharge.patientResponsibility': 'Patient Responsibility',
  'adt.discharge.billingCompleted': 'Billing has been completed',
  'adt.discharge.finalChecklist': 'Final Checklist',
  'adt.discharge.checklist.medicationReconciliation': 'Medication reconciliation completed',
  'adt.discharge.checklist.followUpScheduled': 'Follow-up appointments scheduled',
  'adt.discharge.checklist.instructionsProvided': 'Discharge instructions provided',
  'adt.discharge.checklist.belongingsReturned': 'Patient belongings returned',
  'adt.discharge.completeDischarge': 'Complete Discharge',
  'adt.discharge.status.planned': 'Planned',
  'adt.discharge.status.in_progress': 'In Progress',
  'adt.discharge.status.completed': 'Completed',

  // Discharge Validation
  'adt.discharge.validation.physicianRequired': 'Discharging physician is required',
  'adt.discharge.validation.summaryRequired': 'Discharge summary is required',
  'adt.discharge.validation.medicationReconciliationRequired': 'Medication reconciliation must be completed',
  'adt.discharge.validation.followUpRequired': 'At least one follow-up appointment is required',
  'adt.discharge.validation.instructionsRequired': 'Discharge instructions are required',
  'adt.discharge.validation.billingRequired': 'Billing must be completed before discharge',

  // Transfer
  'adt.transfers.patient': 'Patient',
  'adt.transfers.type': 'Type',
  'adt.transfers.from': 'From',
  'adt.transfers.to': 'To',
  'adt.transfers.scheduledTime': 'Scheduled Time',
  'adt.transfers.status': 'Status',
  'adt.transfer.transferRequest': 'Transfer Request',
  'adt.transfer.patientInfo': 'Patient Information',
  'adt.transfer.patientId': 'Patient ID',
  'adt.transfer.currentLocation': 'Current Location',
  'adt.transfer.room': 'Room',
  'adt.transfer.bed': 'Bed',
  'adt.transfer.transferType': 'Transfer Type',
  'adt.transfer.types.inter_unit': 'Inter-unit Transfer',
  'adt.transfer.types.inter_facility': 'Inter-facility Transfer',
  'adt.transfer.requestDate': 'Request Date',
  'adt.transfer.requestTime': 'Request Time',
  'adt.transfer.requestedBy': 'Requested By',
  'adt.transfer.requestedByPlaceholder': 'Enter name of requesting staff',
  'adt.transfer.reason': 'Reason for Transfer',
  'adt.transfer.reasonPlaceholder': 'Enter detailed reason for transfer...',
  'adt.transfer.destinationUnit': 'Destination Unit',
  'adt.transfer.destinationFacility': 'Destination Facility',
  'adt.transfer.destinationWard': 'Destination Ward',
  'adt.transfer.selectWard': 'Select destination ward',
  'adt.transfer.destinationRoom': 'Destination Room',
  'adt.transfer.selectRoom': 'Select destination room',
  'adt.transfer.destinationBed': 'Destination Bed',
  'adt.transfer.bedsAvailable': 'beds available',
  'adt.transfer.facilityName': 'Facility Name',
  'adt.transfer.facilityNamePlaceholder': 'Enter destination facility name',
  'adt.transfer.facilityAddress': 'Facility Address',
  'adt.transfer.facilityAddressPlaceholder': 'Enter complete facility address',
  'adt.transfer.facilityContact': 'Facility Contact',
  'adt.transfer.facilityContactPlaceholder': 'Enter contact phone/email',
  'adt.transfer.scheduledTransferTime': 'Scheduled Transfer Time',
  'adt.transfer.transferDate': 'Transfer Date',
  'adt.transfer.transferTime': 'Transfer Time',
  'adt.transfer.handoffDocumentation': 'Handoff Documentation',
  'adt.transfer.currentVitalSigns': 'Current Vital Signs',
  'adt.transfer.bloodPressure': 'Blood Pressure',
  'adt.transfer.temperature': 'Temperature',
  'adt.transfer.heartRate': 'Heart Rate',
  'adt.transfer.respiratoryRate': 'Respiratory Rate',
  'adt.transfer.oxygenSaturation': 'O2 Saturation',
  'adt.transfer.currentMedications': 'Current Medications',
  'adt.transfer.medicationPlaceholder': 'Enter medication name and dosage',
  'adt.transfer.allergies': 'Allergies',
  'adt.transfer.allergyPlaceholder': 'Enter allergy',
  'adt.transfer.specialInstructions': 'Special Instructions',
  'adt.transfer.specialInstructionsPlaceholder': 'Enter any special care instructions...',
  'adt.transfer.additionalNotes': 'Additional Notes',
  'adt.transfer.additionalNotesPlaceholder': 'Any additional transfer notes...',
  'adt.transfer.transportAndApproval': 'Transport & Approval',
  'adt.transfer.transportMode': 'Transport Mode',
  'adt.transfer.transportModes.wheelchair': 'Wheelchair',
  'adt.transfer.transportModes.stretcher': 'Stretcher',
  'adt.transfer.transportModes.ambulance': 'Ambulance',
  'adt.transfer.transportModes.air_ambulance': 'Air Ambulance',
  'adt.transfer.escortRequired': 'Escort Required',
  'adt.transfer.escortType': 'Escort Type',
  'adt.transfer.escortTypes.nurse': 'Nurse',
  'adt.transfer.escortTypes.physician': 'Physician',
  'adt.transfer.escortTypes.paramedic': 'Paramedic',
  'adt.transfer.approvalStatus': 'Approval Status',
  'adt.transfer.approvalPending': 'Transfer approval is pending',
  'adt.transfer.requestApproval': 'Request Approval',
  'adt.transfer.approvalGranted': 'Transfer Approved',
  'adt.transfer.approvedBy': 'Approved by {{name}}',
  'adt.transfer.transferSummary': 'Transfer Summary',
  'adt.transfer.scheduledFor': 'Scheduled For',
  'adt.transfer.completeTransfer': 'Complete Transfer',
  'adt.transfer.status.requested': 'Requested',
  'adt.transfer.status.approved': 'Approved',
  'adt.transfer.status.in_transit': 'In Transit',
  'adt.transfer.status.completed': 'Completed',
  'adt.transfer.status.cancelled': 'Cancelled',

  // Transfer Validation
  'adt.transfer.validation.requestedByRequired': 'Requested by field is required',
  'adt.transfer.validation.reasonRequired': 'Transfer reason is required',
  'adt.transfer.validation.wardRequired': 'Destination ward is required',
  'adt.transfer.validation.roomRequired': 'Destination room is required',
  'adt.transfer.validation.bedRequired': 'Destination bed is required',
  'adt.transfer.validation.facilityNameRequired': 'Facility name is required',
  'adt.transfer.validation.facilityAddressRequired': 'Facility address is required',
  'adt.transfer.validation.facilityContactRequired': 'Facility contact is required',
  'adt.transfer.validation.vitalSignsRequired': 'Vital signs documentation is required',
  'adt.transfer.validation.instructionsRequired': 'Special instructions are required',
  'adt.transfer.validation.escortTypeRequired': 'Escort type must be selected',
  'adt.transfer.validation.approvalRequired': 'Transfer must be approved before proceeding',

  // Bed Management
  'adt.beds.occupied': 'occupied',
  'adt.beds.room': 'Room',
  'adt.beds.status.available': 'Available',
  'adt.beds.status.occupied': 'Occupied',
  'adt.beds.status.maintenance': 'Maintenance',
  'adt.beds.status.cleaning': 'Cleaning',

  // CPOE (Computerized Physician Order Entry)
  'cpoe.title': 'Order Management',
  'cpoe.subtitle': 'Manage medication, laboratory, and imaging orders',
  'cpoe.indication': 'Indication',
  'cpoe.dosage.amount': 'Dosage Amount',
  'cpoe.dosage.unit': 'Unit',
  'cpoe.route': 'Route',
  'cpoe.frequency': 'Frequency',
  'cpoe.prnReason': 'PRN Reason',
  'cpoe.startDate': 'Start Date',
  'cpoe.duration.label': 'Duration',
  'cpoe.duration.unit': 'Duration Unit',
  'cpoe.priority': 'Priority',
  'cpoe.notes': 'Notes',
  'cpoe.submitOrder': 'Submit Order',
  'cpoe.orderDetails': 'Order Details',

  // CPOE Routes
  'cpoe.routes.oral': 'Oral',
  'cpoe.routes.iv': 'Intravenous',
  'cpoe.routes.im': 'Intramuscular',
  'cpoe.routes.sc': 'Subcutaneous',
  'cpoe.routes.sl': 'Sublingual',
  'cpoe.routes.topical': 'Topical',
  'cpoe.routes.inhalation': 'Inhalation',
  'cpoe.routes.rectal': 'Rectal',

  // CPOE Frequencies
  'cpoe.frequencies.once': 'Once',
  'cpoe.frequencies.bid': 'Twice daily',
  'cpoe.frequencies.tid': 'Three times daily',
  'cpoe.frequencies.qid': 'Four times daily',
  'cpoe.frequencies.q4h': 'Every 4 hours',
  'cpoe.frequencies.q6h': 'Every 6 hours',
  'cpoe.frequencies.q8h': 'Every 8 hours',
  'cpoe.frequencies.q12h': 'Every 12 hours',
  'cpoe.frequencies.qhs': 'At bedtime',
  'cpoe.frequencies.prn': 'As needed',
  'cpoe.frequencies.ac': 'Before meals',
  'cpoe.frequencies.pc': 'After meals',

  // CPOE Priorities
  'cpoe.priorities.routine': 'Routine',
  'cpoe.priorities.urgent': 'Urgent',
  'cpoe.priorities.stat': 'STAT',

  // CPOE Medication
  'cpoe.medication.search': 'Search Medication',
  'cpoe.medication.searchPlaceholder': 'Search by drug name...',

  // CPOE Dosage Calculator
  'cpoe.dosageCalculator.title': 'Dosage Calculator',
  'cpoe.dosageCalculator.toggle': 'Calculate Dose',
  'cpoe.dosageCalculator.patientWeight': 'Patient Weight',
  'cpoe.dosageCalculator.patientAge': 'Patient Age',
  'cpoe.dosageCalculator.standard': 'Standard Dose',
  'cpoe.dosageCalculator.loading': 'Loading Dose',
  'cpoe.dosageCalculator.calculated': 'Calculated Dose',
  'cpoe.dosageCalculator.weightRequired': 'Patient weight is required for dose calculation',

  // CPOE Clinical Alerts
  'cpoe.alerts.title': 'Clinical Decision Support Alerts',
  'cpoe.alerts.interaction': 'Drug Interaction',
  'cpoe.alerts.allergy': 'Allergy Alert',
  'cpoe.alerts.dosing': 'Dosing Alert',
  'cpoe.alerts.recommendation': 'Recommendation',
  'cpoe.alerts.reaction': 'Reaction',
  'cpoe.alerts.suggestedDose': 'Suggested Dose',
  'cpoe.alerts.acknowledge': 'Acknowledge and Continue',

  // CPOE Order Status
  'cpoe.status.draft': 'Draft',
  'cpoe.status.pending': 'Pending',
  'cpoe.status.active': 'Active',
  'cpoe.status.on-hold': 'On Hold',
  'cpoe.status.discontinued': 'Discontinued',
  'cpoe.status.completed': 'Completed',
  'cpoe.status.cancelled': 'Cancelled',
  'cpoe.status.expired': 'Expired',

  // CPOE Order Types
  'cpoe.orderType.medication': 'Medication',
  'cpoe.orderType.laboratory': 'Laboratory',
  'cpoe.orderType.imaging': 'Imaging',
  'cpoe.orderType.procedure': 'Procedure',
  'cpoe.orderType.diet': 'Diet',
  'cpoe.orderType.activity': 'Activity',
  'cpoe.orderType.nursing': 'Nursing',

  // CPOE Imaging
  'cpoe.imaging.modality': 'Modality',
  'cpoe.imaging.examType': 'Exam Type',
  'cpoe.imaging.anatomicalRegion': 'Anatomical Region',
  'cpoe.imaging.contrast': 'Contrast Required',
  'cpoe.imaging.sedation': 'Sedation Required',
  'cpoe.imaging.transport': 'Transportation Type',
  'cpoe.imaging.isolation': 'Isolation Required',
  'cpoe.imaging.pregnancyStatus': 'Pregnancy Status',
  'cpoe.imaging.safetyScreening': 'Safety Screening',

  // CPOE Imaging Modalities
  'cpoe.imaging.modalities.xray': 'X-Ray',
  'cpoe.imaging.modalities.ct': 'CT Scan',
  'cpoe.imaging.modalities.mri': 'MRI',
  'cpoe.imaging.modalities.ultrasound': 'Ultrasound',
  'cpoe.imaging.modalities.nuclear': 'Nuclear Medicine',
  'cpoe.imaging.modalities.pet': 'PET Scan',
  'cpoe.imaging.modalities.mammography': 'Mammography',
  'cpoe.imaging.modalities.fluoroscopy': 'Fluoroscopy',

  // CPOE Order Sets
  'cpoe.orderSets.title': 'Order Sets',
  'cpoe.orderSets.admission': 'Admission Orders',
  'cpoe.orderSets.postOp': 'Post-Operative Orders',
  'cpoe.orderSets.diseaseSpecific': 'Disease-Specific',
  'cpoe.orderSets.personal': 'Personal Order Sets',
  'cpoe.orderSets.create': 'Create Order Set',
  'cpoe.orderSets.apply': 'Apply Order Set',

  // CPOE Actions & Messages
  'cpoe.newOrder': 'New Order',
  'cpoe.noOrders': 'No orders found for this patient',

  // E-Prescribing
  'eprescribing.title': 'Electronic Prescribing',
  'eprescribing.prescriptions': 'Prescriptions',
  'eprescribing.viewPrescriptions': 'Click "View All" to see all prescriptions for this patient',
  'eprescribing.newPrescription': 'New Prescription',
  'eprescribing.prescriptionDetails': 'Prescription Details',
  'eprescribing.prescriptionHistory': 'Prescription History',
  'eprescribing.activePrescriptions': 'Active Prescriptions',
  'eprescribing.searchMedication': 'Search medication...',
  'eprescribing.selectPharmacy': 'Select Pharmacy',
  'eprescribing.searchPharmacy': 'Search pharmacy...',
  'eprescribing.preferredPharmacy': 'Preferred Pharmacy',

  // E-Prescribing Steps
  'eprescribing.step.medication': 'Medication',
  'eprescribing.step.dosage': 'Dosage',
  'eprescribing.step.pharmacy': 'Pharmacy',
  'eprescribing.step.review': 'Review',

  // Prescription Status
  'eprescribing.status.draft': 'Draft',
  'eprescribing.status.pending-signature': 'Pending Signature',
  'eprescribing.status.signed': 'Signed',
  'eprescribing.status.transmitted': 'Transmitted',
  'eprescribing.status.received-by-pharmacy': 'Received by Pharmacy',
  'eprescribing.status.in-progress': 'In Progress',
  'eprescribing.status.ready-for-pickup': 'Ready for Pickup',
  'eprescribing.status.dispensed': 'Dispensed',
  'eprescribing.status.cancelled': 'Cancelled',
  'eprescribing.status.declined': 'Declined',
  'eprescribing.status.expired': 'Expired',
  'eprescribing.status.discontinued': 'Discontinued',

  // DEA Schedule
  'eprescribing.schedule.I': 'Schedule I',
  'eprescribing.schedule.II': 'Schedule II',
  'eprescribing.schedule.III': 'Schedule III',
  'eprescribing.schedule.IV': 'Schedule IV',
  'eprescribing.schedule.V': 'Schedule V',
  'eprescribing.schedule.Non-Controlled': 'Non-Controlled',

  // Dosage Instructions
  'eprescribing.dosage': 'Dosage',
  'eprescribing.route': 'Route',
  'eprescribing.frequency': 'Frequency',
  'eprescribing.duration': 'Duration',
  'eprescribing.quantity': 'Quantity',
  'eprescribing.daysSupply': 'Days Supply',
  'eprescribing.refills': 'Refills',
  'eprescribing.refillsRemaining': 'Refills Remaining',
  'eprescribing.substitutionAllowed': 'Substitution Allowed',
  'eprescribing.dispenseAsWritten': 'Dispense As Written',
  'eprescribing.additionalInstructions': 'Additional Instructions',

  // Actions
  'eprescribing.signPrescription': 'Sign Prescription',
  'eprescribing.transmitToPharmacy': 'Transmit to Pharmacy',
  'eprescribing.cancelPrescription': 'Cancel Prescription',
  'eprescribing.renewPrescription': 'Renew Prescription',
  'eprescribing.modifyPrescription': 'Modify Prescription',
  'eprescribing.viewHistory': 'View History',
  'eprescribing.checkPMP': 'Check PMP',
  'eprescribing.checkInteractions': 'Check Interactions',

  // Controlled Substances
  'eprescribing.controlledSubstance': 'Controlled Substance',
  'eprescribing.deaNumber': 'DEA Number',
  'eprescribing.pmpCheck': 'PMP Check',
  'eprescribing.pmpRequired': 'PMP check required for controlled substances',
  'eprescribing.pmpCompleted': 'PMP check completed',
  'eprescribing.narcoticsAgreement': 'Narcotics Agreement',
  'eprescribing.narcoticsAgreementRequired': 'Narcotics agreement required',

  // Refills
  'eprescribing.refill.request': 'Refill Request',
  'eprescribing.refill.approve': 'Approve Refill',
  'eprescribing.refill.deny': 'Deny Refill',
  'eprescribing.refill.pending': 'Pending Refill Requests',
  'eprescribing.refill.noRefills': 'No refills remaining',
  'eprescribing.refill.refillsAvailable': 'refills available',

  // Prior Authorization
  'eprescribing.priorAuth.required': 'Prior Authorization Required',
  'eprescribing.priorAuth.status': 'PA Status',
  'eprescribing.priorAuth.pending': 'Pending',
  'eprescribing.priorAuth.approved': 'Approved',
  'eprescribing.priorAuth.denied': 'Denied',
  'eprescribing.priorAuth.authNumber': 'Authorization Number',

  // Pharmacy Information
  'eprescribing.pharmacy.name': 'Pharmacy Name',
  'eprescribing.pharmacy.address': 'Address',
  'eprescribing.pharmacy.phone': 'Phone',
  'eprescribing.pharmacy.hours': 'Hours',
  'eprescribing.pharmacy.capabilities': 'Capabilities',
  'eprescribing.pharmacy.eprescribing': 'E-Prescribing',
  'eprescribing.pharmacy.controlledSubstances': 'Controlled Substances',
  'eprescribing.pharmacy.delivery': 'Delivery Available',
  'eprescribing.pharmacy.twentyFourHour': '24-Hour',

  // Messages
  'eprescribing.messages.signatureRequired': 'Electronic signature required',
  'eprescribing.messages.transmissionSuccess': 'Prescription transmitted successfully',
  'eprescribing.messages.transmissionFailed': 'Prescription transmission failed',
  'eprescribing.messages.validationError': 'Please correct the errors before proceeding',
  'eprescribing.messages.pmpCheckRequired': 'PMP check required before signing',
  'eprescribing.messages.noMedicationSelected': 'Please select a medication',
  'eprescribing.messages.noPharmacySelected': 'Please select a pharmacy',
  'eprescribing.messages.prescriptionCreated': 'Prescription created successfully',
  'eprescribing.messages.prescriptionCancelled': 'Prescription cancelled',
  'eprescribing.messages.refillApproved': 'Refill approved and transmitted',
  'eprescribing.messages.refillDenied': 'Refill request denied',

  // Interactions
  'eprescribing.interactions.title': 'Drug Interactions',
  'eprescribing.interactions.severity.minor': 'Minor',
  'eprescribing.interactions.severity.moderate': 'Moderate',
  'eprescribing.interactions.severity.major': 'Major',
  'eprescribing.interactions.severity.contraindicated': 'Contraindicated',
  'eprescribing.interactions.override': 'Override Interaction',
  'eprescribing.interactions.overrideReason': 'Override Reason',

  // Refill Requests Page
  'eprescribing.refillRequests': 'Refill Requests',
  'eprescribing.refillRequestsDescription': 'Review and manage prescription refill requests',
  'eprescribing.pendingRequests': 'Pending Requests',
  'eprescribing.approvedToday': 'Approved Today',
  'eprescribing.deniedRequests': 'Denied Requests',
  'eprescribing.searchRefills': 'Search by medication, patient, or pharmacy...',
  'eprescribing.noRefillRequests': 'No refill requests found',
  'eprescribing.approve': 'Approve',
  'eprescribing.deny': 'Deny',
  'eprescribing.requestedDate': 'Requested Date',
  'eprescribing.neededBy': 'Needed By',
  'eprescribing.requestedBy': 'Requested By',
  'eprescribing.processedDate': 'Processed Date',
  'eprescribing.denialReason': 'Denial Reason',
  'eprescribing.denyRefillRequest': 'Deny Refill Request',
  'eprescribing.denyRefillDescription': 'Please provide a reason for denying this refill request.',
  'eprescribing.enterDenialReason': 'Enter denial reason...',
  'eprescribing.denyRefill': 'Deny Refill',
  'eprescribing.viewOriginalPrescription': 'View Original Prescription',
  'eprescribing.originalPrescription': 'Original Prescription',
  'eprescribing.overdue': 'Overdue',
  'eprescribing.urgent': 'Urgent',
  'eprescribing.refillsAuthorized': 'Refills Authorized',
  'eprescribing.quantityDispensed': 'Quantity Dispensed',
  'eprescribing.writtenDate': 'Written Date',
  'eprescribing.prescriptionNumber': 'Prescription Number',

  // Refill Status
  'eprescribing.refillStatus.pending': 'Pending',
  'eprescribing.refillStatus.approved': 'Approved',
  'eprescribing.refillStatus.denied': 'Denied',
  'eprescribing.refillStatus.cancelled': 'Cancelled',

  // CPOE Integration
  'eprescribing.createPrescription': 'Create E-Prescription',
  'eprescribing.fromMedicationOrder': 'From medication order',
  'eprescribing.readyToTransmit': 'Ready to transmit',
  'eprescribing.orderWillConvert': 'This medication order will be converted to an electronic prescription and transmitted to the pharmacy.',
  'eprescribing.nextSteps': 'What happens next?',
  'eprescribing.step.selectPharmacy': 'Select patient\'s pharmacy',
  'eprescribing.step.reviewDetails': 'Review prescription details',
  'eprescribing.step.signPrescription': 'Sign prescription electronically',
  'eprescribing.step.transmitToPharmacy': 'Transmit to pharmacy',
  'eprescribing.proceedToPrescription': 'Proceed to E-Prescription',
  'cpoe.sendAsEPrescription': 'Send as E-Prescription',

  // Common Additions (new keys only)
  'common.showLess': 'Show Less',
  'common.pharmacy': 'Pharmacy',
  'common.provider': 'Provider',

  // Authentication
  'auth.welcome': 'Welcome to {{hospitalName}} EMR',
  'auth.forgotPassword': 'Forgot your password?',

  // Authentication Errors
  'auth.errors.invalidCredentials': 'Invalid username or password',
  'auth.errors.accountLocked': 'Account is locked. Please contact administrator.',
  'auth.errors.accountInactive': 'Account is inactive. Please contact administrator.',

  // User Management
  'users.title': 'User Management',
  'users.subtitle': 'Manage system users and permissions',
  'users.addUser': 'Add User',
  'users.editUser': 'Edit User',
  'users.userDetails': 'User Details',
  'users.searchUsers': 'Search users...',
  'users.filterByRole': 'Filter by Role',
  'users.filterByDepartment': 'Filter by Department',
  'users.filterByStatus': 'Filter by Status',
  'users.allRoles': 'All Roles',
  'users.allDepartments': 'All Departments',
  'users.allStatuses': 'All Statuses',

  // User Roles
  'roles.super_admin': 'Super Administrator',
  'roles.admin': 'Administrator',
  'roles.doctor': 'Doctor',
  'roles.nurse': 'Nurse',
  'roles.pharmacist': 'Pharmacist',
  'roles.lab_tech': 'Lab Technician',
  'roles.radiologist': 'Radiologist',
  'roles.billing_staff': 'Billing Staff',
  'roles.receptionist': 'Receptionist',
  'roles.security': 'Security',
  'roles.it_support': 'IT Support',
  'roles.department_head': 'Department Head',
  'roles.case_manager': 'Case Manager',
  'roles.social_worker': 'Social Worker',

  // User Status
  'userStatus.active': 'Active',
  'userStatus.inactive': 'Inactive',
  'userStatus.suspended': 'Suspended',
  'userStatus.pending': 'Pending',
  // Pharmacy Module
  'pharmacy.dashboard.title': 'Pharmacy Dashboard',
  'pharmacy.dashboard.subtitle': 'Medication order management and verification',
  'pharmacy.dashboard.newOrder': 'New Order',
  'pharmacy.dashboard.searchOrders': 'Search orders, patients, medications...',
  'pharmacy.dashboard.totalOrders': 'Total Orders',
  'pharmacy.dashboard.pendingVerification': 'Pending Verification',
  'pharmacy.dashboard.avgProcessingTime': 'Avg Processing Time',
  'pharmacy.dashboard.criticalInteractions': 'Critical Interactions',
  'pharmacy.dashboard.today': 'Today',
  'pharmacy.dashboard.requiresAction': 'Requires action',
  'pharmacy.dashboard.improving': '12% faster',
  'pharmacy.dashboard.needsAttention': 'Needs attention',

  // Pharmacy Orders
  'pharmacy.orders.title': 'Medication Orders',
  'pharmacy.orders.patient': 'Patient',
  'pharmacy.orders.medication': 'Medication',
  'pharmacy.orders.dose': 'Dose',
  'pharmacy.orders.priority': 'Priority',
  'pharmacy.orders.status': 'Status',
  'pharmacy.orders.orderDate': 'Order Date',
  'pharmacy.orders.noOrders': 'No medication orders',
  'pharmacy.orders.noOrdersDescription': 'No medication orders match your current filters',

  // Pharmacy Status
  'pharmacy.status.pending': 'Pending',
  'pharmacy.status.verified': 'Verified',
  'pharmacy.status.dispensed': 'Dispensed',
  'pharmacy.status.administered': 'Administered',
  'pharmacy.status.discontinued': 'Discontinued',
  'pharmacy.status.cancelled': 'Cancelled',

  // Pharmacy Priority
  'pharmacy.priority.stat': 'STAT',
  'pharmacy.priority.urgent': 'Urgent',
  'pharmacy.priority.routine': 'Routine',

  // Pharmacy Actions
  'pharmacy.actions.verify': 'Verify',
  'pharmacy.actions.dispense': 'Dispense',
  'pharmacy.actions.cancel': 'Cancel',

  // Pharmacy Filters
  'pharmacy.filters.allStatuses': 'All Statuses',
  'pharmacy.filters.allPriorities': 'All Priorities',

  // Pharmacy Search
  'pharmacy.search.placeholder': 'Search medications, patients, providers...',

  // Pharmacy Alerts
  'pharmacy.alerts.title': 'Pharmacy Alerts',
  'pharmacy.alerts.lowStock': 'medications are below reorder point',
  'pharmacy.alerts.expiring': 'medications are expiring soon',

  // Pharmacy Metrics
  'pharmacy.metrics.dailyOrders': 'Daily Orders',
  'pharmacy.metrics.pendingOrders': 'Pending Orders',
  'pharmacy.metrics.avgProcessingTime': 'Avg Processing Time',
  'pharmacy.metrics.productivity': 'Productivity',

  // Medication Administration Record (MAR)
  'pharmacy.mar.title': 'Medication Administration Record',
  'pharmacy.mar.subtitle': 'Track and record medication administration',
  'pharmacy.mar.medication': 'Medication',
  'pharmacy.mar.dose': 'Dose',
  'pharmacy.mar.route': 'Route',
  'pharmacy.mar.frequency': 'Frequency',
  'pharmacy.mar.administrationTimes': 'Administration Times',
  'pharmacy.mar.actions': 'Actions',
  'pharmacy.mar.recordAdministration': 'Record Administration',
  'pharmacy.mar.viewDetails': 'View Details',
  'pharmacy.mar.noMedications': 'No medications scheduled',
  'pharmacy.mar.noMedicationsDescription': 'No medications are scheduled for this patient on the selected date',
  'pharmacy.mar.administrationStatus': 'Administration Status',
  'pharmacy.mar.given': 'Given',
  'pharmacy.mar.notGiven': 'Not Given',
  'pharmacy.mar.refused': 'Refused',
  'pharmacy.mar.held': 'Held',
  'pharmacy.mar.partial': 'Partial',
  'pharmacy.mar.reason': 'Reason',
  'pharmacy.mar.reasonPlaceholder': 'Enter reason for not administering...',
  'pharmacy.mar.injectionSite': 'Injection Site',
  'pharmacy.mar.sitePlaceholder': 'Enter injection site...',
  'pharmacy.mar.notes': 'Notes',
  'pharmacy.mar.notesPlaceholder': 'Additional notes...',
  'pharmacy.mar.witnessed': 'Witnessed administration',
  'pharmacy.mar.witnessName': 'Witness name',

  // Medication Inventory
  'pharmacy.inventory.title': 'Medication Inventory',
  'pharmacy.inventory.subtitle': 'Manage medication stock levels and inventory',
  'pharmacy.inventory.export': 'Export',
  'pharmacy.inventory.addItem': 'Add Item',
  'pharmacy.inventory.totalItems': 'Total Items',
  'pharmacy.inventory.totalValue': 'Total Value',
  'pharmacy.inventory.lowStock': 'Low Stock',
  'pharmacy.inventory.expiring': 'Expiring',
  'pharmacy.inventory.active': 'Active',
  'pharmacy.inventory.searchPlaceholder': 'Search medications, locations, bins...',
  'pharmacy.inventory.allStatuses': 'All Statuses',
  'pharmacy.inventory.allLocations': 'All Locations',
  'pharmacy.inventory.lowStockOnly': 'Low stock only',
  'pharmacy.inventory.expiringOnly': 'Expiring only',
  'pharmacy.inventory.inventoryList': 'Inventory List',
  'pharmacy.inventory.medication': 'Medication',
  'pharmacy.inventory.location': 'Location',
  'pharmacy.inventory.currentStock': 'Current Stock',
  'pharmacy.inventory.stockLevels': 'Stock Levels',
  'pharmacy.inventory.value': 'Value',
  'pharmacy.inventory.expiration': 'Expiration',
  'pharmacy.inventory.status': 'Status',
  'pharmacy.inventory.viewDetails': 'View Details',
  'pharmacy.inventory.recordMovement': 'Record Movement',
  'pharmacy.inventory.edit': 'Edit',
  'pharmacy.inventory.noItems': 'No inventory items',
  'pharmacy.inventory.noItemsDescription': 'No inventory items match your current filters',
  'pharmacy.inventory.movementType': 'Movement Type',
  'pharmacy.inventory.quantity': 'Quantity',
  'pharmacy.inventory.reason': 'Reason',
  'pharmacy.inventory.reasonPlaceholder': 'Enter reason for movement...',
  'pharmacy.inventory.notesPlaceholder': 'Additional notes...',
  'pharmacy.inventory.received': 'Received',
  'pharmacy.inventory.dispensed': 'Dispensed',
  'pharmacy.inventory.wasted': 'Wasted',
  'pharmacy.inventory.returned': 'Returned',
  'pharmacy.inventory.transferred': 'Transferred',
  'pharmacy.inventory.adjusted': 'Adjusted',
  'pharmacy.inventory.inactive': 'Inactive',
  'pharmacy.inventory.expired': 'Expired',
  'pharmacy.inventory.recalled': 'Recalled',

  // Pharmacy Status Labels
  'pharmacy.inventory.status.active': 'Active',
  'pharmacy.inventory.status.inactive': 'Inactive',
  'pharmacy.inventory.status.expired': 'Expired',
  'pharmacy.inventory.status.recalled': 'Recalled',

  // Admin (additional)
  'admin.auditLogs': 'Audit Logs',
  'admin.dashboard.title': 'Title',
  'admin.systemMonitoring': 'System Monitoring',
  'admin.systemSettings': 'System Settings',

  // Adt (additional)
  'adt.transfer.from': 'From',
  'adt.transfer.to': 'To',

  // Ai (additional)

  // Appointments (additional)

  // Auth (additional)

  // Common (additional)
  'common.address': 'Address',
  'common.email': 'Email',
  'common.filter.all': 'All',
  'common.phone': 'Phone',
  'common.retry': 'Retry',

  // Cpoe (additional)

  // Dashboard (additional)
  'dashboard.analyzeOverview': 'Analyze Overview',

  // Nav (additional)
  'nav.appointments': 'Appointments',
  'nav.medicalRecords': 'Medical Records',

  // Orders (additional)

  // Patient (additional)
  'patient.enterAddress': 'Enter Address',
  'patient.enterEmail': 'Enter Email',
  'patient.enterEmergencyContactName': 'Enter Emergency Contact Name',
  'patient.enterEmergencyContactPhone': 'Enter Emergency Contact Phone',
  'patient.enterFirstName': 'Enter First Name',
  'patient.enterInsuranceProvider': 'Enter Insurance Provider',
  'patient.enterLastName': 'Enter Last Name',
  'patient.enterPhone': 'Enter Phone',

  // Patients (additional)

  // Patient (additional)

  // Patients (additional)

  // Patient (additional)

  // Pharmacy (additional)
  'pharmacy.inventory.notes': 'Notes',

  // Records (additional)
  'records.vitals': 'Vitals',

  // RoleManagement (additional)

  // Scheduling (additional)
  'scheduling.contact': 'Contact',
  'scheduling.contact.email': 'Email',
  'scheduling.contact.phone': 'Phone',
  'scheduling.contactPreference': 'Contact Preference',
  'scheduling.contact.sms': 'Sms',
  'scheduling.department': 'Department',
  'scheduling.email': 'Email',
  'scheduling.patientName': 'Patient Name',
  'scheduling.phoneNumber': 'Phone Number',
  'scheduling.selectAppointmentType': 'Select Appointment Type',
  'scheduling.selectDepartment': 'Select Department',

  // UserManagement (additional)

  // Voice (additional)

  // Notifications
  'notifications.title': 'Notifications',
  'notifications.subtitle': 'Manage your notifications and alerts',
  'notifications.refresh': 'Refresh',
  'notifications.total': 'Total',
  'notifications.unread': 'Unread',
  'notifications.read': 'Read',
  'notifications.archived': 'Archived',
  'notifications.filter': 'Filter',
  'notifications.filtered': 'Filtered',
  'notifications.clearAll': 'Clear All',
  'notifications.status': 'Status',
  'notifications.priority': 'Priority',
  'notifications.all': 'All',
  'notifications.urgent': 'Urgent',
  'notifications.high': 'High',
  'notifications.normal': 'Normal',
  'notifications.low': 'Low',
  'notifications.markRead': 'Mark as read',
  'notifications.markUnread': 'Mark as unread',
  'notifications.markAllRead': 'Mark all read',
  'notifications.archive': 'Archive',
  'notifications.delete': 'Delete',
  'notifications.selected': 'selected',
  'notifications.empty': 'No notifications',
  'notifications.emptyDescription': 'You\'re all caught up!',
  'notifications.patient': 'Patient',
  'notifications.search': 'Search notifications...',
  'notifications.settings': 'Notification settings',
  'notifications.viewAll': 'View all notifications',
  'notifications.pagination.pageInfo': 'Page {{current}} of {{total}} ({{count}} total)',

  // Common (settings)
  'common.settings': 'Settings',

  // Pharmacy Dashboard (additional)
  'pharmacy.tabs.orders': 'Orders',
  'pharmacy.tabs.verification': 'Verification',
  'pharmacy.tabs.inventory': 'Inventory',
  'pharmacy.tabs.alerts': 'Alerts',
  'pharmacy.dashboard.pharmacistWorkload': 'Pharmacist Workload',
  'pharmacy.dashboard.assignedOrders': 'Assigned Orders',
  'pharmacy.dashboard.verifiedToday': 'Verified Today',
  'pharmacy.dashboard.avgVerificationTime': 'Avg Verification Time',
  'pharmacy.dashboard.allPriorities': 'All Priorities',
  'pharmacy.dashboard.allStatuses': 'All Statuses',
  'pharmacy.dashboard.stat': 'STAT',
  'pharmacy.dashboard.asap': 'ASAP',
  'pharmacy.dashboard.urgent': 'Urgent',
  'pharmacy.dashboard.routine': 'Routine',
  'pharmacy.dashboard.pending': 'Pending',
  'pharmacy.dashboard.verified': 'Verified',
  'pharmacy.dashboard.filled': 'Filled',
  'pharmacy.dashboard.dispensed': 'Dispensed',
  'pharmacy.dashboard.patient': 'Patient',
  'pharmacy.dashboard.medication': 'Medication',
  'pharmacy.dashboard.provider': 'Provider',
  'pharmacy.dashboard.priority': 'Priority',
  'pharmacy.dashboard.status': 'Status',
  'pharmacy.dashboard.orderTime': 'Order Time',
  'pharmacy.dashboard.actions': 'Actions',
  'pharmacy.dashboard.verify': 'Verify',
  'pharmacy.dashboard.dispense': 'Dispense',
  'pharmacy.dashboard.controlled': 'Controlled',
  'pharmacy.dashboard.interactions': 'Interactions',
  'pharmacy.dashboard.status.pending': 'Pending',
  'pharmacy.dashboard.status.verified': 'Verified',
  'pharmacy.dashboard.status.filled': 'Filled',
  'pharmacy.dashboard.status.dispensed': 'Dispensed',
  'pharmacy.dashboard.verificationQueue': 'Verification Queue',
  'pharmacy.dashboard.verificationContent': 'Orders requiring pharmacist verification will appear here',
  'pharmacy.dashboard.inventory': 'Medication Inventory',
  'pharmacy.dashboard.inventoryContent': 'Medication stock levels and inventory management',
  'pharmacy.dashboard.alerts': 'Pharmacy Alerts',
  'pharmacy.dashboard.alertsContent': 'Drug interactions, low stock, and other critical alerts',
  'pharmacy.dashboard.orderDetails': 'Medication Order Details',
  'pharmacy.dashboard.patientInformation': 'Patient Information',
  'pharmacy.dashboard.patientName': 'Patient Name',
  'pharmacy.dashboard.location': 'Location',
  'pharmacy.dashboard.medicationDetails': 'Medication Details',
  'pharmacy.dashboard.medicationName': 'Medication',
  'pharmacy.dashboard.strength': 'Strength',
  'pharmacy.dashboard.route': 'Route',
  'pharmacy.dashboard.frequency': 'Frequency',
  'pharmacy.dashboard.quantity': 'Quantity',
  'pharmacy.dashboard.refills': 'Refills',
  'pharmacy.dashboard.drugInteractions': 'Drug Interactions',
  'pharmacy.dashboard.verificationDetails': 'Verification Details',
  'pharmacy.dashboard.verifiedBy': 'Verified By',
  'pharmacy.dashboard.verifiedAt': 'Verified At',
  'pharmacy.dashboard.notes': 'Notes',

  // Medical Coding
  'coding.medicalCoding': 'Medical Coding',
  'coding.description': 'Assign ICD-10 and CPT codes to patient encounters',
  'coding.browse': 'Browse Codes',
  'coding.codingWorkspace': 'Coding Workspace',
  'coding.statistics': 'Statistics',
  'coding.selectPatientEncounter': 'Please select a patient and encounter',
  'coding.diagnosesSaved': 'Diagnoses saved successfully',
  'coding.selectEncounter': 'Select Encounter',
  'coding.searchPatient': 'Search patient...',
  'coding.noEncounters': 'No encounters found for this patient',
  'coding.draftDiagnoses': 'Draft Diagnoses',
  'coding.addDiagnosis': 'Add Diagnosis',
  'coding.noDraftDiagnoses': 'No diagnoses added yet. Browse codes to get started.',
  'coding.recentlyCoded': 'Recently Coded',
  'coding.noRecentCoding': 'No recent coding activity',

  // Diagnosis Types
  'coding.diagnosisType.primary': 'Primary',
  'coding.diagnosisType.secondary': 'Secondary',
  'coding.diagnosisType.comorbidity': 'Comorbidity',
  'coding.diagnosisType.complication': 'Complication',

  // ICD-10 Browser
  'coding.icd10.browser': 'ICD-10-CM Code Browser',
  'coding.icd10.catalogLabel': 'ICD-10-CM 2025',
  'coding.icd10.startSearching': 'Search ICD-10-CM codes',
  'coding.icd10.startSearchingHint':
    'Type a code or description to search the full code set.',
  'coding.icd10.browserDescription': 'Search and browse ICD-10-CM diagnosis codes',
  'coding.icd10.codes': 'codes',
  'coding.icd10.searchPlaceholder': 'Search by code, title, or description...',
  'coding.icd10.favorites': 'Favorites',
  'coding.icd10.recent': 'Recent',
  'coding.icd10.billableOnly': 'Billable Only',
  'coding.icd10.nonBillable': 'Non-billable',
  'coding.icd10.chapter': 'Chapter',
  'coding.icd10.selectChapter': 'Select Chapter',
  'coding.icd10.noResultsHint': 'Try adjusting your search or filters',

  // Coding Statistics
  'coding.stats.encountersCoded': 'Encounters Coded',
  'coding.stats.last30Days': 'Last 30 days',
  'coding.stats.averageTime': 'Avg Time/Encounter',
  'coding.stats.productivity': 'Productivity metric',
  'coding.stats.accuracy': 'Coding Accuracy',
  'coding.stats.qualityMetric': 'Quality metric',
  'coding.stats.queryRate': 'Query Rate',
  'coding.stats.queriesPerEncounter': 'Queries per encounter',
  'coding.stats.revenueImpact': 'Revenue Impact',
  'coding.stats.totalCharges': 'Total Charges Generated',
  'coding.stats.averageCharge': 'Average Charge/Encounter',

  // Coding Notice
  'coding.notice.title': 'Demo Statistics',
  'coding.notice.description': 'These statistics are calculated from your coding activity. In a production environment, these would reflect actual productivity and quality metrics.',

  // CPT
  'coding.cpt.browser': 'CPT Code Browser',
  'coding.cpt.searchPlaceholder': 'Search procedure codes...',

  // Billing & Revenue Management
  'billing.title': 'Billing & Revenue Management',
  'billing.subtitle': 'Manage bills, payments, and financial reports',
  'billing.newBill': 'New Bill',
  'billing.new': 'New',
  'billing.recordPayment': 'Record Payment',
  'billing.payment': 'Payment',

  // Tabs
  'billing.tabs.overview': 'Overview',
  'billing.tabs.bills': 'Bills',
  'billing.tabs.payments': 'Payments',
  'billing.tabs.claims': 'Insurance Claims',
  'billing.tabs.reports': 'Reports',
  'billing.tabs.saved': 'Service Catalog',

  // Overview Stats
  'billing.stats.totalRevenue': 'Total Revenue',
  'billing.stats.collectionRate': 'Collection Rate',
  'billing.stats.pendingAmount': 'Pending Amount',
  'billing.stats.overdueAmount': 'Overdue Amount',
  'billing.stats.pendingBills': 'pending bills',
  'billing.stats.overdueBills': 'overdue bills',
  'billing.stats.fromLastMonth': 'from last month',

  // Recent Activity
  'billing.recentBills': 'Recent Bills',
  'billing.topRevenueServices': 'Top Revenue Services',
  'billing.services': 'services',

  // Bills Tab
  'billing.searchPlaceholder': 'Search bills by patient name or bill ID...',
  'billing.allStatus': 'All Status',
  'billing.today': 'Today',
  'billing.thisWeek': 'This Week',
  'billing.thisMonth': 'This Month',
  'billing.thisQuarter': 'This Quarter',
  'billing.thisYear': 'This Year',

  // Bill Status
  'billing.status.paid': 'Paid',
  'billing.status.pending': 'Pending',
  'billing.status.partial': 'Partial',
  'billing.status.overdue': 'Overdue',
  'billing.status.cancelled': 'Cancelled',
  'billing.status.disputed': 'Disputed',

  // Table Headers
  'billing.table.billDetails': 'Bill Details',
  'billing.table.patient': 'Patient',
  'billing.table.amount': 'Amount',
  'billing.table.status': 'Status',
  'billing.table.dueDate': 'Due Date',
  'billing.table.actions': 'Actions',
  'billing.table.billId': 'Bill ID',
  'billing.table.totalAmount': 'Total Amount',
  'billing.table.paid': 'Paid',
  'billing.table.balance': 'Balance',

  // Bill Details
  'billing.billDetails': 'Bill Details',
  'billing.patientInformation': 'Patient Information',
  'billing.billInformation': 'Bill Information',
  'billing.totalAmount': 'Total Amount',
  'billing.paidAmount': 'Paid Amount',
  'billing.balance': 'Balance',
  'billing.serviceDetails': 'Service Details',
  'billing.service': 'Service',
  'billing.quantity': 'Quantity',
  'billing.unitPrice': 'Unit Price',
  'billing.total': 'Total',

  // Payments Tab
  'billing.paymentManagement': 'Payment Management',
  'billing.paymentManagementSubtitle': 'Process payments and view payment history',
  'billing.totalCollected': 'Total Collected',
  'billing.pendingCollection': 'Pending Collection',
  'billing.billsRequiringPayment': 'Bills Requiring Payment',
  'billing.allBillsPaid': 'All bills are fully paid!',

  // Claims Tab
  'billing.insuranceClaims': 'Insurance Claims',
  'billing.insuranceClaimsSubtitle': 'Insurance claim tracking and management will be displayed here.',

  // Reports Tab
  'billing.financialReports': 'Financial Reports',
  'billing.revenueAnalytics': 'Revenue analytics and billing reports',
  'billing.exportReport': 'Export Report',
  'billing.totalRevenue': 'Total Revenue',
  'billing.collected': 'Collected',
  'billing.outstanding': 'Outstanding',
  'billing.overdue': 'Overdue',
  'billing.invoices': 'invoices',
  'billing.collectionRate': 'collection rate',
  'billing.invoiceStatusBreakdown': 'Invoice Status Breakdown',
  'billing.revenueSummary': 'Revenue Summary',
  'billing.grossRevenue': 'Gross Revenue',
  'billing.paymentsReceived': 'Payments Received',
  'billing.accountsReceivable': 'Accounts Receivable',
  'billing.recentInvoices': 'Recent Invoices',
  'billing.invoice': 'Invoice',
  'billing.patient': 'Patient',
  'billing.date': 'Date',
  'billing.amount': 'Amount',

  // Actions
  'billing.viewDetails': 'View Details',
  'billing.editBill': 'Edit Bill',
  'billing.downloadPrint': 'Download/Print',

  // Loading & Empty States
  'billing.loadingBills': 'Loading bills...',
  'billing.noBillsFound': 'No bills found',
  'billing.tryAdjustingFilters': 'Try adjusting your filters to see more results',
  'billing.getStartedFirstBill': 'Get started by creating your first bill',
  'billing.createFirstBill': 'Create First Bill',
  'billing.noMatchingBills': 'No matching bills found',
  'billing.tryAdjustingSearch': 'Try adjusting your search',
  'billing.greatJobPayments': 'Great job keeping up with payments',

  // Pagination
  'billing.show': 'Show',
  'billing.entries': 'entries',
  'billing.showing': 'Showing',
  'billing.to': 'to',
  'billing.of': 'of',

  // Claims Tab
  'billing.insuranceClaimsManagement': 'Insurance Claims Management',
  'billing.trackInsuranceClaims': 'Track insurance claims, submissions, and reimbursements all in one place.',
  'billing.submitClaims': 'Submit Claims',
  'billing.trackStatus': 'Track Status',
  'billing.viewPayments': 'View Payments',
  'billing.comingSoon': 'Coming soon - This feature is under development',

  // Overview Stats (Additional)
  'billing.vsLastMonth': 'vs last month',
  'billing.toCollect': 'to collect',
  'billing.needAttention': 'need attention',
  'billing.noServiceData': 'No service data yet',
  'billing.serviceAnalytics': 'Service analytics will appear here',

  // Reports (Additional)
  'billing.exportAsCSV': 'Export as CSV',
  'billing.exportAsJSON': 'Export as JSON',
  'billing.exportAsPDF': 'Export as PDF',
  'billing.pendingBillsCount': 'pending bills',
  'billing.overdueBillsCount': 'overdue bills',

  // Reports & Analytics
  'reports.title': 'Reports & Analytics',
  'reports.subtitle': 'Comprehensive insights and data analytics',
  'reports.configure': 'Configure',
  'reports.config': 'Config',
  'reports.exportAll': 'Export All',
  'reports.export': 'Export',
  'reports.tabs.dashboard': 'Dashboard',
  'reports.tabs.financial': 'Financial',
  'reports.tabs.clinical': 'Clinical',
  'reports.tabs.operational': 'Operational',
  'reports.tabs.custom': 'Custom Reports',
  'reports.executiveDashboard': 'Executive Dashboard',
  'reports.today': 'Today',
  'reports.thisWeek': 'This Week',
  'reports.thisMonth': 'This Month',
  'reports.thisQuarter': 'This Quarter',
  'reports.thisYear': 'This Year',
  'reports.customRange': 'Custom Range',
  'reports.monthlyRevenue': 'Monthly Revenue',
  'reports.totalPatients': 'Total Patients',
  'reports.appointments': 'Appointments',
  'reports.collectionRate': 'Collection Rate',
  'reports.vsLastMonth': 'vs last month',
  'reports.revenueTrend': 'Revenue Trend',
  'reports.viewDetails': 'View Details',
  'reports.details': 'Details',
  'reports.revenueTrendChart': 'Revenue trend chart would be displayed here',
  'reports.patientDemographics': 'Patient Demographics',
  'reports.demographicsChart': 'Demographics pie chart would be displayed here',
  'reports.quickReports': 'Quick Reports',
  'reports.generate': 'Generate',
  'reports.gen': 'Gen',
  'reports.generating': 'Generating...',
  'reports.financialReports': 'Financial Reports',
  'reports.newReport': 'New Report',
  'reports.new': 'New',
  'reports.ready': 'ready',
  'reports.error': 'error',
  'reports.last': 'Last',
  'reports.daily': 'daily',
  'reports.weekly': 'weekly',
  'reports.monthly': 'monthly',
  'reports.quarterly': 'quarterly',
  'reports.yearly': 'yearly',
  'reports.onDemand': 'On Demand',
  'reports.viewReport': 'View Report',
  'reports.downloadReport': 'Download Report',
  'reports.clinicalReports': 'Clinical Reports',
  'reports.clinicalMetrics': 'Clinical quality metrics and patient outcome reports will be displayed here.',
  'reports.operationalReports': 'Operational Reports',
  'reports.operationalEfficiency': 'Operational efficiency and resource utilization reports will be displayed here.',
  'reports.customReports': 'Custom Reports',
  'reports.customReportBuilder': 'Custom report builder and saved reports will be displayed here.',
  'reports.reportConfiguration': 'Report Configuration',
  'reports.defaultSettings': 'Default Settings',
  'reports.defaultDateRange': 'Default Date Range',
  'reports.currentMonth': 'Current Month',
  'reports.currentQuarter': 'Current Quarter',
  'reports.currentYear': 'Current Year',
  'reports.autoRefreshInterval': 'Auto-refresh Interval',
  'reports.never': 'Never',
  'reports.everyHour': 'Every Hour',
  'reports.automatedReportScheduling': 'Automated Report Scheduling',
  'reports.currently': 'Currently',
  'reports.emailNotifications': 'Email Notifications',
  'reports.sendDailySummary': 'Send daily summary reports',
  'reports.alertOnChanges': 'Alert on significant changes in metrics',
  'reports.weeklyExecutiveDashboard': 'Weekly executive dashboard',
  'reports.cancel': 'Cancel',
  'reports.saveSettings': 'Save Settings',
  'reports.exportReports': 'Export Reports',
  'reports.selectReportsToExport': 'Select Reports to Export',
  'reports.selectAllReports': 'Select All Reports',
  'reports.exportFormat': 'Export Format',
  'reports.generatingReports': 'Generating reports... This may take a few moments.',
  'reports.readyToExport': 'Ready to export',
  'reports.report': 'report',
  'reports.reports': 'reports',
  'reports.totalRecords': 'Total Records',
  'reports.averageValue': 'Average Value',
  'reports.completionRate': 'Completion Rate',
  'reports.fromLastPeriod': 'from last period',
  'reports.trendAnalysis': 'Trend Analysis',
  'reports.interactiveChart': 'Interactive chart would be displayed here',
  'reports.downloadPDF': 'Download PDF',
  'reports.downloadExcel': 'Download Excel',
  'reports.close': 'Close',
  'reports.createNewReport': 'Create New Report',
  'reports.reportName': 'Report Name',
  'reports.enterReportName': 'Enter report name',
  'reports.category': 'Category',
  'reports.financial': 'Financial',
  'reports.clinical': 'Clinical',
  'reports.operational': 'Operational',
  'reports.quality': 'Quality',
  'reports.dataSource': 'Data Source',
  'reports.billingData': 'Billing Data',
  'reports.patientRecords': 'Patient Records',
  'reports.labOrders': 'Lab Orders',
  'reports.medications': 'Medications',
  'reports.generationFrequency': 'Generation Frequency',
  'reports.description': 'Description',
  'reports.enterDescription': 'Enter report description',
  'reports.createReport': 'Create Report',

  // Drugs Page
  'drugsPage.title': 'Drug Database',
  'drugsPage.subtitle': 'Search 100,000+ medications powered by RxNorm',
  'drugsPage.tabs.drugSearch': 'Drug Search',
  'drugsPage.tabs.interactionChecker': 'Interaction Checker',
  'drugsPage.tabs.about': 'About',
  'drugsPage.search.title': 'Search Medications',
  'drugsPage.search.placeholder': 'Search by drug name (e.g., metformin, ibuprofen, aspirin)...',
  'drugsPage.infoCards.drugs.title': '100,000+ Drugs',
  'drugsPage.infoCards.drugs.description': 'Search from a comprehensive database of medications including generic and brand name drugs.',
  'drugsPage.infoCards.alternatives.title': 'Alternatives',
  'drugsPage.infoCards.alternatives.description': 'Find alternative medications with the same active ingredients and formulations.',
  'drugsPage.infoCards.interactions.title': 'Interactions',
  'drugsPage.infoCards.interactions.description': 'Check for potential drug-drug interactions and safety alerts.',
  'drugsPage.about.mainTitle': 'About RxNorm Integration',
  'drugsPage.about.whatIsRxNorm.title': 'What is RxNorm?',
  'drugsPage.about.whatIsRxNorm.description': 'RxNorm is a standardized nomenclature for clinical drugs produced by the U.S. National Library of Medicine (NLM). It provides normalized names and unique identifiers for medications to enable interoperability between different healthcare systems.',
  'drugsPage.about.features.title': 'Features Available',
  'drugsPage.about.features.searchDrugs': 'Search over 100,000 medications by generic or brand name',
  'drugsPage.about.features.viewDetails': 'View detailed drug information including RxCUI codes',
  'drugsPage.about.features.findAlternatives': 'Find alternative medications with the same active ingredients',
  'drugsPage.about.features.checkInteractions': 'Check drug-drug interactions and potential safety issues',
  'drugsPage.about.features.extractIngredients': 'Extract active ingredients from medications',
  'drugsPage.about.features.lookupNDC': 'Look up medications by NDC (National Drug Code)',
  'drugsPage.about.dataSource.title': 'Data Source',
  'drugsPage.about.dataSource.description': 'All drug data is retrieved in real-time from the RxNorm API maintained by the U.S. National Library of Medicine. The data is free, publicly available, and regularly updated to ensure accuracy.',
  'drugsPage.about.termTypes.title': 'Term Types (TTY)',
  'drugsPage.about.termTypes.scd.label': 'SCD',
  'drugsPage.about.termTypes.scd.description': 'Semantic Clinical Drug (Generic)',
  'drugsPage.about.termTypes.sbd.label': 'SBD',
  'drugsPage.about.termTypes.sbd.description': 'Semantic Branded Drug (Brand Name)',
  'drugsPage.about.termTypes.in.label': 'IN',
  'drugsPage.about.termTypes.in.description': 'Ingredient (Active Component)',
  'drugsPage.about.termTypes.gpck.label': 'GPCK',
  'drugsPage.about.termTypes.gpck.description': 'Generic Pack',
  'drugsPage.about.termTypes.bpck.label': 'BPCK',
  'drugsPage.about.termTypes.bpck.description': 'Branded Pack',
  'drugsPage.about.disclaimer.title': 'Medical Disclaimer:',
  'drugsPage.about.disclaimer.text': 'This tool is for informational purposes only. Always consult with a qualified healthcare professional before making any medication decisions or changes to your treatment plan.',
  'drugsPage.about.resources.title': 'Resources',
  'drugsPage.about.resources.rxnav': 'RxNav - Official RxNorm Browser',
  'drugsPage.about.resources.api': 'RxNorm API Documentation',
  'drugsPage.about.resources.about': 'About RxNorm',

  // Feature Toggle Page
  'featureToggle.title': 'Feature Toggles Management',
  'featureToggle.subtitle': 'Enable or disable modules and features globally',
  'featureToggle.buttons.resetToDefaults': 'Reset to Defaults',
  'featureToggle.success.message': 'Feature settings updated successfully!',
  'featureToggle.stats.activeModules': 'Active Modules',
  'featureToggle.stats.totalFeatures': 'Total Features',
  'featureToggle.stats.lastUpdated': 'Last Updated',
  'featureToggle.search.title': 'Search & Filter',
  'featureToggle.search.placeholder': 'Search modules or features...',
  'featureToggle.buttons.expandAll': 'Expand All',
  'featureToggle.buttons.collapseAll': 'Collapse All',
  'featureToggle.info.title': 'About Feature Toggles',
  'featureToggle.emptyState.title': 'No modules or features match your search.',
  'featureToggle.emptyState.message': 'Try adjusting your search query or clear the filter.',
  'featureToggle.module.enabled': 'Enabled',
  'featureToggle.module.disabled': 'Disabled',
  'featureToggle.module.featuresCount': '{enabled} / {total} features enabled',
  'featureToggle.module.dependsOn': 'Depends on:',
  'featureToggle.module.requiredBy': 'Required by:',
  'featureToggle.module.missingDeps': 'Cannot enable - missing dependencies: {names}',
  'featureToggle.module.toggleOn': 'ON',
  'featureToggle.module.toggleOff': 'OFF',
  'featureToggle.feature.active': 'Active',
  'featureToggle.feature.inactive': 'Inactive',
  'featureToggle.feature.parentDisabled': 'This feature is enabled but the parent module is disabled',
  'featureToggle.feature.noFeatures': 'No configurable features for this module',
  'featureToggle.confirm.resetDefaults': 'Are you sure you want to reset all feature toggles to default settings? This action cannot be undone.',
  'featureToggle.confirm.disableWithDeps': 'Warning: The following modules depend on {moduleName}:\n\n{dependentNames}\n\nDisabling {moduleName} will also disable these modules. Do you want to continue?',
  'featureToggle.alert.cannotEnable': 'Cannot enable {moduleName}. The following required modules must be enabled first:\n\n{dependencyNames}',

  // Provider Schedule Manager
  'providerSchedule.title': 'Provider Schedules',
  'providerSchedule.subtitle': 'Manage working hours and availability',
  'providerSchedule.buttons.import': 'Import',
  'providerSchedule.buttons.export': 'Export',
  'providerSchedule.buttons.saveTemplate': 'Save Template',
  'providerSchedule.search.placeholder': 'Search providers...',
  'providerSchedule.viewMode.grid': 'Grid',
  'providerSchedule.viewMode.timeline': 'Timeline',
  'providerSchedule.bulkActions.selected': 'provider(s) selected',
  'providerSchedule.bulkActions.clearSelection': 'Clear Selection',
  'providerSchedule.noProviders.title': 'No providers found',
  'providerSchedule.noProviders.message': 'Try adjusting your search criteria',
  'providerSchedule.provider.weeklyHours': 'Weekly Hours',
  'providerSchedule.provider.role': 'Staff',
  'providerSchedule.dropdown.copyToSelected': 'Copy to Selected',
  'providerSchedule.dropdown.exportSchedule': 'Export Schedule',
  'providerSchedule.dropdown.edit': 'Edit',
  'providerSchedule.dropdown.duplicate': 'Duplicate',
  'providerSchedule.dropdown.delete': 'Delete',
  'providerSchedule.dropdown.addTimeBlock': 'Add Time Block',
  'providerSchedule.dropdown.copyTo': 'Copy to {day}',
  'providerSchedule.timeBlock.oneTime': 'One-time',
  'providerSchedule.days.monday': 'Mon',
  'providerSchedule.days.tuesday': 'Tue',
  'providerSchedule.days.wednesday': 'Wed',
  'providerSchedule.days.thursday': 'Thu',
  'providerSchedule.days.friday': 'Fri',
  'providerSchedule.days.saturday': 'Sat',
  'providerSchedule.days.sunday': 'Sun',
  'providerSchedule.toast.scheduleUpdated': 'Schedule updated successfully',
  'providerSchedule.toast.scheduleAdded': 'Schedule added successfully',
  'providerSchedule.toast.scheduleDeleted': 'Schedule deleted successfully',
  'providerSchedule.toast.scheduleCopied': 'Copied schedule to {day}',
  'providerSchedule.toast.weekCopied': 'Copied week schedule to {{count}} provider(s)',
  'providerSchedule.toast.saveFailed': 'Failed to save schedule',
  'providerSchedule.toast.deleteFailed': 'Failed to delete schedule',
  'providerSchedule.toast.copyFailed': 'Failed to copy schedule',
  'providerSchedule.confirm.delete': 'Are you sure you want to delete this time block?',
  'providerSchedule.dependencyError': 'Scheduling module is required for provider schedule management.',

  // Medical Records
  'medicalRecords.title': 'Medical Records',
  'medicalRecords.subtitle': 'View and manage patient medical records',
  'medicalRecords.clinicalInsights': 'Clinical Insights',
  'medicalRecords.newRecord': 'New Record',
  'medicalRecords.new': 'New',
  'medicalRecords.loading': 'Loading medical records...',
  'medicalRecords.noRecordsFound': 'No records found',
  'medicalRecords.adjustFilters': 'Try adjusting your search or filters',

  // Medical Records Search & Filters
  'medicalRecords.search.placeholder': 'Search records by diagnosis, treatment, or patient name...',
  'medicalRecords.filters.advanced': 'Advanced Filters',
  'medicalRecords.filters.active': 'active',
  'medicalRecords.filters.typeStatus': 'Filter by Type & Status',
  'medicalRecords.filters.recordType': 'Record Type',
  'medicalRecords.filters.status': 'Status',
  'medicalRecords.filters.patientId': 'Patient ID',
  'medicalRecords.filters.patientIdPlaceholder': 'Enter patient ID',
  'medicalRecords.filters.patientPlaceholder': 'Search by name or phone…',
  'medicalRecords.filters.dateRange': 'Filter by Date Range',
  'medicalRecords.filters.startDate': 'Start Date',
  'medicalRecords.filters.endDate': 'End Date',
  'medicalRecords.filters.activeLabel': 'Active',
  'medicalRecords.filters.activeFilters': 'Active Filters:',
  'medicalRecords.filters.clearAll': 'Clear All',
  'medicalRecords.filters.type': 'Type',
  'medicalRecords.filters.statusLabel': 'Status',
  'medicalRecords.filters.patient': 'Patient',
  'medicalRecords.filters.from': 'From',
  'medicalRecords.filters.to': 'To',

  // Record Types
  'medicalRecords.types.allTypes': 'All Types',
  'medicalRecords.types.progressNote': 'Progress Note',
  'medicalRecords.types.consultation': 'Consultation',
  'medicalRecords.types.admission': 'Admission',
  'medicalRecords.types.discharge': 'Discharge',
  'medicalRecords.types.procedureNote': 'Procedure Note',
  'medicalRecords.types.operativeNote': 'Operative Note',
  'medicalRecords.types.emergency': 'Emergency',
  'medicalRecords.types.followUp': 'Follow-up',

  // Record Statuses
  'medicalRecords.statuses.allStatuses': 'All Statuses',
  'medicalRecords.statuses.draft': 'Draft',
  'medicalRecords.statuses.signed': 'Signed',
  'medicalRecords.statuses.final': 'Final',

  // Medical Records Stats
  'medicalRecords.stats.overview': 'Medical Records Overview',
  'medicalRecords.stats.generateReport': 'Generate Clinical Report',
  'medicalRecords.stats.totalRecords': 'Total Records',
  'medicalRecords.stats.consultations': 'Consultations',
  'medicalRecords.stats.progressNotes': 'Progress Notes',
  'medicalRecords.stats.signedRecords': 'Signed Records',

  // Medical Record Card
  'medicalRecords.card.unknownPatient': 'Unknown Patient',
  'medicalRecords.card.noChiefComplaint': 'No chief complaint recorded',
  'medicalRecords.card.assessment': 'Assessment:',
  'medicalRecords.card.plan': 'Plan:',
  'medicalRecords.card.moreDiagnoses': 'more',
  'medicalRecords.card.status': 'Status:',
  'medicalRecords.card.signedBy': 'Signed by',

  // Drug Interaction Checker
  'drugs.interactionChecker.title': 'Drug Interaction Checker',
  'drugs.interactionChecker.subtitle': 'Check for interactions between multiple medications',
  'drugs.interactionChecker.addMedications': 'Add Medications',
  'drugs.interactionChecker.searchPlaceholder': 'Search and add medications to check...',
  'drugs.interactionChecker.selectedMedications': 'Selected Medications',
  'drugs.interactionChecker.addAtLeast2': 'Add at least 2 medications to check for interactions',
  'drugs.interactionChecker.checking': 'Checking for interactions...',
  'drugs.interactionChecker.interactionsFound': 'Interaction',
  'drugs.interactionChecker.interactionsFoundPlural': 'Interactions',
  'drugs.interactionChecker.found': 'Found',
  'drugs.interactionChecker.noInteractions': 'No interactions found',
  'drugs.interactionChecker.safeToUse': 'These medications appear to be safe to use together',
  'drugs.interactionChecker.note': 'Note:',
  'drugs.interactionChecker.disclaimer': 'This tool uses RxNorm drug interaction data from the U.S. National Library of Medicine. Always consult with a healthcare professional before making medication decisions.',

  // Lab Orders Additional
  'labOrders.filters': 'Filters:',
  'labOrders.labAnalytics': 'Lab Analytics',
  'labOrders.dashboard': 'Lab Orders Dashboard',
  'labOrders.generateLabReport': 'Generate Lab Report',
  'labOrders.loading': 'Loading lab orders...',

  // Clinic Lab Orders Page
  'clinicLabOrders.title': 'Lab Orders',
  'clinicLabOrders.subtitle': 'Manage and track laboratory orders across all patients',
  'clinicLabOrders.refresh': 'Refresh',
  'clinicLabOrders.newOrder': 'New Order',
  'clinicLabOrders.searchPlaceholder': 'Search by patient name, lab name, or notes...',
  'clinicLabOrders.allStatus': 'All Status',
  'clinicLabOrders.allPriority': 'All Priority',
  'clinicLabOrders.stats.pending': 'Pending',
  'clinicLabOrders.stats.inProgress': 'In Progress',
  'clinicLabOrders.stats.resulted': 'Resulted',
  'clinicLabOrders.stats.needsReview': 'Needs Review',
  'clinicLabOrders.loading': 'Loading lab orders...',
  'clinicLabOrders.noOrders': 'No lab orders found',
  'clinicLabOrders.noOrdersDesc': 'Lab orders will appear here once created from patient records',
  'clinicLabOrders.table.patient': 'Patient',
  'clinicLabOrders.table.tests': 'Tests',
  'clinicLabOrders.table.orderDate': 'Order Date',
  'clinicLabOrders.table.priority': 'Priority',
  'clinicLabOrders.table.status': 'Status',
  'clinicLabOrders.table.lab': 'Lab',
  'clinicLabOrders.table.actions': 'Actions',
  'clinicLabOrders.moreTests': 'more',
  'clinicLabOrders.needsReview': 'Needs Review',
  'clinicLabOrders.viewDetails': 'View details',
  'clinicLabOrders.editOrder': 'Edit order',

  // New/Edit Clinic Lab Order Pages
  'clinicLabOrders.new.title': 'New Lab Order',
  'clinicLabOrders.new.subtitle': 'Create a new laboratory order for a patient',
  'clinicLabOrders.edit.title': 'Edit Lab Order',
  'clinicLabOrders.edit.orderId': 'Order ID',
  'clinicLabOrders.loading.order': 'Loading lab order...',
  'clinicLabOrders.error.loadFailed': 'Failed to load lab order details',
  'clinicLabOrders.error.notFound': 'Lab order not found',
  'clinicLabOrders.error.backToOrders': 'Back to Lab Orders',
  'clinicLabOrders.edit.cannotEdit': 'Cannot Edit This Order',
  'clinicLabOrders.edit.cancelled': 'This lab order has been cancelled and cannot be edited.',
  'clinicLabOrders.edit.resulted': 'This lab order has already been resulted. Only administrators can edit resulted orders.',
  'clinicLabOrders.edit.backToDetails': 'Back to Order Details',
  'clinicLabOrders.edit.adminOverride': 'Admin Override',
  'clinicLabOrders.edit.adminWarning': 'You are editing a resulted lab order. Changes will be logged for audit purposes.',
  'clinicLabOrders.form.patient': 'Patient',
  'clinicLabOrders.form.selectPatient': 'Select Patient',
  'clinicLabOrders.form.searchPatient': 'Search patients by name...',
  'clinicLabOrders.form.searchingPatients': 'Searching patients...',
  'clinicLabOrders.form.noPatients': 'No patients found',
  'clinicLabOrders.form.patientLocked': 'Patient cannot be changed after order creation',
  'clinicLabOrders.form.selectTests': 'Select Tests',
  'clinicLabOrders.form.editTests': 'Edit Tests',
  'clinicLabOrders.form.addCustomTest': 'Add Custom Test',
  'clinicLabOrders.form.testName': 'Test name',
  'clinicLabOrders.form.testCode': 'Code (optional)',
  'clinicLabOrders.form.orderDetails': 'Order Details',
  'clinicLabOrders.form.priority': 'Priority',
  'clinicLabOrders.form.labName': 'Lab Name (Optional)',
  'clinicLabOrders.form.labNamePlaceholder': 'e.g., Quest Diagnostics',
  'clinicLabOrders.form.clinicalNotes': 'Clinical Notes / Reason for Order',
  'clinicLabOrders.form.clinicalNotesPlaceholder': 'Enter clinical notes or reason for ordering these tests...',
  'clinicLabOrders.summary.title': 'Order Summary',
  'clinicLabOrders.summary.selectedTests': 'Selected Tests',
  'clinicLabOrders.summary.noTests': 'No tests selected',
  'clinicLabOrders.error.selectPatient': 'Please select a patient',
  'clinicLabOrders.error.selectTests': 'Please add at least one test',
  'clinicLabOrders.error.createFailed': 'Failed to create lab order. Please try again.',
  'clinicLabOrders.error.updateFailed': 'Failed to update lab order. Please try again.',
  'clinicLabOrders.action.cancel': 'Cancel',
  'clinicLabOrders.action.creating': 'Creating...',
  'clinicLabOrders.action.createOrder': 'Create Order',
  'clinicLabOrders.action.saving': 'Saving...',
  'clinicLabOrders.action.saveChanges': 'Save Changes',

  // Clinic Lab Order Details Page
  'clinicLabOrders.details.title': 'Lab Order Details',
  'clinicLabOrders.details.backToOrders': 'Back to Orders',
  'clinicLabOrders.details.edit': 'Edit Order',
  'clinicLabOrders.details.cancel': 'Cancel Order',
  'clinicLabOrders.details.confirmCancel': 'Cancel Lab Order?',
  'clinicLabOrders.details.confirmCancelMessage': 'Are you sure you want to cancel this lab order? This action cannot be undone.',
  'clinicLabOrders.details.orderInfo': 'Order Information',
  'clinicLabOrders.details.orderDate': 'Order Date',
  'clinicLabOrders.details.orderedBy': 'Ordered By',
  'clinicLabOrders.details.patientInfo': 'Patient Information',
  'clinicLabOrders.details.viewPatient': 'View Patient',
  'clinicLabOrders.details.tests': 'Tests',
  'clinicLabOrders.details.testCount': 'tests',
  'clinicLabOrders.details.clinicalNotes': 'Clinical Notes',
  'clinicLabOrders.details.noClinicalNotes': 'No clinical notes provided',
  'clinicLabOrders.details.timeline': 'Order Timeline',
  'clinicLabOrders.details.statusUpdated': 'Status updated to',
  'clinicLabOrders.details.orderCreated': 'Order created',
  'clinicLabOrders.details.orderId': 'Order ID',
  'clinicLabOrders.details.labAnalysis': 'Lab Analysis',
  'clinicLabOrders.details.markReviewed': 'Mark Reviewed',
  'clinicLabOrders.details.needsReview': 'NEEDS REVIEW',
  'clinicLabOrders.details.reviewedStatus': 'REVIEWED',
  'clinicLabOrders.details.resultDate': 'Result Date',
  'clinicLabOrders.details.enterResults': 'Enter Results',
  'clinicLabOrders.details.relevantToConditions': 'Relevant to patient conditions',
  'clinicLabOrders.details.clinicalSignificance': 'Clinical Significance',
  'clinicLabOrders.details.reasonForOrder': 'Reason for Order',
  'clinicLabOrders.details.resultNotes': 'Result Notes',
  'clinicLabOrders.details.relevantConditions': 'Relevant Conditions',
  'clinicLabOrders.details.labsCorrelatedNote': 'Labs correlated with chronic conditions:',
  'clinicLabOrders.details.blueMarkerNote': 'Tests marked with a blue border are particularly relevant to these conditions.',
  'clinicLabOrders.details.provider': 'Provider',
  'clinicLabOrders.details.resultsReceived': 'Results Received',
  'clinicLabOrders.details.saveResults': 'Save Results',
  'clinicLabOrders.form.result': 'Result',
  'clinicLabOrders.form.resultPlaceholder': 'Enter result',
  'clinicLabOrders.form.unit': 'Unit',
  'clinicLabOrders.form.unitPlaceholder': 'e.g., mg/dL',
  'clinicLabOrders.form.resultNotesPlaceholder': 'Add any notes about the results...',
  'labOrders.abnormal': 'Abnormal',
  'labOrders.editResults': 'Edit Results',
  'labOrders.enterResults': 'Enter Results',

  // Voiceprint enrollment
  'voiceprint.title': 'My Voice',
  'voiceprint.enrolled': 'Enrolled',
  'voiceprint.notEnrolled': 'Not enrolled yet',
  'voiceprint.enrollCta': 'Record my voice',
  'voiceprint.unavailable':
    'Voice recognition is turned off for this clinic, so a recording cannot be enrolled right now. Your clinic administrator can change this.',
  'voiceprint.replaceCta': 'Re-record my voice',
  'voiceprint.captureLabel': 'Speak naturally for up to {{seconds}} seconds.',
  'voiceprint.promptHeading': 'Read these — or speak freely',
  'voiceprint.promptHint':
    'Reading varied sentences gives MAIE a richer voice sample. Anything you say works.',
  'voiceprint.prompt1':
    'Good morning, my name is Doctor [your last name]. How are you feeling today?',
  'voiceprint.prompt2':
    'Have you noticed any new symptoms since our last visit, or any side effects from your medication?',
  'voiceprint.prompt3':
    "Let's review your most recent results and adjust the plan if needed.",
  'voiceprint.recordingNow': 'Recording…',
  'voiceprint.processing': 'Processing audio…',
  'voiceprint.waitingForMic': 'Waiting for microphone permission…',
  'voiceprint.startRecording': 'Start recording',
  'voiceprint.stopRecording': 'Stop',
  'voiceprint.recordAgain': 'Record again',
  'voiceprint.capturedSeconds': 'Captured {{seconds}}s',
  'voiceprint.tooShort':
    'Recording is shorter than {{min}}s — please record a longer sample.',
  'voiceprint.consent':
    'I consent to MAIE storing a cryptographic fingerprint of my voice, encrypted per-tenant, for the sole purpose of identifying my turns in consultations. I can revoke this consent at any time.',
  'voiceprint.submitEnroll': 'Save voiceprint',
  'voiceprint.submitReplace': 'Replace voiceprint',
  'voiceprint.savedToast': 'Voiceprint saved',
  'voiceprint.savedToastDesc':
    'MAIE will now recognise your voice and label your turns in transcripts.',
  'voiceprint.replacedToast': 'Voiceprint replaced',
  'voiceprint.history': 'My voiceprints',
  'voiceprint.rowActive': 'active',
  'voiceprint.rowRetired': 'retired',
  'voiceprint.revoke': 'Revoke',
  'voiceprint.errors.enroll':
    'Could not save voiceprint. Please try again or contact support.',

  // First-login onboarding modal
  'voiceprint.onboarding.title': 'Let MAIE recognize your voice',
  'voiceprint.onboarding.description':
    "We'd like to record a 30-second sample of your voice so your turns in consultations can be labeled automatically. You can enroll now or later from Settings.",
  'voiceprint.onboarding.pointPrivacy':
    'Only a mathematical fingerprint is stored — never raw audio. Encrypted per-tenant.',
  'voiceprint.onboarding.pointAttribution':
    'Your lines appear labeled as "Doctor" in transcripts; patient and family lines stay separate.',
  'voiceprint.onboarding.pointRevoke':
    'You can revoke or replace your voiceprint any time from Settings → My Voice.',
  'voiceprint.onboarding.remindLater': 'Remind me later',
  'voiceprint.onboarding.enrollNow': 'Enroll now',

  // Team / membership management (clinic OWNER surface)
  'memberships.title': 'Team members',
  'memberships.subtitle': 'Manage who has access to your clinic and what they can do.',
  'memberships.inviteCta': 'Invite member',
  'memberships.notOwnerHeading': 'Team management',
  'memberships.notOwnerBody':
    'Only the clinic Owner can manage team members. Ask your Owner to invite or change roles.',
  'memberships.pendingHeading': 'Pending invitations ({{count}})',
  'memberships.activeHeading': 'Active members',
  'memberships.empty': 'No team members yet. Click "Invite member" above to add one.',
  'memberships.loading': 'Loading members…',
  'memberships.col.email': 'Email',
  'memberships.col.role': 'Role',
  'memberships.col.sent': 'Sent',
  'memberships.col.expires': 'Expires',
  'memberships.col.name': 'Name',
  'memberships.col.status': 'Status',
  'memberships.col.you': '(you)',
  'memberships.col.assists': 'Assists',
  'memberships.assists.unassigned': 'Unassigned',
  'memberships.assists.notApplicable': '—',
  'memberships.assists.noDoctors': 'No doctors yet — invite a Doctor first.',

  // Doctor home — assistants panel
  'home.myAssistants.title': 'My assistants',

  // Role-specific home pages (Receptionist / Nurse / Billing)
  'roleHome.greeting.morning': 'Good morning',
  'roleHome.greeting.afternoon': 'Good afternoon',
  'roleHome.greeting.evening': 'Good evening',
  'roleHome.assisting': 'Assisting Dr. {{name}}',
  'roleHome.unassigned': 'Not yet linked to a doctor',
  'roleHome.empty.appointments': 'No appointments scheduled for today.',

  'receptionistHome.title': 'Front desk',
  'receptionistHome.subtitle': 'Today’s patient flow at a glance.',
  'receptionistHome.queueTitle': "Today's queue",
  'receptionistHome.walkInsTitle': 'Walk-ins',
  'receptionistHome.quick.newAppointment': 'New appointment',
  'receptionistHome.quick.newPatient': 'Add patient',
  'receptionistHome.quick.viewSchedule': 'Open schedule',
  'receptionistHome.quick.messages': 'Messages',
  'receptionistHome.checkIn': 'Check in',
  'receptionistHome.markNoShow': 'No-show',

  'nurseHome.title': 'Nursing',
  'nurseHome.subtitle': 'Patient triage and prep.',
  'nurseHome.queueTitle': "Today's patients",
  'nurseHome.handoffTitle': 'Handoff to doctor',
  'nurseHome.handoffEmpty': 'No active handoffs.',
  'nurseHome.recordVitals': 'Record vitals',
  'nurseHome.viewChart': 'View chart',

  'billingHome.title': 'Billing',
  'billingHome.subtitle': 'Today’s revenue at a glance.',
  'billingHome.outstanding': 'Outstanding',
  'billingHome.paidToday': 'Paid today',
  'billingHome.invoicesTitle': 'Recent invoices',
  'billingHome.refundsTitle': 'Refund requests',
  'billingHome.refundsEmpty': 'No refund requests open.',
  'billingHome.openSubscription': 'Subscription & seats',
  'billingHome.openInvoices': 'All invoices',
  'memberships.action.revoke': 'Revoke',
  'memberships.action.remove': 'Remove',
  'memberships.action.resend': 'Resend',
  'memberships.action.sendAgain': 'Send again',
  'memberships.action.resendExpiredHint':
    'Issue a fresh invitation token and email it again. The expired link becomes unusable.',
  'memberships.action.resendPendingHint':
    'Send a new email with a fresh link. The previous link in the original email stops working.',
  'memberships.status.pending': 'Pending',
  'memberships.status.expired': 'Expired',
  'memberships.invitationExpiredHint':
    'This invitation has expired. Remove it and send a new one.',
  'memberships.confirmRevoke': "Revoke {{name}}'s access to this clinic?",
  'memberships.selfDemoteHint':
    'Promote another member to Owner before changing your own role',
  'memberships.seat.ai': 'AI seat',
  'memberships.seat.recordsOnly': 'Records-only',
  'memberships.seat.hint':
    'Records-only keeps every clinical privilege — notes, prescribing, signing — and removes AI features. Costs less per month.',
  'memberships.action.resetPin': 'Reset signing PIN',
  'memberships.action.suspend': 'Suspend',
  'memberships.action.reactivate': 'Reactivate',
  'memberships.resetPinHint':
    "Clears their signing PIN — they'll set a new one on their next sign.",
  'memberships.suspendHint':
    'Blocks login but keeps the seat and data. Reversible.',
  'memberships.reactivateHint': 'Restore login access for this member.',
  'memberships.confirmResetPin':
    "Reset {{name}}'s signing PIN? They'll set a new one on their next signature.",
  'memberships.confirmSuspend':
    "Suspend {{name}}? They won't be able to log in until reactivated.",
  'memberships.resetPinSuccess': "{{name}}'s signing PIN was reset.",
  'memberships.action.resetPassword': 'Reset password',
  'memberships.resetPwTitle': 'Reset {{name}}’s password',
  'memberships.resetPwEmailOption': 'Email a reset link',
  'memberships.resetPwEmailDesc':
    "Sends {{name}} a secure link to set their own password. You never see it.",
  'memberships.resetPwTempOption': 'Generate a temporary password',
  'memberships.resetPwTempDesc':
    "For members without working email. You'll get a one-time password to hand over; they must change it at next login.",
  'memberships.resetPwSending': 'Working…',
  'memberships.resetPwEmailSent':
    "Reset link sent to {{name}}. It expires in 1 hour.",
  'memberships.resetPwEmailNotDelivered':
    "Couldn't deliver the email (check the mail setup). Try a temporary password instead.",
  'memberships.resetPwTempReady':
    "Temporary password for {{name}} — copy it now, it won't be shown again:",
  'memberships.resetPwTempHint':
    'Share it securely. They must set a new password the next time they sign in.',
  'memberships.copy': 'Copy',
  'memberships.copied': 'Copied',
  'memberships.done': 'Done',
  'memberships.cancel': 'Cancel',

  // Invite modal
  'invite.modal.title': 'Invite a team member',
  'invite.modal.issuedTitle': 'Invitation issued',
  'invite.modal.helper': "They'll receive a one-time link to set up their account.",
  'invite.modal.emailLabel': 'Email',
  'invite.modal.emailPlaceholder': 'newdoctor@clinic.health',
  'invite.modal.roleLabel': 'Role',
  'invite.modal.roleDesc.Owner':
    'Full clinic management — invite, change roles, configure settings.',
  'invite.modal.roleDesc.Clinic Manager':
    'Operations & admin below Owner — staff, scheduling, billing; views clinical data, no role admin.',
  'invite.modal.roleDesc.Doctor': 'Clinical care, documentation, prescribing.',
  'invite.modal.roleDesc.Nurse':
    'Assists clinical workflow; limited record access.',
  'invite.modal.roleDesc.Receptionist':
    'Front desk, appointments, no clinical records.',
  'invite.modal.roleDesc.Billing':
    'Financial review, billing, no clinical records.',
  'invite.modal.seatLabel': 'Seat',
  'invite.modal.seat.ai': 'AI seat',
  'invite.modal.seat.recordsOnly': 'Records-only seat',
  'invite.modal.seatDesc.ai':
    'Voice scribe, Ask MAIE and document scanning, on top of full clinical access.',
  'invite.modal.seatDesc.recordsOnly':
    'Full clinical access — notes, prescribing and signing all work. No AI features. Costs less per month.',
  'invite.modal.cancel': 'Cancel',
  'invite.modal.send': 'Send invitation',
  'invite.modal.sending': 'Sending…',
  'invite.modal.delivered':
    'We emailed an invitation to {{email}}. The link expires {{expires}}.',
  'invite.modal.notDelivered':
    'Share this one-time link with {{email}} — email delivery is unavailable on this deployment. The link expires {{expires}}.',
  'invite.modal.warningDelivered':
    "You can also copy the link below if the email doesn't arrive — it's the same one. You won't see it again after closing this dialog.",
  'invite.modal.warningNotDelivered':
    "You won't see this link again after closing this dialog. Copy it now or revoke and re-issue if lost.",
  'invite.modal.copy': 'Copy',
  'invite.modal.copied': 'Copied',
  'invite.modal.done': 'Done',

  // Invite acceptance (public)
  'inviteAccept.eyebrow': 'INVITATION',
  'inviteAccept.heroLine1': "You've been invited",
  'inviteAccept.heroLine2': 'to join {{clinic}}',
  'inviteAccept.heroAs': 'as {{role}}',
  'inviteAccept.heroByline': 'Invited by {{inviter}}',
  'inviteAccept.expires': 'Link expires {{date}}',
  'inviteAccept.poweredBy': 'Clinic powered by MAIE',
  'inviteAccept.previewLoading': 'Checking your invitation…',
  'inviteAccept.errorTitle': 'This invitation can\'t be used',
  'inviteAccept.errorAskOwner':
    'Ask the clinic Owner to send you a fresh invite.',
  'inviteAccept.linkMissing': 'Invitation link is missing.',
  'inviteAccept.title': 'Accept your invitation',
  'inviteAccept.subtitle': 'Set up your account to join the clinic.',
  'inviteAccept.firstName': 'First name',
  'inviteAccept.firstNamePlaceholder': 'Jane',
  'inviteAccept.lastName': 'Last name',
  'inviteAccept.lastNamePlaceholder': 'Cooper',
  'inviteAccept.password': 'Password',
  'inviteAccept.passwordPlaceholder': 'Choose a strong password',
  'inviteAccept.confirmPassword': 'Confirm password',
  'inviteAccept.confirmPasswordPlaceholder': 'Repeat your password',
  'inviteAccept.passwordHint': 'At least 8 characters.',
  'inviteAccept.passwordsMismatch': 'Passwords do not match.',
  'inviteAccept.passwordTooShort': 'Password must be at least 8 characters.',
  'inviteAccept.submit': 'Accept invitation',
  'inviteAccept.submitting': 'Setting up…',
  'inviteAccept.successTitle': "You're all set",
  'inviteAccept.successRedirect': 'Signing you in…',
  'inviteAccept.attachedTitle': "You've been added",
  'inviteAccept.attachedBody':
    'We recognised your email — your existing MAIE account has been attached to this clinic. Signing you in now. (Your password for other clinics is unchanged; the one you just entered was discarded for safety.)',
  'inviteAccept.goToSignIn': 'Continue',

  // Tenant-visible role labels (used in pickers)
  'roles.Owner': 'Owner',
  'roles.Clinic Manager': 'Clinic Manager',
  'roles.Stock Manager': 'Stock Manager',
  'roles.Accountant': 'Accountant',
  'roles.Doctor': 'Doctor',
  'roles.Nurse': 'Nurse',
  'roles.Receptionist': 'Receptionist',
  'roles.Billing': 'Billing',

  // First-run welcome + demo consult
  'welcome.eyebrow': 'Welcome to MAIE',
  'welcome.title': "Let's see MAIE in action",
  'welcome.titleWithClinic': "Welcome, {{clinic}} is ready",
  'welcome.specialtyQuestion': "What's your specialty?",
  'welcome.specialtyHint':
    'This tailors the demo — and sharpens every AI note you make later.',
  'welcome.youllMeet': "You'll meet {{name}} — {{summary}}.",
  'welcome.tailoringWait': 'Preparing your patient…',
  'welcome.tailoring':
    'Tailoring a patient to your specialty — this preview will update in a moment.',
  'welcome.cta': 'Try a demo consult',
  'welcome.skip': 'Skip — take me to my clinic',
  'welcome.goToClinic': 'Go to my clinic',
  'welcome.ready': 'MAIE is ready',
  'welcome.wakingUp': 'MAIE is waking up…',
  'welcome.offline': "You're offline — the demo needs a connection.",
  'welcome.loading': 'Getting things ready…',
  'welcome.scribeUnavailable':
    'The voice scribe isn’t available right now, so the demo will have to wait — your clinic is ready to use either way.',
  'welcome.recordingStarted': 'Recording — describe the visit out loud.',
  'welcome.startFailed': "Couldn't start the demo. Please try again.",
  'welcome.micDeniedTitle': 'Microphone access blocked',
  'welcome.micDeniedBodyWeb':
    "MAIE can't hear you. Allow microphone access in your browser's site settings, then try again.",
  'welcome.micDeniedBodyNative':
    "MAIE can't hear you. Allow microphone access in system settings, then try again.",
  'welcome.openSettings': 'Open Settings',
  'welcome.tryAgain': 'Try again',

  // Demo patient banner
  'demoPatient.banner.title': 'This is your demo patient',
  'demoPatient.banner.body':
    'Nothing here is real. When you’re done exploring, you can remove the demo data in one click.',
  'demoPatient.banner.delete': 'Delete demo data',
  'demoPatient.banner.deleteConfirm': 'Yes, delete it',
  'demoPatient.banner.keepExploring': 'Keep exploring',
  'demoPatient.banner.deleted': 'Demo data removed.',
  'demoPatient.banner.deleteFailed': "Couldn't delete the demo data.",

  // Getting-started checklist (home)
  'setupChecklist.eyebrow': 'Getting started',
  'setupChecklist.title': 'Finish setting up ({{count}} left)',
  'setupChecklist.dismiss': 'Dismiss',
  'setupChecklist.item.tryDemo': 'Try a demo consult',
  'setupChecklist.item.addPatient': 'Add your first patient',
  'setupChecklist.item.inviteTeam': 'Invite your team',
  'setupChecklist.item.branding': 'Add your clinic logo',
  'setupChecklist.item.pin': 'Set your signing PIN',
  'setupChecklist.item.specialty': 'Pick your specialty (sharpens AI notes)',

  // Role welcome cards (invited team members)
  'roleWelcome.eyebrow': 'Welcome',
  'roleWelcome.gotIt': 'Got it',
  'roleWelcome.receptionist.title': "Welcome, {{name}} — here's your front desk",
  'roleWelcome.receptionist.body':
    'Everything for the day starts from this page. Try one of these:',
  'roleWelcome.receptionist.step.book': 'Book an appointment',
  'roleWelcome.receptionist.step.bookBody': 'Schedule a patient visit in a few taps.',
  'roleWelcome.receptionist.step.addPatient': 'Add a patient',
  'roleWelcome.receptionist.step.addPatientBody': 'Create a chart for a new patient.',
  'roleWelcome.receptionist.step.schedule': "See today's schedule",
  'roleWelcome.receptionist.step.scheduleBody': "The whole day's appointments in one view.",
  'roleWelcome.receptionist.step.messages': 'Answer messages',
  'roleWelcome.receptionist.step.messagesBody': 'Patient messages land in one inbox.',
  'roleWelcome.nurse.title': "Welcome, {{name}} — here's your station",
  'roleWelcome.nurse.body': 'Your day runs through these three places:',
  'roleWelcome.nurse.step.vitals': 'Record vitals',
  'roleWelcome.nurse.step.vitalsBody': "Pick a patient and log today's readings.",
  'roleWelcome.nurse.step.schedule': "See today's schedule",
  'roleWelcome.nurse.step.scheduleBody': "Who's coming in, and when.",
  'roleWelcome.nurse.step.protocols': 'Browse protocols',
  'roleWelcome.nurse.step.protocolsBody': 'Standing orders and care protocols.',
  'roleWelcome.billing.title': "Welcome, {{name}} — here's billing",
  'roleWelcome.billing.body': 'Invoices, payments, and reports all live here:',
  'roleWelcome.billing.step.invoice': 'Create an invoice',
  'roleWelcome.billing.step.invoiceBody': 'Bill a visit or service in a few taps.',
  'roleWelcome.billing.step.workspace': 'Open billing',
  'roleWelcome.billing.step.workspaceBody': 'Invoices and payments in one place.',
  'roleWelcome.billing.step.reports': 'See reports',
  'roleWelcome.billing.step.reportsBody': 'Revenue and outstanding balances.',
  'roleWelcome.doctor.title': "Welcome, {{name}} — you're all set",
  'roleWelcome.doctor.body': 'The fastest way in is to see MAIE write a note:',
  'roleWelcome.doctor.step.demo': 'Try a demo visit',
  'roleWelcome.doctor.step.demoBody': 'Talk through a pretend consult; MAIE writes the note.',
  'roleWelcome.doctor.step.addPatient': 'Add a patient',
  'roleWelcome.doctor.step.addPatientBody': 'Create a chart for a new patient.',
  'roleWelcome.doctor.step.notes': 'Review notes',
  'roleWelcome.doctor.step.notesBody': 'Drafts waiting for your signature live here.',

  // Domain management
  'domains.title': 'Domains',
  'domains.unsupported.title': 'Custom domains are not available',
  'domains.unsupported.body':
    'This deployment does not allow tenant-managed custom domains. Your clinic stays on its managed subdomain.',
  'domains.notOwner':
    'Only the clinic Owner can manage domains. Ask your Owner.',
  'domains.col.url': 'URL',
  'domains.col.tier': 'Tier',
  'domains.col.status': 'Status',
  'domains.col.cert': 'Cert',
  'domains.tier.subdomain': 'Managed subdomain',
  'domains.tier.custom_domain': 'Custom domain',
  'domains.tier.shared': 'Shared',
  'domains.status.active': 'Active',
  'domains.status.pending_verification': 'Pending verification',
  'domains.status.retired': 'Retired',
  'domains.cert.none': '—',
  'domains.cert.issued': 'Issued',
  'domains.cert.expiring_soon': 'Expiring soon',
  'domains.cert.expired': 'Expired',
  'domains.cert.failed': 'Failed',
  'domains.add': 'Add custom domain',
  'domains.add.placeholder': 'clinic.example.com',
  'domains.add.cancel': 'Cancel',
  'domains.add.submit': 'Add domain',
  'domains.add.submitting': 'Adding…',
  'domains.verify': 'Verify',
  'domains.verifying': 'Verifying…',
  'domains.retire': 'Remove',
  'domains.confirmRetire': 'Remove "{{domain}}" from this clinic?',
  'domains.dnsHeading': 'DNS records to add',
  'domains.dnsType': 'Type',
  'domains.dnsName': 'Name / Host',
  'domains.dnsValue': 'Value',
  'domains.dnsCopy': 'Copy',
  'domains.dnsCopied': 'Copied',
  'domains.dnsPropagation':
    'DNS changes can take a few minutes to propagate. If verification fails, wait a moment and try again.',

  // Specialty / Profile
  'profile.title': 'Profile',
  'profile.specialty.label': 'Specialty',
  'profile.specialty.placeholder': 'Select your specialty',
  'profile.subspecialty.label': 'Subspecialty (optional)',
  'profile.subspecialty.placeholder': 'e.g. Interventional cardiology',
  'profile.save': 'Save profile',
  'profile.saved': 'Profile updated',
  'profile.specialty.notSet': 'Not set',

  'specialty.onboarding.title': 'Pick your specialty',
  'specialty.onboarding.description':
    "We tailor transcription accuracy, the SOAP layout, and template suggestions to your specialty. You can change this any time in Settings.",
  'specialty.onboarding.skip': 'Skip for now',
  'specialty.onboarding.confirm': 'Save and continue',

  // Personal info card (settings)
  'settings.personalInfo.eyebrow': 'Account',
  'settings.personalInfo.title': 'Personal information',
  'settings.personalInfo.firstName': 'First name',
  'settings.personalInfo.lastName': 'Last name',
  'settings.personalInfo.email': 'Email',
  'settings.personalInfo.saveFailed': 'Could not save changes. Try again.',

  // Security / change password card
  'settings.security.eyebrow': 'Security',
  'settings.security.title': 'Password',
  'settings.security.currentPassword': 'Current password',
  'settings.security.newPassword': 'New password',
  'settings.security.confirmPassword': 'Confirm new password',
  'settings.security.tooShort': 'Password must be at least 8 characters.',
  'settings.security.mismatch': 'Passwords do not match.',
  'settings.security.changeWarning':
    'Changing your password signs you out on every other device.',
  'settings.security.passwordUpdated': 'Password updated',
  'settings.security.invalidCurrentPassword':
    'That current password is incorrect.',
  'settings.security.passwordUnchanged':
    'Pick a new password — it cannot match your current one.',
  'settings.security.updateFailed':
    'Could not update password. Try again.',
  'settings.security.updateButton': 'Update password',

  // SSO register fallback errors
  'auth.register.ssoEmailUnverified':
    "{{provider}} hasn't verified your email yet. Verify it with {{provider}} first, then try again.",
  'auth.register.ssoGenericError':
    'Sign-up via {{provider}} could not be completed. Please try again or use email and password.',
};